// ============================================
// İSTANBUL NİŞANTAŞI ÜNİVERSİTESİ HELP FORM
// Vanilla JavaScript Application
// ============================================

// ============================================
// SECTION 0: CSS LOADING CHECK & FALLBACK
// ============================================
// CSP-compliant CSS loading verification
(function() {
    'use strict';
    
    // Check if custom CSS loaded successfully
    function checkCSSLoaded() {
        const cssLink = document.getElementById('custom-css');
        if (!cssLink) return;
        
        // Check if stylesheet is loaded
        let cssLoaded = false;
        try {
            const sheets = document.styleSheets;
            for (let i = 0; i < sheets.length; i++) {
                try {
                    const rules = sheets[i].cssRules || sheets[i].rules;
                    if (rules && rules.length > 0) {
                        // Check if our custom CSS is loaded by looking for a unique selector
                        for (let j = 0; j < Math.min(rules.length, 10); j++) {
                            if (rules[j].selectorText && 
                                (rules[j].selectorText.includes('.form-card') || 
                                 rules[j].selectorText.includes('.header-actions'))) {
                                cssLoaded = true;
                                break;
                            }
                        }
                    }
                } catch (e) {
                    // Cross-origin stylesheet, skip
                }
                if (cssLoaded) break;
            }
        } catch (e) {
            // Fallback: check if link element exists and has href
            cssLoaded = cssLink.href && cssLink.href.length > 0;
        }
        
        // If CSS not loaded, try fallback
        if (!cssLoaded && cssLink.href) {
            const currentHref = cssLink.href;
            // If minified version failed, try regular version
            if (currentHref.includes('style.min.css')) {
                const fallbackHref = currentHref.replace('style.min.css', 'style.css');
                cssLink.href = fallbackHref;
            }
        }
    }
    
    // Run check after DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkCSSLoaded);
    } else {
        checkCSSLoaded();
    }
    
    // Also check after a short delay to catch late-loading CSS
    setTimeout(checkCSSLoaded, 500);
})();

// ============================================
// SECTION 1: TRANSLATIONS
// ============================================
// Dil Desteği - Translation Object
const translations = {
    tr: {
        // Header
        'header.title': 'Yardım Talebi Formu',
        'header.requestResults': 'Talep Sonuçlarım',
        'header.downloadHandbook': 'Öğrenci El Kitabı',
        
        // Form
        'form.title': 'Yardım Talebi Formu',
        'form.subtitle': 'Lütfen aşağıdaki bilgileri eksiksiz doldurunuz',
        'form.processFlow': 'Süreç Akış Takibi',
        
        // User Type
        'userType.title': 'Kullanıcı Tipi',
        'userType.student': 'Öğrenci',
        'userType.studentDesc': 'Sistem içinde kayıtlı öğrenci',
        'userType.other': 'Diğer',
        'userType.otherDesc': 'Sistem dışından başvuru',
        
        // Student Verification
        'studentVerification.title': 'Öğrenci Doğrulama',
        'studentVerification.studentNumber': 'Öğrenci Numarası',
        'studentVerification.sendCode': 'Kod Gönder',
        'studentVerification.sendCodeDesc': 'Öğrenci numaranızı girdikten sonra "Kod Gönder" butonuna basarak doğrulama kodunu talep edebilirsiniz.',
        
        // Contact Information
        'contactInfo.title': 'İletişim Bilgileri',
        'contactInfo.name': 'Ad Soyad',
        'contactInfo.phone': 'Telefon Numarası',
        'contactInfo.phoneFormat': 'Başında 0 olmadan 5XX XXX XX XX formatında yazınız.',
        'contactInfo.email': 'E-posta Adresi',
        
        // Student Information
        'studentInfo.title': 'Öğrenci Bilgileri',
        'studentInfo.name': 'Ad Soyad',
        'studentInfo.studentEmail': 'Öğrenci E-posta',
        'studentInfo.department': 'Bölüm',
        'studentInfo.class': 'Sınıf',
        'studentInfo.phone': 'Telefon',
        'studentInfo.phoneFormat': 'Lütfen telefon numaranızı başında 0 olmadan 5XX XXX XX XX formatında giriniz.',
        'studentInfo.personalEmail': 'Kişisel E-posta',
        
        // Reset Password
        'resetPassword.title': 'Obis Şifremi Sıfırla',
        'resetPassword.button': 'Obis Şifremi Sıfırla',
        
        // Request Details
        'requestDetails.title': 'Talep Detayları',
        'requestDetails.topic': 'Konu',
        'requestDetails.selectTopic': 'Konu seçiniz...',
        'requestDetails.request': 'İstek',
        'requestDetails.requestPlaceholder': 'Lütfen talebinizi detaylı bir şekilde açıklayınız...',
        'requestDetails.requestMinLength': 'En az 10 karakter olmalıdır.',
        
        // File Upload
        'fileUpload.title': 'Dosya Yükleme',
        'fileUpload.label': 'İsteğe Bağlı Dosya Yükleme',
        'fileUpload.acceptedTypes': '(jpg, jpeg, png, pdf)',
        'fileUpload.dragText': 'Dosyanızı buraya sürükleyin veya seçmek için tıklayın',
        'fileUpload.maxSize': 'Maksimum dosya boyutu: 10MB',
        
        // Consent
        'consent.text': 'Kişisel verilerin işlenmesi ve korunmasına yönelik aydınlatma metnini okudum, onaylıyorum.',
        
        // Submit
        'submit.button': 'Formu Gönder',
        'submit.sending': 'Gönderiliyor...',
        
        // IBAN Section
        'iban.title': 'IBAN Bilgileri',
        'iban.name': 'IBAN AD SOYAD',
        'iban.namePlaceholder': 'IBAN hesap sahibinin adı soyadı',
        'iban.number': 'IBAN',
        'iban.numberPlaceholder': 'TR00 0000 0000 0000 0000 0000 00',
        'iban.format': 'TR ile başlayan 26 karakterlik IBAN numarası giriniz.',
        
        // Horizontal Transfer
        'horizontalTransfer.title': 'Yatay Geçiş Dokümanları',
        'horizontalTransfer.type': 'Geçiş Türleri',
        'horizontalTransfer.typeLabel': 'Geçiş Türleri',
        'horizontalTransfer.selectType': 'Lütfen bir geçiş türü seçiniz.',
        'horizontalTransfer.selectTypeHelper': 'Lütfen bir geçiş türü seçiniz.',
        'horizontalTransfer.typeGANO': 'GANO',
        'horizontalTransfer.typeEKTALIMAT': 'EK TALİMAT',
        'horizontalTransfer.typeNOName': 'NOName',
        'horizontalTransfer.faculty': 'Fakülte',
        'horizontalTransfer.selectFaculty': 'Fakülte seçiniz...',
        'horizontalTransfer.program': 'Program',
        'horizontalTransfer.selectProgram': 'Önce fakülte seçiniz...',
        'horizontalTransfer.studentDocument': 'Öğrenci Belgesi',
        'horizontalTransfer.courseContent': 'Alınan Ders İçerik Bilgisi',
        'horizontalTransfer.transcript': 'Transkript',
        
        // Student Reason 1003 (Record deletion)
        'studentReason1003.title': 'Kayıt Sildirme Nedeni',
        'studentReason1003.subtitle': 'Kayıt sildirme için geçerli nedeni seçiniz. Gerekli durumlarda ek detay alanı açılacaktır.',
        'studentReason1003.options.financial': 'Mali Nedenler',
        'studentReason1003.options.personal': 'Kişisel Neden',
        'studentReason1003.options.military': 'Askerlik',
        'studentReason1003.options.horizontal': 'Yatay Geçiş',
        'studentReason1003.options.other': 'Diğer',
        'studentReason1003.descriptions.financial': 'Ödeme, burs veya finansal süreçlere bağlı durumlar.',
        'studentReason1003.descriptions.personal': 'Sağlık, aile veya kişisel planlamaya dair durumlar.',
        'studentReason1003.descriptions.military': 'Sevk, tecil veya askerlik süreçleri ile ilgili talepler.',
        'studentReason1003.descriptions.horizontal': 'Kabul edildiğiniz üniversite ve program bilgisini giriniz.',
        'studentReason1003.descriptions.other': 'Listede olmayan farklı bir neden belirtiniz.',
        'studentReason1003.horizontalLabel': 'Kabul Edildiğiniz Üniversite Adı',
        'studentReason1003.horizontalHelper': 'Kabul edildiğiniz üniversiteyi listeden seçiniz.',
        'studentReason1003.horizontalPlaceholder': 'Üniversite adı, fakülte/bölüm ve program bilgisi',
        'studentReason1003.otherLabel': 'Diğer Neden Detayı',
        'studentReason1003.otherHelper': 'En az 5 karakter olacak şekilde bilgi giriniz.',
        'studentReason1003.otherPlaceholder': 'Lütfen diğer nedeninizi detaylandırınız.',
        'studentReason1003.errors.reasonRequired': 'Lütfen bir neden seçiniz.',
        'studentReason1003.errors.horizontalRequired': 'Kabul edildiğiniz üniversite adı ve bölümü zorunludur.',
        'studentReason1003.errors.otherRequired': 'Lütfen en az 5 karakter olacak şekilde açıklama yazınız.',
        
        // Student Freeze 1004
        'studentFreeze.title': 'Kayıt Dondurma Nedenleri',
        'studentFreeze.subtitle': 'Lütfen kayıt dondurma talebinizin gerekçesini seçiniz ve gerekiyorsa detaylandırınız.',
        'studentFreeze.options.yurtdisi': 'Yurtdışı Eğitimi',
        'studentFreeze.options.saglik': 'Sağlık',
        'studentFreeze.options.askerlik': 'Askerlik',
        'studentFreeze.options.hazirlik': 'Hazırlık Prog. Erken Bitirme',
        'studentFreeze.options.other': 'Diğer',
        'studentFreeze.descriptions.yurtdisi': 'Yurt dışında eğitim veya değişim programına katılım.',
        'studentFreeze.descriptions.saglik': 'Sağlık raporu veya tedavi gerektiren durumlar.',
        'studentFreeze.descriptions.askerlik': 'Tecil, sevk veya zorunlu askerlik süreçleri.',
        'studentFreeze.descriptions.hazirlik': 'Hazırlık programını planlanandan önce tamamlama durumu.',
        'studentFreeze.descriptions.other': 'Listede olmayan farklı bir sebep belirtiniz.',
        'studentFreeze.otherLabel': 'Diğer Neden Detayı',
        'studentFreeze.otherHelper': 'En az 5 karakter olacak şekilde bilgi giriniz.',
        'studentFreeze.otherPlaceholder': 'Diğer nedeninizi detaylandırınız.',
        'studentFreeze.historyQuestion': 'Önceki yıllarda kayıt dondurma var mı?',
        'studentFreeze.historyYes': 'Evet',
        'studentFreeze.historyNo': 'Hayır',
        'studentFreeze.errors.reasonRequired': 'Lütfen kayıt dondurma nedenini seçiniz.',
        'studentFreeze.errors.otherRequired': 'Diğer nedeni en az 5 karakter olacak şekilde belirtiniz.',
        'studentFreeze.errors.historyRequired': 'Lütfen önceki yıllarda kayıt dondurma durumunu seçiniz.',
        'studentFreeze.periodTitle': 'Talep Dönemi ve Akademik Takvim',
        'studentFreeze.periodSubtitle': 'Kayıt dondurma sürenizi ve hangi akademik yıl/dönemden itibaren geçerli olacağını seçiniz. Bitiş bilgisi otomatik hesaplanacaktır.',
        'studentFreeze.requestPeriodLabel': 'Talep Dönemi',
        'studentFreeze.requestPeriodPlaceholder': 'Talep dönemini seçiniz...',
        'studentFreeze.requestPeriod.1': '1 Yarıyıl İzinli',
        'studentFreeze.requestPeriod.2': '2 Yarıyıl İzinli',
        'studentFreeze.requestPeriod.3': '3 Yarıyıl İzinli',
        'studentFreeze.requestPeriod.4': '4 Yarıyıl İzinli',
        'studentFreeze.startYearLabel': 'Başlama Yılı',
        'studentFreeze.startYearPlaceholder': 'Başlama yılını seçiniz...',
        'studentFreeze.startTermLabel': 'Başlama Dönemi',
        'studentFreeze.startTermPlaceholder': 'Başlama dönemini seçiniz...',
        'studentFreeze.term.fall': 'Güz',
        'studentFreeze.term.spring': 'Bahar',
        'studentFreeze.endInfoTitle': 'Oluşan Kayıt Dondurma Aralığı',
        'studentFreeze.endInfoPlaceholder': 'Talep dönemi, başlama yılı ve dönemi seçtiğinizde bitiş yılı ve dönemi burada otomatik görüntülenecektir.',
        'studentFreeze.endInfoComputed': 'Başlangıç: {startYear} {startTerm} • Bitiş: {endYear} {endTerm}',
        'studentFreeze.errors.periodRequired': 'Lütfen talep dönemi bilgisini seçiniz.',
        'studentFreeze.errors.startYearRequired': 'Lütfen başlama yılını seçiniz.',
        'studentFreeze.errors.startTermRequired': 'Lütfen başlama dönemini seçiniz.',

        // Student Exemption 1006
        'studentExemption1006.title': 'Muafiyet Başvurusu',
        'studentExemption1006.subtitle': 'Muaf olmak istediğiniz dersleri listelerken zorunlu ekleri yükleyiniz.',
        'studentExemption1006.tableTitle': 'Nişantaşı Üniversitesi\'nde Muaf Olmak İstediğiniz Dersler',
        'studentExemption1006.tableSubtitle': 'Ders kodu, adı, kredi, AKTS ve harf notu bilgilerini eksiksiz giriniz.',
        'studentExemption1006.tableHelper': 'En az bir ders satırı doldurulmalıdır.',
        'studentExemption1006.addRow': 'Satır Ekle',
        'studentExemption1006.columns.code': 'Ders Kodu / Course Code',
        'studentExemption1006.columns.name': 'Ders Adı / Course Name',
        'studentExemption1006.columns.credit': 'Kredi / Credit',
        'studentExemption1006.columns.ects': 'AKTS / ECTS',
        'studentExemption1006.columns.grade': 'Harf Notu / Letter Grade',
        'studentExemption1006.docs.helper': 'Sürükle veya Tıkla',
        'studentExemption1006.docs.appendix1.label': 'EK-1 / Transkript',
        'studentExemption1006.docs.appendix1.title': 'Transkript / Transcript',
        'studentExemption1006.docs.appendix2.label': 'EK-2 / Ders İçerikleri',
        'studentExemption1006.docs.appendix2.title': 'Ders İçerikleri / Course Contents',
        'studentExemption1006.docs.appendix3.label': 'EK-3 / Muaf Ders Tablosu',
        'studentExemption1006.docs.appendix3.title': 'Muaf Ders Tablosu / Exemption Table',
        'studentExemption1006.errors.tableRequired': 'Lütfen en az bir ders satırı ekleyiniz.',
        'studentExemption1006.errors.rowRequired': 'Tüm sütunları doldurunuz.',
        'studentExemption1006.errors.documentRequired': 'Bu belge zorunludur.',
        'studentExemption1006.errors.maxRows': 'En fazla 8 satır ekleyebilirsiniz.',

        // Student Three Course 1007
        'studentThreeCourse1007.title': 'Üç Ders Başvurusu',
        'studentThreeCourse1007.subtitle': 'Üç ders sınavına gireceğiniz ders bilgilerini giriniz.',
        'studentThreeCourse1007.tableTitle': 'Üç Ders Sınavına Gireceği Dersin Bilgileri',
        'studentThreeCourse1007.tableSubtitle': 'Her satır için ders kodu, adı, kredi, AKTS ve not bilgisini doldurunuz.',
        'studentThreeCourse1007.columns.no': 'Sayı / No.',
        'studentThreeCourse1007.columns.code': 'Ders Kodu / Course Code',
        'studentThreeCourse1007.columns.name': 'Ders Adı / Course Name',
        'studentThreeCourse1007.columns.credit': 'Ders Kredisi / Credit',
        'studentThreeCourse1007.columns.ects': 'Ders AKTS\'si / ECTS',
        'studentThreeCourse1007.columns.grade': 'Ders Notu / Grade',
        'studentThreeCourse1007.errors.rowRequired': 'Tüm satırlarda eksiksiz bilgi girmelisiniz.',
        'studentThreeCourse1007.docs.transcript.label': 'Not Durum Belgesi (Transkript)',
        'studentThreeCourse1007.docs.transcript.title': 'Transkript yükleyiniz',
        'studentThreeCourse1007.docs.helper': 'PDF, JPG, JPEG veya PNG yükleyebilirsiniz',
        'studentThreeCourse1007.errors.documentRequired': 'Lütfen transkript belgesini yükleyiniz.',
        
        // Exam Excuse
        'examExcuse.title': 'Sınav Mazeret Bilgileri',
        'examExcuse.courseCount': 'Ders Sayısı',
        'examExcuse.academicYear': 'Öğretim Yılı',
        'examExcuse.term': 'Dönem',
        'examExcuse.courseCode': 'Ders Kodu',
        'examExcuse.courseName': 'Ders Adı',
        'examExcuse.exam': 'Sınav',
        'examExcuse.examScore': 'Sınav Notu',
        'examExcuse.selection': 'Seçim',
        'examExcuse.emptyState': 'Bu döneme ait ders bulunamadı.',
        'examExcuse.helper': 'Lütfen mazeret sınavı talep etmek istediğiniz dersi ve sınav türünü seçiniz.',
        'examExcuse.errors.examTypeRequired': 'Lütfen sınav türünü seçiniz.',
        'examExcuse.errors.courseRequired': 'Lütfen mazeret sınavı talep etmek istediğiniz dersi seçiniz.',
        'examExcuse.errors.appealCheck': 'Lütfen itiraz etmek istediğiniz sınavı ve ilgili notu kontrol ediniz.',
        
        // Modals
        'modal.requestResults.title': 'Talep Sonuçlarım',
        'modal.requestResults.search': 'Ara',
        'modal.requestResults.securityNote': 'Güvenlik için e-posta doğrulaması gereklidir',
        'modal.success.title': 'Başarılı',
        'modal.success.message': 'İşlem başarıyla tamamlandı.',
        'modal.success.requestNumber': 'Talep numaranız:',
        'modal.success.trackInfo': 'Talebinizin durumunu "Talep Sonuçlarım" bölümünden takip edebilirsiniz.',
        'modal.success.ok': 'Tamam',
        'modal.error.title': 'Hata',
        'modal.error.message': 'Lütfen tekrar deneyiniz.',
        'modal.error.ok': 'Tamam',
        
        // Verification Modal
        'verification.title': 'Doğrulama Kodunu Girin',
        'verification.description': 'Öğrenci e-posta adresinize gönderilen 6 haneli kodu aşağıdaki kutulara giriniz.',
        'verification.verify': 'Doğrula',
        'verification.resend': 'Kodu Tekrar Gönder',
        'verification.validFor': 'Kod 10 dakika geçerlidir.',
        
        // Email Verification Modal
        'emailVerification.title': 'E-posta Doğrulama',
        'emailVerification.security': 'Güvenlik Doğrulaması',
        'emailVerification.description': 'Öğrenci e-posta adresinize doğrulama kodu gönderildi. Lütfen mailinize gelen 6 haneli kodu giriniz.',
        
        // Request Detail Modal
        'requestDetail.title': 'Talep Detayı',
        'requestDetail.subject': 'Konu Başlığı',
        'requestDetail.startDate': 'Açılış Tarihi',
        'requestDetail.closeDate': 'Kapanış Tarihi',
        'requestDetail.studentRequest': 'Öğrenci Talebi',
        'requestDetail.response': 'Yanıt / Güncelleme',
        
        // Privacy Modal
        'privacy.title': 'Kişisel Verilerin İşlenmesi ve Korunmasına Yönelik Aydınlatma Metni',
        'privacy.understand': 'Anladım',
        
        // Errors
        'error.invalidFileType': 'Geçersiz dosya türü. Sadece JPG, PNG ve PDF dosyaları kabul edilir.',
        'error.fileTooLarge': 'Dosya boyutu çok büyük (maksimum 10MB)',
        'error.invalidStudentNumber': 'Geçersiz öğrenci numarası',
        'error.invalidEmail': 'Geçersiz e-posta adresi',
        'error.invalidPhone': 'Telefon 5XX XXX XX XX formatında olmalıdır.',
        'error.requestMinLength': 'İstek alanı en az 10 karakter olmalıdır.',
        'error.consentRequired': 'Kişisel verilerin işlenmesi onayını vermelisiniz.',
        'error.topicRequired': 'Lütfen bir konu seçiniz.',
        'error.maxActiveRequests': 'Aktif 3 talebiniz bulunmaktadır.\\n\\nTalepleriniz sonuçlandığında tekrar başvuru hakkınız açılacaktır.',
        
        // Success Messages
        'success.requestSubmitted': 'Talebiniz başarıyla gönderildi!',
        'success.requestNumber': 'Talep Numaranız:',
        'success.trackInfo': 'Talebinizin durumunu "Talep Sonuçlarım" bölümünden takip edebilirsiniz.',
        
        // Request Detail Modal
        'requestDetail.loading': 'Yükleniyor...',
        'requestDetail.loadingDetails': 'Talep detayları yükleniyor, lütfen bekleyiniz...',
        'requestDetail.noStatus': 'Durum Bilgisi Yok',
        
        // Student Double Minor 1008
        'studentDoubleMinor1008.title': 'Çift Anadal/Yandal Ders Bilgileri',
        'studentDoubleMinor1008.subtitle': 'Çift anadal veya yandal programındaki ders bilgilerinizi giriniz.',
        'studentDoubleMinor1008.programTypeTitle': 'Program Tipi',
        'studentDoubleMinor1008.doubleMajor': 'Çift Anadal',
        'studentDoubleMinor1008.minor': 'Yandal',
        'studentDoubleMinor1008.tableTitle': 'Çift Anadal/Yandal Ders Bilgileri',
        'studentDoubleMinor1008.tableSubtitle': 'Ders kodu, adı, kredi, AKTS ve harf notu bilgilerini eksiksiz giriniz.',
        'studentDoubleMinor1008.tableHelper': 'En az bir ders satırı doldurulmalıdır.',
        'studentDoubleMinor1008.addRow': 'Satır Ekle',
        'studentDoubleMinor1008.columns.code': 'Ders Kodu / Course Code',
        'studentDoubleMinor1008.columns.name': 'Ders Adı / Course Name',
        'studentDoubleMinor1008.columns.credit': 'Kredi / Credit',
        'studentDoubleMinor1008.columns.ects': 'AKTS / ECTS',
        'studentDoubleMinor1008.columns.grade': 'Harf Notu / Letter Grade',
        'studentDoubleMinor1008.errors.programTypeRequired': 'Lütfen program tipini seçiniz (Çift Anadal veya Yandal).',
        'studentDoubleMinor1008.errors.tableRequired': 'Lütfen en az bir ders satırı ekleyiniz.',
        'studentDoubleMinor1008.errors.rowRequired': 'Tüm sütunları doldurunuz.',
        'studentDoubleMinor1008.errors.maxRows': 'En fazla 8 satır ekleyebilirsiniz.',
        'studentDoubleMinor1008.doubleMajorSubtitle': 'Double Major',
        'studentDoubleMinor1008.minorSubtitle': 'Minor',
        'studentDoubleMinor1008.actions': 'İşlemler',
        
        // Student Reason 1003 - Additional
        'studentReason1003.horizontalSelect': 'Üniversite seçiniz...',
        
        // Student Three Course 1007 - Placeholders
        'studentThreeCourse1007.placeholders.code': 'CS101',
        'studentThreeCourse1007.placeholders.name': 'Course Name',
        'studentThreeCourse1007.placeholders.credit': '3',
        'studentThreeCourse1007.placeholders.ects': '5',
        'studentThreeCourse1007.placeholders.grade': 'AA',
        
        // Topic Search
        'topicSearch.placeholder': 'Konu arayınız',
        'topicSearch.noResults': 'Aradığınız konu bulunamadı.',
        
        // Validation Messages
        'validation.userTypeRequired': 'Lütfen kullanıcı tipini seçiniz.',
        'validation.topicRequired': 'Lütfen bir konu seçiniz.',
        'validation.ibanNameRequired': 'IBAN hesap sahibinin adı soyadı zorunludur.',
        'validation.ibanInvalid': 'Geçerli bir Türkiye IBAN numarası giriniz. (TR ile başlayan 26 karakter)',
        'validation.emailVerificationRequired': 'Lütfen email doğrulamasını tamamlayınız.',
        'validation.missingFields': 'Lütfen aşağıdaki alanları doldurunuz:',
        'validation.missingFieldsTitle': 'Eksik Bilgiler',
        'validation.programTypeRequired': 'Lütfen program tipini seçiniz (Çift Anadal veya Yandal).',
        'validation.doubleMinorIncomplete': 'Lütfen çift anadal/yandal ders bilgilerini eksiksiz doldurunuz.',
        'validation.exemptionIncomplete': 'Lütfen muafiyet ders bilgilerini eksiksiz doldurunuz.',
        'validation.transferIncomplete': 'Lütfen yatay geçiş bilgilerini eksiksiz doldurunuz.',
        
        // Error Messages
        'error.generic': 'Hata oluştu. Lütfen tekrar deneyiniz.',
        'error.studentNotFound': 'Öğrenci bulunamadı. Lütfen geçerli bir öğrenci numarası giriniz.',
        'error.studentInfoLoadFailed': 'Öğrenci bilgileri yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.',
        'error.verificationCodeSendFailed': 'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyiniz.',
        'error.verificationCodeSendError': 'Doğrulama kodu gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.',
        'error.formSubmitFailed': 'Form gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.',
        'error.passwordResetFailed': 'Şifre sıfırlama işlemi başarısız oldu. Lütfen daha sonra tekrar deneyiniz.',
        'error.passwordResetSuccess': 'Şifre sıfırlama işlemi başarıyla gerçekleştirildi.',
        'error.redirecting': 'İlgili sayfaya yönlendiriliyorsunuz, lütfen bekleyiniz...',
        'error.studentNumberNotFound': 'Öğrenci numarası bulunamadı. Lütfen tekrar deneyiniz.',
        
        // Warning Messages
        'warning.studentOnly': 'Bu işlem yalnızca öğrenci doğrulaması sonrası yapılabilir.',
        'warning.verificationRequired': 'Şifre sıfırlamak için önce öğrenci doğrulamasını tamamlayınız.',
        'warning.studentInfoRequired': 'Öğrenci bilgileri doğrulanamadı. Lütfen önce doğrulama adımını tamamlayınız.',
        'warning.examExcuseVerificationRequired': 'Mazeret sınavı talebi için önce öğrenci doğrulamasını tamamlayınız.',
        
        // Info Messages
        'info.passwordResetStarted': 'OBIS giriş şifreniz doğrulanmış öğrenci kimliğiniz kullanılarak güvenli şekilde sıfırlanacaktır. Lütfen işlemin tamamlanmasını bekleyiniz.',
        'info.passwordResetStartedTitle': 'Şifre Sıfırlama Başlatıldı',
        'info.verificationCodeSending': 'Öğrenci e-posta adresinize doğrulama kodu gönderiliyor.',
        'info.verificationCodeSent': 'Öğrenci e-posta adresinize 6 haneli doğrulama kodu gönderildi. Lütfen kodu giriniz.',
        'info.verificationCodeCanSend': 'Öğrenci e-posta adresinize doğrulama kodu göndermek için "Kod Gönder" butonunu kullanabilirsiniz.',
        
        // Loading Messages
        'loading.sendingCode': 'Kod Gönderiliyor',
        'loading.submittingForm': 'Gönderiliyor...',
        'loading.submitButton': 'Formu Gönder',
        'loading.obisData': 'OBİS ders ve sınav bilgileriniz alınmaktadır. Bu işlem yaklaşık 2 dakika kadar sürebilir. Lütfen bekleyiniz...',
        'loading.examData': 'Lütfen mazeret sınavı talep etmek istediğiniz dersi ve sınav türünü seçiniz.',
        
        // Success Messages
        'success.title': 'Başarılı!',
        
        // Error Titles
        'error.title': 'Hata',
        'warning.title': 'Uyarı',
    },
    en: {
        // Header
        'header.title': 'Help Request Form',
        'header.requestResults': 'Request Results',
        'header.downloadHandbook': 'Student Handbook',
        
        // Form
        'form.title': 'Help Request Form',
        'form.subtitle': 'Please fill in the information below completely',
        'form.processFlow': 'Process Flow Tracking',
        
        // User Type
        'userType.title': 'User Type',
        'userType.student': 'Student',
        'userType.studentDesc': 'Registered student in the system',
        'userType.other': 'Other',
        'userType.otherDesc': 'External application',
        
        // Student Verification
        'studentVerification.title': 'Student Verification',
        'studentVerification.studentNumber': 'Student Number',
        'studentVerification.sendCode': 'Send Code',
        'studentVerification.sendCodeDesc': 'After entering your student number, you can request the verification code by pressing the "Send Code" button.',
        
        // Contact Information
        'contactInfo.title': 'Contact Information',
        'contactInfo.name': 'Name Surname',
        'contactInfo.phone': 'Phone Number',
        'contactInfo.phoneFormat': 'Please write in 5XX XXX XX XX format without leading zero.',
        'contactInfo.email': 'Email Address',
        
        // Student Information
        'studentInfo.title': 'Student Information',
        'studentInfo.name': 'Name Surname',
        'studentInfo.studentEmail': 'Student Email',
        'studentInfo.department': 'Department',
        'studentInfo.class': 'Class',
        'studentInfo.phone': 'Phone Number',
        'studentInfo.phoneFormat': 'Please enter your phone number in 5XX XXX XX XX format without leading zero.',
        'studentInfo.personalEmail': 'Personal E-mail',
        
        // Reset Password
        'resetPassword.title': 'Reset My Password',
        'resetPassword.button': 'Reset My Password',
        
        // Request Details
        'requestDetails.title': 'Request Details',
        'requestDetails.topic': 'Topic',
        'requestDetails.selectTopic': 'Select topic...',
        'requestDetails.request': 'Request',
        'requestDetails.requestPlaceholder': 'Please explain your request in detail...',
        'requestDetails.requestMinLength': 'Must be at least 10 characters.',
        
        // File Upload
        'fileUpload.title': 'File Upload',
        'fileUpload.label': 'Additional Documents',
        'fileUpload.acceptedTypes': '(jpg, jpeg, png, pdf)',
        'fileUpload.dragText': 'Drag your file here or click to select',
        'fileUpload.maxSize': 'Maximum file size: 10MB',
        
        // Consent
        'consent.text': 'I have read and understand the clarification text for the processing and protection of personal data.',
        
        // Submit
        'submit.button': 'Submit Form',
        'submit.sending': 'Sending...',
        
        // IBAN Section
        'iban.title': 'IBAN Information',
        'iban.name': 'IBAN NAME SURNAME',
        'iban.namePlaceholder': 'Name and surname of the IBAN account holder',
        'iban.number': 'IBAN',
        'iban.numberPlaceholder': 'TR00 0000 0000 0000 0000 0000 00',
        'iban.format': 'Please enter a 26-character IBAN number starting with TR.',
        
        // Horizontal Transfer
        'horizontalTransfer.title': 'Horizontal Transfer Documents',
        'horizontalTransfer.type': 'Transfer Types',
        'horizontalTransfer.typeLabel': 'Transfer Types',
        'horizontalTransfer.selectType': 'Please select a transfer type.',
        'horizontalTransfer.selectTypeHelper': 'Please select a transfer type.',
        'horizontalTransfer.typeGANO': 'GANO',
        'horizontalTransfer.typeEKTALIMAT': 'EK TALİMAT',
        'horizontalTransfer.typeNOName': 'NOName',
        'horizontalTransfer.faculty': 'Faculty',
        'horizontalTransfer.selectFaculty': 'Select faculty...',
        'horizontalTransfer.program': 'Program',
        'horizontalTransfer.selectProgram': 'Please select faculty first...',
        'horizontalTransfer.studentDocument': 'Student Document',
        'horizontalTransfer.courseContent': 'Course Content Information',
        'horizontalTransfer.transcript': 'Transcript',
        
        // Student Reason 1003 (Record deletion)
        'studentReason1003.title': 'Record Deletion Reason',
        'studentReason1003.subtitle': 'Select the valid reason for the withdrawal request. Additional detail fields will appear when necessary.',
        'studentReason1003.options.financial': 'Financial Reasons',
        'studentReason1003.options.personal': 'Personal Reason',
        'studentReason1003.options.military': 'Military Service',
        'studentReason1003.options.horizontal': 'Horizontal Transfer',
        'studentReason1003.options.other': 'Other',
        'studentReason1003.descriptions.financial': 'Situations related to payments, scholarships or financial processes.',
        'studentReason1003.descriptions.personal': 'Situations related to health, family or personal planning.',
        'studentReason1003.descriptions.military': 'Requests related to conscription, deferment or compulsory service.',
        'studentReason1003.descriptions.horizontal': 'Enter the name of the university and program you were accepted to.',
        'studentReason1003.descriptions.other': 'Specify a different reason that is not listed.',
        'studentReason1003.horizontalLabel': 'Accepted University Name',
        'studentReason1003.horizontalHelper': 'Select the university you were accepted to from the list.',
        'studentReason1003.horizontalPlaceholder': 'University name, faculty/department and program information',
        'studentReason1003.horizontalSelect': 'Select university...',
        'studentReason1003.otherLabel': 'Other Reason Details',
        'studentReason1003.otherHelper': 'Provide at least 5 characters of information.',
        'studentReason1003.otherPlaceholder': 'Please describe your other reason.',
        'studentReason1003.errors.reasonRequired': 'Please select a reason.',
        'studentReason1003.errors.horizontalRequired': 'Accepted university name and program is required.',
        'studentReason1003.errors.otherRequired': 'Please enter at least 5 characters of explanation.',
        
        // Student Freeze 1004
        'studentFreeze.title': 'Registration Freeze Reasons',
        'studentFreeze.subtitle': 'Please select the justification for your freeze request and add details if needed.',
        'studentFreeze.options.yurtdisi': 'Study Abroad',
        'studentFreeze.options.saglik': 'Health',
        'studentFreeze.options.askerlik': 'Military Service',
        'studentFreeze.options.hazirlik': 'Prep Program Early Completion',
        'studentFreeze.options.other': 'Other',
        'studentFreeze.descriptions.yurtdisi': 'Participation in an overseas education or exchange program.',
        'studentFreeze.descriptions.saglik': 'Situations requiring medical reports or treatment.',
        'studentFreeze.descriptions.askerlik': 'Processes related to deferment, enlistment or compulsory service.',
        'studentFreeze.descriptions.hazirlik': 'Completing the preparatory program earlier than planned.',
        'studentFreeze.descriptions.other': 'Specify a different reason not listed.',
        'studentFreeze.otherLabel': 'Other Reason Details',
        'studentFreeze.otherHelper': 'Provide at least 5 characters of information.',
        'studentFreeze.otherPlaceholder': 'Please describe your other reason.',
        'studentFreeze.historyQuestion': 'Have you frozen your registration in previous years?',
        'studentFreeze.historyYes': 'Yes',
        'studentFreeze.historyNo': 'No',
        'studentFreeze.errors.reasonRequired': 'Please select a registration freeze reason.',
        'studentFreeze.errors.otherRequired': 'Please describe the other reason with at least 5 characters.',
        'studentFreeze.errors.historyRequired': 'Please specify whether you have frozen registration in previous years.',
        'studentFreeze.periodTitle': 'Request Period and Academic Calendar',
        'studentFreeze.periodSubtitle': 'Select how many terms you want to freeze and from which academic year/term it will be valid. The end information will be calculated automatically.',
        'studentFreeze.requestPeriodLabel': 'Request Period',
        'studentFreeze.requestPeriodPlaceholder': 'Select request period...',
        'studentFreeze.requestPeriod.1': '1 Term Leave',
        'studentFreeze.requestPeriod.2': '2 Terms Leave',
        'studentFreeze.requestPeriod.3': '3 Terms Leave',
        'studentFreeze.requestPeriod.4': '4 Terms Leave',
        'studentFreeze.startYearLabel': 'Start Academic Year',
        'studentFreeze.startYearPlaceholder': 'Select start academic year...',
        'studentFreeze.startTermLabel': 'Start Term',
        'studentFreeze.startTermPlaceholder': 'Select start term...',
        'studentFreeze.term.fall': 'Fall',
        'studentFreeze.term.spring': 'Spring',
        'studentFreeze.endInfoTitle': 'Computed Freeze Interval',
        'studentFreeze.endInfoPlaceholder': 'Once you select request period, start year and term, the end year and term will be shown here automatically.',
        'studentFreeze.endInfoComputed': 'Start: {startYear} {startTerm} • End: {endYear} {endTerm}',
        'studentFreeze.errors.periodRequired': 'Please select a request period.',
        'studentFreeze.errors.startYearRequired': 'Please select the start academic year.',
        'studentFreeze.errors.startTermRequired': 'Please select the start term.',

        // Student Exemption 1006
        'studentExemption1006.title': 'Course Exemption Request',
        'studentExemption1006.subtitle': 'List the courses you want to be exempt from and upload the required appendices.',
        'studentExemption1006.tableTitle': 'Courses Applied for Exemption at Nişantaşı University',
        'studentExemption1006.tableSubtitle': 'Provide course code, name, credit, ECTS and letter grade for each row.',
        'studentExemption1006.tableHelper': 'At least one course row must be completed.',
        'studentExemption1006.addRow': 'Add Row',
        'studentExemption1006.columns.code': 'Course Code',
        'studentExemption1006.columns.name': 'Course Name',
        'studentExemption1006.columns.credit': 'Credit',
        'studentExemption1006.columns.ects': 'ECTS',
        'studentExemption1006.columns.grade': 'Letter Grade',
        'studentExemption1006.docs.helper': 'Drag or Click',
        'studentExemption1006.docs.appendix1.label': 'APPENDIX 1 / Transcript',
        'studentExemption1006.docs.appendix1.title': 'Transcript',
        'studentExemption1006.docs.appendix2.label': 'APPENDIX 2 / Course Contents',
        'studentExemption1006.docs.appendix2.title': 'Course Contents',
        'studentExemption1006.docs.appendix3.label': 'APPENDIX 3 / Exemption Table',
        'studentExemption1006.docs.appendix3.title': 'Course Exemption Table',
        'studentExemption1006.errors.tableRequired': 'Please add at least one course row.',
        'studentExemption1006.errors.rowRequired': 'All columns must be filled.',
        'studentExemption1006.errors.documentRequired': 'This document is required.',
        'studentExemption1006.errors.maxRows': 'You can add up to 8 rows.',

        // Student Three Course 1007
        'studentThreeCourse1007.title': 'Three-Course Exam Request',
        'studentThreeCourse1007.subtitle': 'Enter the course information for the three-course exam.',
        'studentThreeCourse1007.tableTitle': 'Information about the Courses for which Three Course Exam will be Taken',
        'studentThreeCourse1007.tableSubtitle': 'Fill out course code, name, credit, ECTS and grade for each row.',
        'studentThreeCourse1007.columns.no': 'No.',
        'studentThreeCourse1007.columns.code': 'Course Code',
        'studentThreeCourse1007.columns.name': 'Course Name',
        'studentThreeCourse1007.columns.credit': 'Credit',
        'studentThreeCourse1007.columns.ects': 'ECTS',
        'studentThreeCourse1007.columns.grade': 'Grade',
        'studentThreeCourse1007.errors.rowRequired': 'All three rows must be completed.',
        'studentThreeCourse1007.docs.transcript.label': 'Transcript',
        'studentThreeCourse1007.docs.transcript.title': 'Upload your transcript',
        'studentThreeCourse1007.docs.helper': 'Accepted formats: PDF, JPG, JPEG, PNG',
        'studentThreeCourse1007.errors.documentRequired': 'Please upload your transcript document.',
        'studentThreeCourse1007.placeholders.code': 'CS101',
        'studentThreeCourse1007.placeholders.name': 'Course Name',
        'studentThreeCourse1007.placeholders.credit': '3',
        'studentThreeCourse1007.placeholders.ects': '5',
        'studentThreeCourse1007.placeholders.grade': 'AA',
        
        // Student Double Minor 1008 - Additional
        'studentDoubleMinor1008.doubleMajorSubtitle': 'Double Major',
        'studentDoubleMinor1008.minorSubtitle': 'Minor',
        'studentDoubleMinor1008.actions': 'Actions',
        
        // Exam Excuse
        'examExcuse.title': 'Exam Excuse Information',
        'examExcuse.courseCount': 'Course Count',
        'examExcuse.academicYear': 'Academic Year',
        'examExcuse.term': 'Term',
        'examExcuse.courseCode': 'Course Code',
        'examExcuse.courseName': 'Course Name',
        'examExcuse.exam': 'Exam',
        'examExcuse.examScore': 'Exam Score',
        'examExcuse.selection': 'Selection',
        'examExcuse.emptyState': 'No courses found for this term.',
        'examExcuse.helper': 'Please select the course and exam type for which you want to request an excuse exam.',
        'examExcuse.errors.examTypeRequired': 'Please select an exam type.',
        'examExcuse.errors.courseRequired': 'Please select the course for which you want to request an excuse exam.',
        'examExcuse.errors.appealCheck': 'Please check the exam and related grade you want to appeal.',
        
        // Modals
        'modal.requestResults.title': 'Request Results',
        'modal.requestResults.search': 'Search',
        'modal.requestResults.securityNote': 'Email verification is required for security',
        'modal.success.title': 'Success',
        'modal.success.message': 'Operation completed successfully.',
        'modal.success.requestNumber': 'Request number:',
        'modal.success.trackInfo': 'You can track your request status from the "Request Results" section.',
        'modal.success.ok': 'OK',
        'modal.error.title': 'Error',
        'modal.error.message': 'Please try again.',
        'modal.error.ok': 'OK',
        
        // Verification Modal
        'verification.title': 'Enter Verification Code',
        'verification.description': 'Please enter the 6-digit code sent to your student email in the boxes below.',
        'verification.verify': 'Verify',
        'verification.resend': 'Resend Code',
        'verification.validFor': 'The verification code is valid for 10 minutes.',
        
        // Email Verification Modal
        'emailVerification.title': 'Email Verification',
        'emailVerification.security': 'Security Verification',
        'emailVerification.description': 'A verification code has been sent to your student email. Please enter the 6-digit code you received.',
        
        // Request Detail Modal
        'requestDetail.title': 'Request Detail',
        'requestDetail.subject': 'Subject Title',
        'requestDetail.startDate': 'Opening Date',
        'requestDetail.closeDate': 'Closing Date',
        'requestDetail.studentRequest': 'Student Request',
        'requestDetail.response': 'Response / Update',
        
        // Privacy Modal
        'privacy.title': 'Privacy Policy',
        'privacy.understand': 'I Understand',
        
        // Errors
        'error.invalidFileType': 'Invalid file type. Only JPG, PNG and PDF files are accepted.',
        'error.fileTooLarge': 'File size is too large (maximum 10MB)',
        'error.invalidStudentNumber': 'Invalid student number',
        'error.studentNotFound': 'Student not found',
        'error.invalidEmail': 'Invalid email address',
        'error.invalidPhone': 'Phone number must be in 5XX XXX XX XX format.',
        'error.requestMinLength': 'Request field must be at least 10 characters.',
        'error.consentRequired': 'You must give consent for processing personal data.',
        'error.topicRequired': 'Please select a topic.',
        'error.maxActiveRequests': 'You have 3 active requests.\\n\\nYour application right will be opened again when your requests are completed.',
        
        // Success Messages
        'success.requestSubmitted': 'Your request has been submitted successfully!',
        'success.requestNumber': 'Request Number:',
        'success.trackInfo': 'You can track your request status from the "Request Results" section.',
        
        // Request Detail Modal
        'requestDetail.loading': 'Loading...',
        'requestDetail.loadingDetails': 'Request details are loading, please wait...',
        'requestDetail.noStatus': 'No Status Information',
        
        // Topic Search
        'topicSearch.placeholder': 'Search topic',
        'topicSearch.noResults': 'Topic not found.',
    }
};

// ============================================
// SECTION 2: LANGUAGE MANAGER
// ============================================
// Dil Yönetimi - Language Manager Class
class LanguageManager {
    constructor() {
        // localStorage sadece non-sensitive data için kullanılıyor (preferredLanguage)
        // Sensitive data (token, credentials) localStorage'da saklanmıyor - güvenli
        this.currentLang = localStorage.getItem('preferredLanguage') || 'tr';
        this.init();
    }
    
    init() {
        this.setupLanguageButtons();
        this.applyLanguage(this.currentLang);
    }
    
    setupLanguageButtons() {
        this.dropdownToggle = document.getElementById('languageDropdownToggle');
        this.dropdownItems = Array.from(document.querySelectorAll('.language-option'));
        
        if (this.dropdownItems.length) {
            this.dropdownItems.forEach(item => {
                item.addEventListener('click', () => this.setLanguage(item.dataset.lang));
            });
        }
        
        this.updateDropdownUI();
    }
    
    setLanguage(lang) {
        if (lang !== this.currentLang) {
            this.currentLang = lang;
            localStorage.setItem('preferredLanguage', lang);
            this.applyLanguage(lang);
        } else {
            this.updateDropdownUI();
        }
        
        if (this.dropdownToggle && window.bootstrap?.Dropdown) {
            const dropdownInstance = bootstrap.Dropdown.getInstance(this.dropdownToggle);
            dropdownInstance?.hide();
        }
    }
    
    applyLanguage(lang) {
        this.updateDropdownUI();
        
        // Tüm i18n elementlerini güncelle
        const i18nElements = document.querySelectorAll('[data-i18n], .i18n-text');
        i18nElements.forEach(element => {
            const key = element.getAttribute('data-i18n') || element.closest('[data-i18n]')?.getAttribute('data-i18n');
            if (key && translations[lang] && translations[lang][key]) {
                if (element.classList.contains('i18n-text')) {
                    element.textContent = translations[lang][key];
                } else {
                    const textElement = element.querySelector('.i18n-text');
                    if (textElement) {
                        textElement.textContent = translations[lang][key];
                    } else {
                        element.textContent = translations[lang][key];
                    }
                }
            }
        });
        
        // Placeholder'ları güncelle
        const placeholderElements = document.querySelectorAll('[data-i18n-placeholder]');
        placeholderElements.forEach(element => {
            const key = element.getAttribute('data-i18n-placeholder');
            if (key && translations[lang] && translations[lang][key]) {
                element.placeholder = translations[lang][key];
            }
        });
        
        // Title attribute'ları güncelle
        const titleElements = document.querySelectorAll('[data-i18n-title]');
        titleElements.forEach(element => {
            const key = element.getAttribute('data-i18n-title');
            if (key && translations[lang] && translations[lang][key]) {
                element.title = translations[lang][key];
            }
        });
        
        // Aria-label attribute'ları güncelle
        const ariaLabelElements = document.querySelectorAll('[data-i18n-aria-label]');
        ariaLabelElements.forEach(element => {
            const key = element.getAttribute('data-i18n-aria-label');
            if (key && translations[lang] && translations[lang][key]) {
                element.setAttribute('aria-label', translations[lang][key]);
            }
        });
        
        // Option elementlerindeki i18n-text span'larını güncelle
        const optionElements = document.querySelectorAll('option[data-i18n]');
        optionElements.forEach(option => {
            const key = option.getAttribute('data-i18n');
            if (key && translations[lang] && translations[lang][key]) {
                const textSpan = option.querySelector('.i18n-text');
                if (textSpan) {
                    textSpan.textContent = translations[lang][key];
                } else {
                    option.textContent = translations[lang][key];
                }
            }
        });
    }
    
    updateDropdownUI() {
        if (!this.dropdownItems) {
            this.dropdownItems = Array.from(document.querySelectorAll('.language-option'));
        }
        if (!this.dropdownToggle) {
            this.dropdownToggle = document.getElementById('languageDropdownToggle');
        }
        if (this.dropdownItems.length) {
            this.dropdownItems.forEach(item => {
                const isActive = item.dataset.lang === this.currentLang;
                item.classList.toggle('active', isActive);
            });
        }
        
        if (this.dropdownToggle) {
            const activeItem = this.dropdownItems?.find(item => item.dataset.lang === this.currentLang);
            if (activeItem) {
                const flag = activeItem.dataset.flag || '';
                const label = activeItem.dataset.label || activeItem.textContent.trim();
                const flagEl = this.dropdownToggle.querySelector('.language-flag img');
                const labelEl = this.dropdownToggle.querySelector('.language-label');
                
                if (flagEl) {
                    if (flag === 'tr') {
                        flagEl.src = window.STATIC_PREFIX 
                            ? `${window.STATIC_PREFIX}/images/turkey.png`
                            : 'static/images/turkey.png';
                        flagEl.alt = 'Türkçe';
                    } else if (flag === 'en') {
                        flagEl.src = window.STATIC_PREFIX 
                            ? `${window.STATIC_PREFIX}/images/United%20Kingdom%20Flag%20Icon.png`
                            : 'static/images/United%20Kingdom%20Flag%20Icon.png';
                        flagEl.alt = 'English';
                    }
                }
                if (labelEl) labelEl.textContent = label;
            }
        }
    }
    
    getTranslation(key, lang = null) {
        const targetLang = lang || this.currentLang;
        return translations[targetLang]?.[key] || key;
    }
}

// Global language manager instance
let languageManager = null;

// ============================================
// SECTION 3: UTILITY FUNCTIONS
// ============================================
// Performance optimization utilities
function debounce(fn, delay = 150) {
    let timeoutId;
    return function debounced(...args) {
        const context = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(context, args), delay);
    };
}

// Throttle function for scroll/resize events
function throttle(fn, limit = 100) {
    let inThrottle;
    return function throttled(...args) {
        const context = this;
        if (!inThrottle) {
            fn.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
}

// RequestAnimationFrame wrapper for smooth animations
function raf(callback) {
    return requestAnimationFrame(callback);
}

// Lazy load images with Intersection Observer
function lazyLoadImages() {
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute('data-src');
                        observer.unobserve(img);
                    }
                }
            });
        }, {
            rootMargin: '50px'
        });

        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });
    }
}

// Character counter initialization for textareas/inputs
function initCharCounters() {
    const inputs = document.querySelectorAll('[data-char-max]');
    inputs.forEach(input => {
        if (input.dataset.charCounterInitialized === 'true') {
            return;
        }

        const max = parseInt(input.dataset.charMax, 10);
        const counter = document.createElement('div');
        counter.className = 'char-counter';
        counter.setAttribute('aria-live', 'polite');

        const formGroup = input.closest('.form-group');
        let referenceElement = input;
        if (formGroup) {
            const helpers = formGroup.querySelectorAll('.form-text');
            if (helpers.length) {
                referenceElement = helpers[helpers.length - 1];
            }
        }
        referenceElement.insertAdjacentElement('afterend', counter);

        const updateCounter = () => {
            const currentLength = input.value.length;
            const hasMax = Number.isFinite(max);
            counter.textContent = hasMax ? `${currentLength} / ${max} karakter` : `${currentLength} karakter`;
            if (hasMax) {
                counter.classList.toggle('char-counter-warning', currentLength >= Math.floor(max * 0.8) && currentLength <= max);
                counter.classList.toggle('char-counter-limit', currentLength > max);
            }
        };

        input.addEventListener('input', updateCounter);
        input.addEventListener('change', updateCounter);
        updateCounter();

        input.dataset.charCounterInitialized = 'true';
    });
}

// Performance: Batch DOM updates
function batchDOMUpdates(updates) {
    raf(() => {
        updates.forEach(update => update());
    });
}

// Memory-efficient event delegation
function createEventDelegator(container, eventType, selector, handler) {
    if (!container) return null;
    
    const delegator = (e) => {
        const target = e.target.closest(selector);
        if (target) {
            handler.call(target, e);
        }
    };
    
    container.addEventListener(eventType, delegator, { passive: true });
    return delegator;
}

// ============================================
// SECTION 4: EXAM EXCUSE MANAGER
// ============================================
// Sınav Mazeret Yönetimi - Exam Excuse Manager Class
class ExamExcuseManager {
    constructor(app, elements) {
        this.app = app;
        this.elements = elements || {};
        this.globalOverlayElement = document.getElementById('globalBlockingOverlay');
        this.globalOverlayMessageElement = this.globalOverlayElement ? this.globalOverlayElement.querySelector('[data-role="message"]') : null;
        this.allowedGroupIds = new Set(['1', '2']);
        this.currentGroupId = null;
        this.scoreEnabledGroups = new Set(['2']);
        this.examTypeOptions = [
            'Ara Sınav 1',
            'Ara Sınav 2',
            'Ara Sınav 3',
            'Ara Sınav 4',
            'Ara Sınav 5',
            'Ara Sınav 6',
            'Final',
            'Bütünleme'
        ];
        this.examFieldMappings = {
            'Ara Sınav 1': ['Ara Sınav 1'],
            'Ara Sınav 2': ['Ara Sınav 2'],
            'Ara Sınav 3': ['Ara Sınav 3'],
            'Ara Sınav 4': ['Ara Sınav 4'],
            'Ara Sınav 5': ['Ara Sınav 5'],
            'Ara Sınav 6': ['Ara Sınav 6'],
            'Final': ['Final', 'FSP (Final Sınavı Puanı)', 'Final Notu'],
            'Bütünleme': ['Bütünleme', 'BSP (Bütünleme Sınavı Puanı)']
        };
        this.cacheTtlMs = 5 * 60 * 1000;
        this.sessionStorageKey = 'exam_excuse_cache_v1';
        this.memoryCache = new Map();
        this.sessionCache = {};
        this.restoreSessionCache();
        this.state = this.createEmptyExamRequestState();
        this.overlayElement = this.ensureOverlayElement();
        this.overlayMessageElement = this.overlayElement ? this.overlayElement.querySelector('[data-role="message"]') : null;
        this.tableEventsBound = false;
        this.bindTableEvents();
    }

    createEmptyExamRequestState() {
        return {
            grades: [],
            meta: {
                count: null,
                academic_year: '',
                term: '',
                headers: []
            },
            selections: {},
            selectedCourseKey: null
        };
    }

    reset(forceHide = false) {
        this.state = this.createEmptyExamRequestState();
        if (this.elements.meta?.count) {
            this.elements.meta.count.value = '';
        }
        if (this.elements.meta?.year) {
            this.elements.meta.year.value = '';
        }
        if (this.elements.meta?.term) {
            this.elements.meta.term.value = '';
        }
        if (this.elements.body) {
            this.elements.body.innerHTML = '';
        }
        if (this.elements.emptyState) {
            this.elements.emptyState.classList.add('d-none');
        }
        if (this.elements.helper) {
            const helperText = this.app.languageManager?.getTranslation('loading.examData') || 'Lütfen mazeret sınavı talep etmek istediğiniz dersi ve sınav türünü seçiniz.';
            this.elements.helper.textContent = helperText;
        }
        if (this.elements.scoreHeader) {
            this.elements.scoreHeader.classList.add('d-none');
        }
        this.clearExamSelectionError();
        this.hideBlockingOverlay();
        if (forceHide && this.elements.section) {
            this.elements.section.classList.add('d-none');
            this.currentGroupId = null;
        }
    }

    async handleTopicChange({ selectedGroupId, userType, isVerified, studentData }) {
        const overlayMessage = this.app.languageManager?.getTranslation('loading.obisData') || 'OBİS ders ve sınav bilgileriniz alınmaktadır. Bu işlem yaklaşık 2 dakika kadar sürebilir. Lütfen bekleyiniz...';
        if (!this.allowedGroupIds.has(String(selectedGroupId))) {
            this.currentGroupId = null;
            this.hideBlockingOverlay();
            const currentSelect = document.getElementById('ticketTopic');
            const noSelection = !currentSelect || !currentSelect.value;
            this.reset(!noSelection);
            return;
        }
        this.currentGroupId = String(selectedGroupId);

        this.showBlockingOverlay(overlayMessage);

        if (userType !== 'student') {
            this.hideBlockingOverlay();
            this.reset(true);
            return;
        }

        if (!isVerified) {
            const warningTitle = this.app.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.app.languageManager?.getTranslation('warning.examExcuseVerificationRequired') || 'Mazeret sınavı talebi için önce öğrenci doğrulamasını tamamlayınız.';
            this.app.showWarningToast(warningMsg, warningTitle);
            this.hideBlockingOverlay();
            this.reset(true);
            return;
        }

        const student = studentData || this.app.currentStudentData;
        if (!student || !student.ogrenci_no) {
            const warningTitle = this.app.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.app.languageManager?.getTranslation('warning.studentInfoRequired') || 'Öğrenci bilgileri doğrulanamadı. Lütfen önce doğrulama adımını tamamlayınız.';
            this.app.showWarningToast(warningMsg, warningTitle);
            this.hideBlockingOverlay();
            this.reset(true);
            return;
        }

        await this.loadExamDataForCurrentStudent(false);
    }

    async loadExamDataForCurrentStudent(forceRefresh = false) {
        const student = this.app.currentStudentData;
        if (!student || !student.ogrenci_no) {
            const warningTitle = this.app.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.app.languageManager?.getTranslation('warning.studentInfoRequired') || 'Öğrenci bilgileri doğrulanamadı. Lütfen önce doğrulama adımını tamamlayınız.';
            this.app.showWarningToast(warningMsg, warningTitle);
            this.hideBlockingOverlay();
            return;
        }
        const topicSelect = document.getElementById('ticketTopic');
        const topicOption = topicSelect?.selectedOptions[0];
        const groupId = topicOption ? topicOption.dataset?.grupId : null;
        if (!topicSelect || !topicSelect.value || !this.allowedGroupIds.has(groupId)) {
            this.hideBlockingOverlay();
            this.currentGroupId = null;
            this.reset(false);
            return;
        }
        this.currentGroupId = groupId;
        await this.fetchAndRenderExamData(student.ogrenci_no, forceRefresh);
    }

    handleUserTypeChange(userType) {
        if (userType !== 'student') {
            this.hideBlockingOverlay();
            this.reset(true);
            return;
        }
        this.hideBlockingOverlay();
        this.reset(false);
    }

    async fetchAndRenderExamData(studentNumber, forceRefresh = false) {
        const cacheKey = (studentNumber || '').trim();
        if (!cacheKey) {
            return;
        }

        if (!forceRefresh) {
            const cachedData = this.getCachedEntry(cacheKey);
            if (cachedData) {
                this.applyExamData(cachedData);
                this.hideBlockingOverlay();
                return;
            }
        }

        const overlayMsg = this.app.languageManager?.getTranslation('loading.obisData') || 'OBİS ders ve sınav bilgileriniz alınmaktadır. Bu işlem yaklaşık 2 dakika kadar sürebilir. Lütfen bekleyiniz...';
        this.showBlockingOverlay(overlayMsg);

        try {
            const response = await this.app.fetchWithAuth(`${this.app.apiBaseUrl}/student-grades/${encodeURIComponent(cacheKey)}`);
            const data = await response.json();

            if (response.ok && data?.success) {
                const normalized = this.normalizeExamData(data.data || {});
                this.setCachedEntry(cacheKey, normalized);
                this.applyExamData(normalized);
            } else {
                const message = data?.error || 'Sınav bilgileri alınamadı. Lütfen daha sonra tekrar deneyiniz.';
                this.reset(true);
                this.app.showErrorToast(message, 'Hata');
            }
        } catch (error) {
            console.error('Sınav bilgileri getirme hatası:', error);
            this.reset(true);
            const errorTitle = this.app.languageManager?.getTranslation('error.title') || 'Hata';
            const errorMsg = this.app.languageManager?.getTranslation('error.generic') || 'Sınav bilgileri alınırken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.';
            this.app.showErrorToast(errorMsg, errorTitle);
        } finally {
            this.hideBlockingOverlay();
        }
    }

    normalizeExamData(rawData) {
        const grades = Array.isArray(rawData?.grades) ? rawData.grades : [];
        const meta = rawData?.meta || {};
        return {
            grades,
            meta: {
                count: meta.count ?? grades.length ?? 0,
                academic_year: meta.academic_year || '',
                term: meta.term || '',
                headers: meta.headers || rawData?.headers || []
            }
        };
    }

    applyExamData(normalizedData) {
        this.state = this.createEmptyExamRequestState();
        
        const allGrades = normalizedData.grades || [];
        let filteredGrades = [];
        
        // Sadece grup ID 1 (sınav mazeret) için filtreleme yap
        if (this.currentGroupId === '1') {
            // Sınav mazeret için: Sadece sınav notu negatif olan dersleri filtrele
            allGrades.forEach(grade => {
                // Hangi sınav türünün notu negatifse onu bul
                const negativeExamType = this.findNegativeExamType(grade);
                
                // Eğer negatif sınav notu varsa, bu dersi ekle
                if (negativeExamType) {
                    filteredGrades.push(grade);
                }
            });
        } else {
            // Diğer gruplar için (sınav itiraz vb.) tüm dersleri göster
            filteredGrades = allGrades;
        }
        
        this.state.grades = filteredGrades;
        this.state.meta = normalizedData.meta;

        filteredGrades.forEach((grade, index) => {
            const courseKey = this.buildCourseKey(grade, index);
            let selectedExam;
            
            // Sadece grup ID 1 (sınav mazeret) için otomatik sınav türü seçimi
            if (this.currentGroupId === '1') {
                // Negatif sınav notu olan sınav türünü otomatik seç
                selectedExam = this.findNegativeExamType(grade) || this.determineDefaultExamType(grade);
            } else {
                // Diğer gruplar için varsayılan sınav türü
                selectedExam = this.determineDefaultExamType(grade);
            }
            
            this.state.selections[courseKey] = {
                grade,
                selectedExam: selectedExam
            };
            if (!this.state.selectedCourseKey) {
                this.state.selectedCourseKey = courseKey;
            }
        });

        this.renderExamSection();
    }

    buildCourseKey(grade, index = 0) {
        const code = (grade?.['Ders Kodu'] || grade?.code || '').toString().trim();
        const selection = (grade?.['Ders Seçimi'] || grade?.selection || '').toString().trim();
        const fallback = `course-${index}`;
        return [code, selection].filter(Boolean).join('::') || fallback;
    }

    determineDefaultExamType(grade) {
        for (const option of this.examTypeOptions) {
            const fieldKeys = this.examFieldMappings[option] || [];
            const hasValue = fieldKeys.some(key => {
                const fieldValue = grade?.[key];
                return fieldValue !== undefined && fieldValue !== null && fieldValue.toString().trim().length > 0;
            });
            if (hasValue) {
                return option;
            }
        }
        return this.examTypeOptions[0];
    }

    findNegativeExamType(grade) {
        // Sınav mazeret için: Hangi sınav türünün notu negatifse onu bul
        for (const option of this.examTypeOptions) {
            const fieldKeys = this.examFieldMappings[option] || [];
            for (const key of fieldKeys) {
                const value = grade?.[key];
                if (value !== undefined && value !== null && value.toString().trim().length > 0) {
                    const numericValue = parseFloat(value);
                    if (!isNaN(numericValue) && numericValue < 0) {
                        return option;
                    }
                }
            }
        }
        return null;
    }

    isScoreVisibleForCurrentTopic() {
        return this.currentGroupId && this.scoreEnabledGroups.has(this.currentGroupId);
    }

    extractExamScoreForSelection(grade, selectedExam) {
        if (!grade) {
            return '';
        }
        const examKeyList = this.examFieldMappings[selectedExam] || [];
        for (const key of examKeyList) {
            const value = grade?.[key];
            if (value !== undefined && value !== null && value.toString().trim().length > 0) {
                return value.toString().trim();
            }
        }
        return '';
    }

    updateExamScoreCell(courseKey) {
        if (!this.elements.body || !this.isScoreVisibleForCurrentTopic()) {
            return;
        }
        const selection = courseKey ? this.state.selections[courseKey] : null;
        const row = this.elements.body.querySelector(`tr[data-course-key="${courseKey}"]`);
        if (!selection || !row) {
            return;
        }
        const scoreCell = row.querySelector('.exam-score-cell');
        if (!scoreCell) {
            return;
        }
        const score = this.extractExamScoreForSelection(selection.grade, selection.selectedExam) || '';
        scoreCell.textContent = score;
        scoreCell.dataset.score = score;
    }

    renderExamSection() {
        if (!this.elements.section) {
            return;
        }

        const { meta, grades, selectedCourseKey, selections } = this.state;
        const hasGrades = Array.isArray(grades) && grades.length > 0;
        const showScoreColumn = this.isScoreVisibleForCurrentTopic();
        if (this.elements.scoreHeader) {
            this.elements.scoreHeader.classList.toggle('d-none', !showScoreColumn);
        }

        if (this.elements.meta?.count) {
            this.elements.meta.count.value = hasGrades ? (meta?.count ?? grades.length) : '';
        }
        if (this.elements.meta?.year) {
            this.elements.meta.year.value = meta?.academic_year || '';
        }
        if (this.elements.meta?.term) {
            this.elements.meta.term.value = meta?.term || '';
        }

        if (this.elements.body) {
            const fragment = document.createDocumentFragment();
            const isExamExcuse = this.currentGroupId === '1';
            
            if (hasGrades) {
                grades.forEach((grade, index) => {
                    const courseKey = this.buildCourseKey(grade, index);
                    const selection = selections[courseKey];
                    const row = document.createElement('tr');
                    row.dataset.courseKey = courseKey;
                    if (selectedCourseKey === courseKey) {
                        row.classList.add('selected');
                    }
                    
                    // Sınav mazeret (grup ID 1) için dropdown kaldırıldı, sadece metin göster
                    // Diğer gruplar için dropdown göster
                    let examTypeMarkup;
                    if (isExamExcuse) {
                        const examTypeText = selection?.selectedExam || '';
                        examTypeMarkup = `<td>${ExamExcuseManager.escapeHtml(examTypeText)}</td>`;
                    } else {
                        const optionsMarkup = this.examTypeOptions.map(option => {
                            const selectedAttr = selection?.selectedExam === option ? 'selected' : '';
                            return `<option value="${option}" ${selectedAttr}>${option}</option>`;
                        }).join('');
                        examTypeMarkup = `
                            <td>
                                <select class="form-select form-select-sm" data-course-key="${courseKey}">
                                    ${optionsMarkup}
                                </select>
                            </td>
                        `;
                    }
                    
                    const rawScore = showScoreColumn ? this.extractExamScoreForSelection(grade, selection?.selectedExam) : '';
                    const scoreText = rawScore ? ExamExcuseManager.escapeHtml(rawScore) : '';
                    const scoreCellMarkup = showScoreColumn ? `<td class="exam-score-cell" data-score="${scoreText}">${scoreText}</td>` : '';
                    row.innerHTML = `
                        <td>${ExamExcuseManager.escapeHtml(grade?.['Ders Kodu'] || '')}</td>
                        <td>${ExamExcuseManager.escapeHtml(grade?.['Ders Adı'] || '')}</td>
                        ${examTypeMarkup}
                        ${scoreCellMarkup}
                        <td>
                            <div class="form-check mb-0">
                                <input class="form-check-input" type="radio" name="examCourseSelection" value="${courseKey}" ${selectedCourseKey === courseKey ? 'checked' : ''}>
                                <label class="form-check-label visually-hidden">Ders Seçimi</label>
                            </div>
                        </td>
                    `;
                    fragment.appendChild(row);
                });
            }
            this.elements.body.innerHTML = '';
            this.elements.body.appendChild(fragment);
        }

        if (this.elements.emptyState) {
            this.elements.emptyState.classList.toggle('d-none', hasGrades);
        }

        if (this.elements.section) {
            this.elements.section.classList.remove('d-none');
        }

        if (this.elements.helper) {
            // Grup ID 1 (sınav mazeret) için sadece ders seçimi mesajı
            // Grup ID 2 (sınav itiraz) için eski mesaj
            const isExamExcuse = this.currentGroupId === '1';
            let helperMessage;
            if (this.isScoreVisibleForCurrentTopic()) {
                // Sınav itiraz için - not görünür olduğunda
                const translation = this.app?.languageManager?.getTranslation('examExcuse.errors.appealCheck');
                helperMessage = translation || 'Lütfen itiraz etmek istediğiniz sınavı ve ilgili notu kontrol ediniz.';
            } else if (isExamExcuse) {
                // Sınav mazeret için
                helperMessage = 'Lütfen mazeret sınavı talep etmek istediğiniz dersi seçiniz.';
            } else {
                // Diğer durumlar
                const translation = this.app?.languageManager?.getTranslation('loading.examData');
                helperMessage = translation || 'Lütfen mazeret sınavı talep etmek istediğiniz dersi ve sınav türünü seçiniz.';
            }
            this.elements.helper.textContent = hasGrades
                ? helperMessage
                : 'Bu döneme ait kayıtlı ders bulunamadı.';
        }

        this.highlightSelectedExamRow();
        this.clearExamSelectionError();
    }

    handleExamCourseSelection(courseKey) {
        if (!courseKey || !this.state.selections[courseKey]) {
            return;
        }
        this.state.selectedCourseKey = courseKey;
        this.highlightSelectedExamRow();
        this.updateExamScoreCell(courseKey);
        this.clearExamSelectionError();
    }

    handleExamTypeChange(courseKey, examType) {
        if (!courseKey || !this.state.selections[courseKey]) {
            return;
        }
        this.state.selections[courseKey].selectedExam = examType;
        this.updateExamScoreCell(courseKey);
        this.clearExamSelectionError();
    }

    highlightSelectedExamRow() {
        if (!this.elements.body) {
            return;
        }
        const selectedKey = this.state.selectedCourseKey;
        const rows = Array.from(this.elements.body.querySelectorAll('tr'));
        rows.forEach(row => {
            const courseKey = row.dataset.courseKey;
            const radio = row.querySelector('input[type="radio"]');
            if (courseKey === selectedKey) {
                row.classList.add('selected');
                if (radio) {
                    radio.checked = true;
                }
                this.updateExamScoreCell(courseKey);
            } else {
                row.classList.remove('selected');
                if (radio) {
                    radio.checked = false;
                }
            }
        });
    }

    showExamSelectionError(message) {
        if (this.elements.error) {
            this.elements.error.textContent = message;
            this.elements.error.classList.remove('d-none');
        }
    }

    clearExamSelectionError() {
        if (this.elements.error) {
            this.elements.error.textContent = '';
            this.elements.error.classList.add('d-none');
        }
    }

    validateExamSelection() {
        if (!this.elements.section || this.elements.section.classList.contains('d-none')) {
            return true;
        }
        const selectedKey = this.state.selectedCourseKey;
        if (!selectedKey || !this.state.selections[selectedKey]) {
            this.showExamSelectionError('Mazeret sınavı talep edilecek dersi seçiniz.');
            ExamExcuseManager.scrollToElement(this.elements.section);
            return false;
        }
        const selection = this.state.selections[selectedKey];
        if (!selection?.selectedExam) {
            this.showExamSelectionError('Lütfen sınav türünü seçiniz.');
            ExamExcuseManager.scrollToElement(this.elements.section);
            return false;
        }
        this.clearExamSelectionError();
        return true;
    }

    appendExamSelectionToFormData(formData, selectedTopic) {
        if (!selectedTopic || !this.allowedGroupIds.has(String(selectedTopic.grup_id))) {
            return;
        }
        const selectedKey = this.state.selectedCourseKey;
        const selection = selectedKey ? this.state.selections[selectedKey] : null;
        if (!selection) {
            return;
        }
        const grade = selection.grade || {};
        const meta = this.state.meta || {};

        const includeScore = this.isScoreVisibleForCurrentTopic();
        const examScore = includeScore ? this.extractExamScoreForSelection(grade, selection.selectedExam) : '';
        formData.append('exam_excuse_course_code', grade['Ders Kodu'] || '');
        formData.append('exam_excuse_course_name', grade['Ders Adı'] || '');
        formData.append('exam_excuse_course_selection', grade['Ders Seçimi'] || '');
        formData.append('exam_excuse_exam_type', selection.selectedExam || '');
        if (includeScore) {
            formData.append('exam_excuse_exam_score', examScore);
        }
        formData.append('exam_excuse_academic_year', meta.academic_year || '');
        formData.append('exam_excuse_term', meta.term || '');
        formData.append('exam_excuse_course_count', meta.count !== null && meta.count !== undefined ? String(meta.count) : '');
        formData.append('exam_excuse_payload', JSON.stringify({
            meta,
            selected_course: grade,
            selected_exam: selection.selectedExam,
            ...(includeScore ? { selected_exam_score: examScore } : {})
        }));
    }

    getTopicById(konuId, topics) {
        if (!konuId || !Array.isArray(topics)) {
            return null;
        }
        const numericId = parseInt(konuId, 10);
        if (Number.isNaN(numericId)) {
            return null;
        }
        return topics.find(topic => parseInt(topic.id, 10) === numericId) || null;
    }

    shouldLoadExamSectionForCurrentSelection() {
        const { currentUserType, isVerified } = this.app;
        if (currentUserType !== 'student' || !isVerified) {
            return false;
        }
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect) {
            return false;
        }
        const selectedOption = topicSelect.options[topicSelect.selectedIndex];
        const groupId = selectedOption ? parseInt(selectedOption.dataset.grupId || '', 10) : NaN;
        this.app.selectedTopicGroupId = Number.isNaN(groupId) ? null : groupId;
        return this.allowedGroupIds.has(String(this.app.selectedTopicGroupId));
    }

    async handleExamSelectionPostVerification() {
        if (this.shouldLoadExamSectionForCurrentSelection()) {
            await this.loadExamDataForCurrentStudent(false);
        } else if (!this.allowedGroupIds.has(String(this.app.selectedTopicGroupId))) {
            this.reset(true);
        }
    }

    showBlockingOverlay(message) {
        const defaultMessage = this.app.languageManager?.getTranslation('loading.obisData') || 'OBİS ders ve sınav bilgileriniz alınmaktadır. Bu işlem yaklaşık 2 dakika kadar sürebilir. Lütfen bekleyiniz...';
        const displayMessage = message || defaultMessage;
        if (this.globalOverlayElement) {
            if (this.globalOverlayMessageElement) {
                this.globalOverlayMessageElement.textContent = displayMessage;
            }
            this.globalOverlayElement.classList.remove('d-none');
            document.body.classList.add('body-blocked');
        }
        if (this.overlayElement) {
            if (this.overlayMessageElement) {
                this.overlayMessageElement.textContent = displayMessage;
            }
            this.overlayElement.classList.remove('d-none');
        }
    }

    hideBlockingOverlay() {
        if (this.globalOverlayElement) {
            this.globalOverlayElement.classList.add('d-none');
            document.body.classList.remove('body-blocked');
        }
        if (this.overlayElement) {
            this.overlayElement.classList.add('d-none');
        }
    }

    ensureOverlayElement() {
        const section = this.elements.section;
        if (!section) {
            return null;
        }
        let overlay = section.querySelector('.exam-section-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'exam-section-overlay d-none';
            overlay.innerHTML = `
                <div class="exam-section-overlay__content">
                    <div class="spinner-border text-light" role="status" aria-hidden="true"></div>
                    <p class="exam-section-overlay__message mb-0" data-role="message">
                        Sınav bilgileriniz getiriliyor lütfen bekleyin
                    </p>
                </div>
            `;
            section.appendChild(overlay);
        }
        return overlay;
    }

    bindTableEvents() {
        if (!this.elements.body || this.tableEventsBound) {
            return;
        }
        this.tableEventsBound = true;
        this.elements.body.addEventListener('change', this.handleTableChange.bind(this));
        this.elements.body.addEventListener('click', this.handleTableClick.bind(this));
    }

    handleTableChange(event) {
        // Sınav mazeret (grup ID 1) için dropdown yok, sınav itiraz (grup ID 2) için var
        if (this.currentGroupId === '1') {
            return;
        }
        const selectEl = event.target && event.target.closest('select[data-course-key]');
        if (!selectEl) {
            return;
        }
        const courseKey = selectEl.dataset.courseKey;
        const examType = selectEl.value;
        this.handleExamTypeChange(courseKey, examType);
    }

    handleTableClick(event) {
        // Sınav mazeret (grup ID 1) için dropdown yok
        if (this.currentGroupId === '1') {
            const selectInteraction = event.target && event.target.closest('select[data-course-key]');
            if (selectInteraction) {
                return;
            }
        }
        const radio = event.target && event.target.closest('input[type="radio"][name="examCourseSelection"]');
        if (radio) {
            this.handleExamCourseSelection(radio.value);
            return;
        }
        const row = event.target && event.target.closest('tr[data-course-key]');
        if (row) {
            this.handleExamCourseSelection(row.dataset.courseKey);
        }
    }

    getCachedEntry(cacheKey) {
        const now = Date.now();
        const memoryEntry = this.memoryCache.get(cacheKey);
        if (memoryEntry && now - memoryEntry.fetchedAt < this.cacheTtlMs) {
            return memoryEntry.data;
        }
        const sessionEntry = this.sessionCache[cacheKey];
        if (sessionEntry && now - sessionEntry.fetchedAt < this.cacheTtlMs) {
            this.memoryCache.set(cacheKey, sessionEntry);
            return sessionEntry.data;
        }
        return null;
    }

    setCachedEntry(cacheKey, data) {
        const record = {
            data,
            fetchedAt: Date.now()
        };
        this.memoryCache.set(cacheKey, record);
        this.sessionCache[cacheKey] = record;
        this.persistSessionCache();
    }

    restoreSessionCache() {
        // sessionStorage sadece non-sensitive cache data için kullanılıyor (exam data cache)
        // Sensitive data (token, credentials) sessionStorage'da saklanmıyor - güvenli
        try {
            const rawCache = sessionStorage.getItem(this.sessionStorageKey);
            if (!rawCache) {
                this.sessionCache = {};
                return;
            }
            const parsed = JSON.parse(rawCache);
            if (parsed && typeof parsed === 'object') {
                this.sessionCache = parsed;
                Object.entries(parsed).forEach(([key, record]) => {
                    if (record && typeof record.fetchedAt === 'number' && record.data) {
                        this.memoryCache.set(key, record);
                    }
                });
            } else {
                this.sessionCache = {};
            }
        } catch (error) {
            this.sessionCache = {};
        }
    }

    persistSessionCache() {
        try {
            sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this.sessionCache));
        } catch (error) {
            // sessionStorage erişilemezse sessizce devam et
        }
    }

    static escapeHtml(value) {
        if (value === null || value === undefined) {
            return '';
        }
        return value
            .toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    static scrollToElement(element) {
        if (!element) {
            return;
        }
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
    }
}

// ============================================
// SECTION 5: MAIN APPLICATION
// ============================================
// Ana Uygulama - Main Application Class
class HelpFormApp {
    constructor() {
        // IIS subdirectory desteği için path detection
        // API versioning: v1 kullanılıyor (backward compatibility için eski endpoint'ler de çalışıyor)
        const path = window.location.pathname;
        if (path.includes('/ticket/')) {
            this.apiBaseUrl = '/ticket/api/v1';
        } else {
            this.apiBaseUrl = '/api/v1';
        }
        this.isLoading = false;
        this.selectedFile = null;
        this.languageManager = languageManager || new LanguageManager();
        // Dil değiştiğinde Tom Select placeholder'larını güncelle
        const originalApplyLanguage = this.languageManager.applyLanguage.bind(this.languageManager);
        this.languageManager.applyLanguage = (lang) => {
            originalApplyLanguage(lang);
            this.updateTomSelectPlaceholders();
        };
        // CSRF Token cache
        this.csrfToken = null;
        this.init();
    }
    
    // CSRF Token'ı al ve cache'le
    async fetchCSRFToken() {
        if (this.csrfToken) {
            return this.csrfToken;
        }
        try {
            const response = await fetch(`${this.apiBaseUrl}/csrf-token`);
            const data = await response.json();
            this.csrfToken = data.csrf_token;
            return this.csrfToken;
        } catch (error) {
            // CSRF token alınamazsa devam et (backend zaten cookie ile koruyor)
            return null;
        }
    }
    
    updateTomSelectPlaceholders() {
        const placeholderText = this.languageManager?.getTranslation('topicSearch.placeholder') || 'Konu arayınız';
        
        // Student topic select
        if (this.ticketTopicTomSelect) {
            if (this.ticketTopicTomSelect.input) {
                this.ticketTopicTomSelect.input.placeholder = placeholderText;
            }
            // Dropdown içindeki arama kutusunu da güncelle
            if (this.ticketTopicTomSelect.updateSearchPlaceholder) {
                this.ticketTopicTomSelect.updateSearchPlaceholder();
            } else {
                // Fallback: Manuel olarak bul ve güncelle
                if (this.ticketTopicTomSelect.dropdown) {
                    let searchInput = this.ticketTopicTomSelect.dropdown.querySelector('.ts-dropdown-content input[type="text"]');
                    if (!searchInput) {
                        searchInput = this.ticketTopicTomSelect.dropdown.querySelector('input[type="text"]');
                    }
                    if (!searchInput) {
                        searchInput = this.ticketTopicTomSelect.dropdown.querySelector('input');
                    }
                    if (searchInput) {
                        searchInput.placeholder = placeholderText;
                        searchInput.setAttribute('placeholder', placeholderText);
                    }
                }
            }
        }
        
        // Non-student topic select
        if (this.nonStudentTopicTomSelect) {
            if (this.nonStudentTopicTomSelect.input) {
                this.nonStudentTopicTomSelect.input.placeholder = placeholderText;
            }
            // Dropdown içindeki arama kutusunu da güncelle
            if (this.nonStudentTopicTomSelect.updateSearchPlaceholder) {
                this.nonStudentTopicTomSelect.updateSearchPlaceholder();
            } else {
                // Fallback: Manuel olarak bul ve güncelle
                if (this.nonStudentTopicTomSelect.dropdown) {
                    let searchInput = this.nonStudentTopicTomSelect.dropdown.querySelector('.ts-dropdown-content input[type="text"]');
                    if (!searchInput) {
                        searchInput = this.nonStudentTopicTomSelect.dropdown.querySelector('input[type="text"]');
                    }
                    if (!searchInput) {
                        searchInput = this.nonStudentTopicTomSelect.dropdown.querySelector('input');
                    }
                    if (searchInput) {
                        searchInput.placeholder = placeholderText;
                        searchInput.setAttribute('placeholder', placeholderText);
                    }
                }
            }
        }
    }

    init() {
        // Performance: Batch DOM reads
        const criticalElements = {
            toastContainer: document.getElementById('toastContainer'),
            loadingSpinner: document.getElementById('loadingSpinner')
        };
        
        this.toastContainer = criticalElements.toastContainer;
        
        // Performance: Use requestIdleCallback for non-critical initialization
        const initCritical = () => {
            this.setupEventListeners();
            this.hideLoadingSpinner();
            this.initializeForm();
        };
        
        const initNonCritical = () => {
            const examElements = this.collectExamElements();
            this.examManager = new ExamExcuseManager(this, examElements);
            this.setupVerificationModal();
            this.examManager.reset(true);
            this.setupHorizontalTransferEvents();
            this.setupNonStudentHorizontalTransferEvents();
            this.setupStudentReasonEvents();
            this.setupStudentFreezeEvents();
            this.setupStudentExemptionEvents();
            this.setupStudentThreeCourseEvents();
        };
        
        // Initialize critical parts immediately
        initCritical();
        
        // Initialize non-critical parts when idle
        if ('requestIdleCallback' in window) {
            requestIdleCallback(initNonCritical, { timeout: 2000 });
        } else {
            setTimeout(initNonCritical, 100);
        }
        
        // Initialize state
        this.currentUserType = null;
        this.currentStudentData = null;
        this.isVerified = false;
        this.lastFetchedStudentNo = null;
        this.lastVerificationSentFor = null;
        this.selectedTopicGroupId = null;
        this.ticketGroups = [];
        this.ticketTopics = [];
        this.verificationInputs = [];
        this.studentVerifyButton = null;
        this.studentVerificationModalInstance = null;
        this.studentVerificationModalOpen = false;
        this.requestDetailRefs = null;
        this.currentRequestSummaries = [];
        this.currentRequestStudentNo = null;
        // Yatay geçiş için dosya referansları (Öğrenci)
        this.horizontalTransferFiles = {
            ogrenciBelgesi: null,
            dersIcerikBilgisi: null,
            transkript: null
        };
        // Sınav itiraz için dosya referansı
        this.examAppealFile = null;
        this.examAppealFileUploadSetup = false;
        // Yatay geçiş için dosya referansları (Other kullanıcı)
        this.nonStudentHorizontalTransferFiles = {
            ogrenciBelgesi: null,
            dersIcerikBilgisi: null,
            transkript: null
        };
        // Üniversiteler listesi cache
        this.universitiesList = null;
        // Tom Select instance'ı için
        this.universityTomSelect = null;
        
        // Performance: Initialize API cache
        this.apiCache = new Map();
        this.cacheTTL = 5 * 60 * 1000; // 5 minutes

        // Muafiyet başvurusu (1006) için durum
        this.studentExemptionFiles = {
            appendix1: null,
            appendix2: null
        };
        this.exemptionCourseMaxRows = 8;
        this.exemptionCourseMinRows = 1;
        this.exemptionEventsInitialized = false;
        this.exemptionCoursesBody = null;
        
        // Çift Anadal/Yandal (1008) için durum
        this.doubleMinorCourseMaxRows = 8;
        this.doubleMinorCourseMinRows = 1;
        this.doubleMinorEventsInitialized = false;
        this.doubleMinorCoursesBody = null;
        this.doubleMinorProgramType = null;
        
        // Konu seçimi için Tom Select
        this.ticketTopicTomSelect = null;
        this.nonStudentTopicTomSelect = null;
        this.exemptionCoursesError = null;
        this.threeCourseEventsInitialized = false;
        this.threeCourseTableBody = null;
        this.threeCourseTableError = null;
        this.threeCourseTranscriptFile = null;
    }

    async buildAuthHeaders(extraHeaders) {
        const headers = new Headers(extraHeaders || {});
        
        // CSRF Token ekle (POST/PUT/DELETE istekleri için)
        // Backend'de CSRF token cookie olarak gönderiliyor, burada header'a da ekleniyor
        const csrfToken = await this.fetchCSRFToken();
        if (csrfToken) {
            headers.set('X-CSRF-Token', csrfToken);
        }
        
        return headers;
    }

    // API Response Cache Manager
    apiCache = new Map();
    cacheTTL = 5 * 60 * 1000; // 5 minutes default
    
    getCachedResponse(url) {
        const cached = this.apiCache.get(url);
        if (cached && Date.now() - cached.timestamp < this.cacheTTL) {
            return cached.data;
        }
        this.apiCache.delete(url);
        return null;
    }
    
    setCachedResponse(url, data) {
        this.apiCache.set(url, {
            data: data,
            timestamp: Date.now()
        });
    }
    
    clearCache() {
        this.apiCache.clear();
    }
    
    async fetchWithAuth(url, options = {}) {
        const opts = { ...options };
        // buildAuthHeaders artık async, await kullan
        const headers = await this.buildAuthHeaders(options.headers || {});
        opts.headers = headers;
        opts.credentials = 'same-origin';
        
        // Performance: Cache GET requests (skip cache for POST/PUT/DELETE)
        const isGetRequest = !options.method || options.method === 'GET';
        if (isGetRequest) {
            const cached = this.getCachedResponse(url);
            if (cached) {
                return Promise.resolve(new Response(JSON.stringify(cached), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                }));
            }
        }
        
        // Performance: Retry logic for network failures
        const maxRetries = 3;
        let retryCount = 0;
        
        const fetchWithRetry = () => {
            return fetch(url, opts).then(response => {
                // Cache successful GET responses
                if (isGetRequest && response.ok) {
                    response.clone().json().then(data => {
                        this.setCachedResponse(url, data);
                    }).catch(() => {}); // Ignore JSON parse errors
                }
                return response;
            }).catch(error => {
                if (retryCount < maxRetries && (error.name === 'TypeError' || error.message.includes('network'))) {
                    retryCount++;
                    return new Promise(resolve => {
                        setTimeout(() => resolve(fetchWithRetry()), Math.pow(2, retryCount) * 1000);
                    });
                }
                throw error;
            });
        };
        
        return fetchWithRetry();
    }

    // Toast Notification System - Optimized with RAF
    showToast(type, title, message, duration = 7000) {
        if (!this.toastContainer) {
            alert(`${title}\n\n${message.replace(/<br>/g, '\n').replace(/<[^>]*>/g, '')}`);
            return;
        }
        
        // Use requestAnimationFrame for smooth DOM insertion
        raf(() => {
            const toast = document.createElement('div');
            toast.className = `toast ${type}`;
            
            // Inline CSS ekle (CSS yüklenmediyse çalışsın diye)
            const colorMap = {
                success: '#10b981',
                error: '#ef4444',
                warning: '#f59e0b',
                info: '#3b82f6'
            };
            
            toast.style.cssText = `
                background: white;
                border-radius: 12px;
                box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
                padding: 1.25rem 1.5rem;
                margin-bottom: 1rem;
                min-width: 350px;
                max-width: 500px;
                display: flex !important;
                align-items: flex-start;
                gap: 1rem;
                border-left: 5px solid ${colorMap[type]};
                position: relative;
                overflow: hidden;
                animation: slideInRight 0.4s ease;
            `;
            
            const iconMap = {
                success: 'fa-check-circle',
                error: 'fa-exclamation-circle',
                warning: 'fa-exclamation-triangle',
                info: 'fa-info-circle'
            };
            
            const closeBtn = document.createElement('button');
            closeBtn.className = 'toast-close';
            closeBtn.innerHTML = '×';
            closeBtn.style.cssText = `
                background: none;
                border: none;
                font-size: 1.25rem;
                color: #999;
                cursor: pointer;
                padding: 0;
                width: 24px;
                height: 24px;
            `;
            closeBtn.onclick = () => {
                toast.style.animation = 'slideOutRight 0.3s ease forwards';
                setTimeout(() => toast.remove(), 300);
            };
            
            toast.innerHTML = `
                <i class="fas ${iconMap[type]}" style="font-size: 1.75rem; color: ${colorMap[type]}; flex-shrink: 0;"></i>
                <div style="flex: 1; min-width: 0;">
                    <div style="font-weight: 600; font-size: 1rem; margin: 0 0 0.25rem 0;">${title}</div>
                    <div style="font-size: 0.9rem; color: #666; margin: 0;">${message}</div>
                </div>
            `;
            
            toast.appendChild(closeBtn);
            
            const progress = document.createElement('div');
            progress.className = 'toast-progress';
            progress.style.cssText = `
                position: absolute;
                bottom: 0;
                left: 0;
                height: 4px;
                background: ${colorMap[type]};
                animation: progressBar ${duration}ms linear forwards;
            `;
            toast.appendChild(progress);
            
            // Container'a da inline style ekle
            if (this.toastContainer) {
                this.toastContainer.style.cssText = `
                    position: fixed !important;
                    top: 20px !important;
                    right: 20px !important;
                    z-index: 999999 !important;
                    pointer-events: none;
                `;
            }
            
            this.toastContainer.appendChild(toast);
            
            // Auto remove after duration
            const timeoutId = setTimeout(() => {
                toast.classList.add('removing');
                setTimeout(() => toast.remove(), 300);
            }, duration);
            
            // Clear timeout on manual close
            closeBtn.addEventListener('click', () => clearTimeout(timeoutId), { once: true });
        });
    }

    showSuccessToast(message, title = 'Başarılı!') {
        this.showToast('success', title, message);
    }

    showErrorToast(message, title = 'Hata!') {
        this.showToast('error', title, message);
    }

    showWarningToast(message, title = 'Uyarı!') {
        this.showToast('warning', title, message);
    }

    showInfoToast(message, title = 'Bilgi') {
        this.showToast('info', title, message);
    }

    setupEventListeners() {
        // Ticket group ve topic event listener'ları
        const ticketGroupSelect = document.getElementById('ticketGroup');
        const ticketTopicSelect = document.getElementById('ticketTopic');
        
        if (ticketGroupSelect) {
            ticketGroupSelect.addEventListener('change', this.handleTicketGroupChange.bind(this));
        }
        
        if (ticketTopicSelect) {
            ticketTopicSelect.addEventListener('change', this.handleTicketTopicChange.bind(this));
        }
        
        // Other kullanıcı tipi için konu seçimi
        const nonStudentTicketTopic = document.getElementById('nonStudentTicketTopic');
        if (nonStudentTicketTopic) {
            nonStudentTicketTopic.addEventListener('change', this.handleNonStudentTicketTopicChange.bind(this));
        }
        
        // Artık grup seçimi yok; tüm konuları yükle (default: student)
        this.loadAllTicketTopics('student');
        // User type selection
        const userTypeInputs = document.querySelectorAll('input[name="userType"]');
        userTypeInputs.forEach(input => {
            input.addEventListener('change', this.handleUserTypeChange.bind(this));
        });

        // Öğrenci numarası input event
        const ogrenciNoInput = document.getElementById('ogrenciNo');
        if (ogrenciNoInput) {
            ogrenciNoInput.addEventListener('input', this.handleOgrenciNoInput.bind(this));
            ogrenciNoInput.addEventListener('blur', this.handleOgrenciNoBlur.bind(this));
        }

        // Telefon inputları için formatlama
        const nonStudentPhoneInput = document.getElementById('nonStudentPhone');
        if (nonStudentPhoneInput) {
            const debouncedNonStudentFormatter = debounce(() => this.handlePhoneInput(nonStudentPhoneInput), 120);
            nonStudentPhoneInput.addEventListener('input', debouncedNonStudentFormatter);
            nonStudentPhoneInput.addEventListener('blur', () => this.handlePhoneBlur(nonStudentPhoneInput, 'nonStudentPhone'));
        }
        const studentPhoneInput = document.getElementById('telefon');
        if (studentPhoneInput) {
            const debouncedStudentFormatter = debounce(() => this.handlePhoneInput(studentPhoneInput), 120);
            studentPhoneInput.addEventListener('input', debouncedStudentFormatter);
            studentPhoneInput.addEventListener('blur', () => this.handlePhoneBlur(studentPhoneInput, 'telefon'));
        }

        // IBAN input event
        const ibanInput = document.getElementById('ibanInput');
        if (ibanInput) {
            ibanInput.addEventListener('input', (e) => this.handleIBANInput(e.target));
            ibanInput.addEventListener('blur', (e) => this.handleIBANBlur(e.target, 'ibanInput'));
        }

        // Form submit event
        const form = document.getElementById('helpForm');
        if (form) {
            form.addEventListener('submit', this.handleFormSubmit.bind(this));
        }
        // Fallback: bazı temalarda submit olayını yutan scriptler olabilir; butona da dinleyici ekle
        const submitBtn = document.getElementById('submitBtn');
        if (submitBtn && form) {
            submitBtn.addEventListener('click', (e) => {
                // Form submit tetikleyicisi
                if (!this.isLoading) {
                    e.preventDefault();
                    this.handleFormSubmit(e);
                }
            });
        }

        // File upload events
        this.setupFileUploadEvents();

        // Search events
        const searchInput = document.getElementById('searchOgrenciNo');
        if (searchInput) {
            searchInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    this.searchRequests();
                }
            });
        }

        const resetPasswordBtn = document.getElementById('resetPasswordBtn');
        if (resetPasswordBtn) {
            resetPasswordBtn.addEventListener('click', () => this.handleResetPassword());
        }

        const sendVerificationCodeBtn = document.getElementById('sendVerificationCodeBtn');
        if (sendVerificationCodeBtn) {
            sendVerificationCodeBtn.addEventListener('click', () => this.handleSendVerificationCodeClick());
        }

        const showResultsBtn = document.getElementById('showRequestResultsBtn');
        if (showResultsBtn) {
            showResultsBtn.addEventListener('click', (event) => {
                event.preventDefault();
                showRequestResults();
            });
        }

        const downloadHandbookBtn = document.getElementById('downloadHandbookBtn');
        if (downloadHandbookBtn) {
            downloadHandbookBtn.addEventListener('click', (event) => {
                event.preventDefault();
                downloadHandbook();
            });
        }

        const removeFileBtn = document.getElementById('removeFileBtn');
        if (removeFileBtn) {
            removeFileBtn.addEventListener('click', (event) => {
                event.preventDefault();
                this.removeFile();
            });
        }

        const privacyLink = document.getElementById('privacyModalLink');
        if (privacyLink) {
            privacyLink.addEventListener('click', (event) => {
                event.preventDefault();
                showPrivacyModal();
            });
        }

        const showEmailVerificationModalBtn = document.getElementById('showEmailVerificationModalBtn');
        if (showEmailVerificationModalBtn) {
            showEmailVerificationModalBtn.addEventListener('click', (event) => {
                event.preventDefault();
                showEmailVerificationModal();
            });
        }
    }

    collectExamElements() {
        return {
            section: document.getElementById('examExcuseSection'),
            meta: {
                count: document.getElementById('examCourseCount'),
                year: document.getElementById('examAcademicYear'),
                term: document.getElementById('examTerm')
            },
            body: document.getElementById('examGridBody'),
            emptyState: document.getElementById('examEmptyState'),
            error: document.getElementById('examSelectionError'),
            helper: document.getElementById('examSelectionHelper'),
            scoreHeader: document.querySelector('[data-score-header]')
        };
    }

    createEmptyExamRequestState() {
        if (this.examManager) {
            return this.examManager.createEmptyExamRequestState();
        }
        return {
            grades: [],
            meta: {
                count: null,
                academic_year: '',
                term: ''
            },
            selections: {},
            selectedCourseKey: null
        };
    }

    async loadAllTicketTopics(userType = 'student') {
        try {
            // Kullanıcı tipine göre konuları yükle
            const url = `${this.apiBaseUrl}/ticket-topics-all?user_type=${userType}`;
            const response = await this.fetchWithAuth(url);
            const data = await response.json();
            if (data.success) {
                // data: [{id: KonuID, grup_id: GrupID, name: Konu}]
                this.ticketTopics = data.data;
                this.populateTicketTopics(this.ticketTopics, userType);
            }
        } catch (error) {
            console.error('Tüm konular yüklenemedi:', error);
        }
    }

    async handleTicketGroupChange(e) {
        // Grup seçimi kaldırıldığı için bu fonksiyon artık sadece diğer alanları sıfırlar
        const topicSelect = document.getElementById('ticketTopic');
        if (topicSelect) {
            topicSelect.innerHTML = '<option value="">Konu seçiniz...</option>';
            this.populateTicketTopics(this.ticketTopics || []);
        }
    }

    // loadTicketTopics artık kullanılmıyor (grup yok)

    populateTicketTopics(topics, userType = 'student') {
        // Öğrenci için ticketTopic, Other için nonStudentTicketTopic
        const selectId = userType === 'student' ? 'ticketTopic' : 'nonStudentTicketTopic';
        const select = document.getElementById(selectId);
        if (select) {
            select.innerHTML = '<option value="">Konu seçiniz...</option>';
            topics.forEach(topic => {
                const option = document.createElement('option');
                option.value = topic.id; // Seçimde KonuID tutulur
                option.dataset.grupId = topic.grup_id; // GrupID'yi data attribute olarak sakla
                option.textContent = topic.name; // Açıklamada konu adı gösterilir
                select.appendChild(option);
            });
            
            // Tom Select ile arama özelliği ekle
            this.initializeTopicSelect(selectId, userType);
        }
    }
    
    initializeTopicSelect(selectId, userType) {
        if (typeof TomSelect === 'undefined') {
            return; // Tom Select yüklenmemişse devam etme
        }
        
        const selectElement = document.getElementById(selectId);
        if (!selectElement) return;
        
        // Eğer zaten Tom Select ile başlatılmışsa, önce destroy et
        if (userType === 'student' && this.ticketTopicTomSelect) {
            this.ticketTopicTomSelect.destroy();
            this.ticketTopicTomSelect = null;
        } else if (userType !== 'student' && this.nonStudentTopicTomSelect) {
            this.nonStudentTopicTomSelect.destroy();
            this.nonStudentTopicTomSelect = null;
        }
        
        // Tom Select'i başlat
        const tomSelectOptions = {
            placeholder: this.languageManager?.getTranslation('topicSearch.placeholder') || 'Konu arayınız',
            allowEmptyOption: true,
            searchField: ['text'],
            maxOptions: null,
            dropdownParent: 'body',
            plugins: ['clear_button', 'dropdown_input'],
            dropdownInput: true,
            searchPlaceholder: this.languageManager?.getTranslation('topicSearch.placeholder') || 'Konu arayınız',
            render: {
                no_results: (data, escape) => {
                    const noResultsMsg = this.languageManager?.getTranslation('topicSearch.noResults') || 'Aradığınız konu bulunamadı.';
                    return `<div class="no-results"><i class="fas fa-search me-2"></i>${noResultsMsg}</div>`;
                },
                option: function(data, escape) {
                    return '<div class="option-item"><span>' + escape(data.text) + '</span></div>';
                }
            },
            onChange: (value) => {
                // Değişiklik olduğunda handleTicketTopicChange'i tetikle
                const event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);
            },
            onInitialize: function() {
                // Wrapper'a class ekle
                this.wrapper.classList.add('topic-select-wrapper');
                // İlk yüklemede placeholder'ı ayarla (dropdown henüz açık değilse)
                const self = this;
                setTimeout(() => {
                    self.updateSearchPlaceholder();
                }, 100);
            },
            onDropdownOpen: function() {
                // Dropdown açıldığında arama kutusunun placeholder'ını güncelle
                const self = this;
                // Input henüz render edilmemiş olabilir, kısa bir gecikme ile dene
                setTimeout(() => {
                    self.updateSearchPlaceholder();
                }, 50);
            }
        };
        
        // Tom Select instance'ına app referansı ve placeholder güncelleme fonksiyonu ekle
        const appRef = this;
        tomSelectOptions.updateSearchPlaceholder = function() {
            // Dropdown içindeki arama kutusunu bul ve placeholder'ı güncelle
            if (this.dropdown) {
                // Farklı selector'ları dene (Tom Select'in farklı versiyonları için)
                let searchInput = this.dropdown.querySelector('.ts-dropdown-content input[type="text"]');
                if (!searchInput) {
                    searchInput = this.dropdown.querySelector('.ts-dropdown-content input');
                }
                if (!searchInput) {
                    searchInput = this.dropdown.querySelector('input[type="text"]');
                }
                if (!searchInput) {
                    searchInput = this.dropdown.querySelector('input');
                }
                if (searchInput) {
                    const placeholderText = appRef.languageManager?.getTranslation('topicSearch.placeholder') || 'Konu arayınız';
                    searchInput.placeholder = placeholderText;
                    // Attribute olarak da ayarla (bazı durumlarda gerekli)
                    searchInput.setAttribute('placeholder', placeholderText);
                }
            }
        };
        
        if (userType === 'student') {
            this.ticketTopicTomSelect = new TomSelect(selectElement, tomSelectOptions);
            // Instance'a updateSearchPlaceholder metodunu bağla
            if (this.ticketTopicTomSelect && tomSelectOptions.updateSearchPlaceholder) {
                this.ticketTopicTomSelect.updateSearchPlaceholder = tomSelectOptions.updateSearchPlaceholder.bind(this.ticketTopicTomSelect);
            }
        } else {
            this.nonStudentTopicTomSelect = new TomSelect(selectElement, tomSelectOptions);
            // Instance'a updateSearchPlaceholder metodunu bağla
            if (this.nonStudentTopicTomSelect && tomSelectOptions.updateSearchPlaceholder) {
                this.nonStudentTopicTomSelect.updateSearchPlaceholder = tomSelectOptions.updateSearchPlaceholder.bind(this.nonStudentTopicTomSelect);
            }
        }
    }

    async handleTicketTopicChange(e) {
        const topicSelect = e.target;
        // Tom Select kullanılıyorsa value'yu ondan al
        let topicId = null;
        let selectedOption = null;
        
        if (this.currentUserType === 'student' && this.ticketTopicTomSelect) {
            const value = this.ticketTopicTomSelect.getValue();
            topicId = value ? parseInt(value, 10) : null;
            // Option'ı bul
            if (topicId) {
                selectedOption = Array.from(topicSelect.options).find(opt => parseInt(opt.value, 10) === topicId);
            }
        } else if (this.currentUserType !== 'student' && this.nonStudentTopicTomSelect) {
            const value = this.nonStudentTopicTomSelect.getValue();
            topicId = value ? parseInt(value, 10) : null;
            if (topicId) {
                selectedOption = Array.from(topicSelect.options).find(opt => parseInt(opt.value, 10) === topicId);
            }
        } else {
            // Normal select
            selectedOption = topicSelect.options[topicSelect.selectedIndex];
            topicId = topicSelect.value ? parseInt(topicSelect.value, 10) : null;
        }
        
        const groupId = selectedOption ? parseInt(selectedOption.dataset.grupId || '', 10) : NaN;
        this.selectedTopicGroupId = Number.isNaN(groupId) ? null : groupId;
        
        // Yatay Geçiş kontrolü (öğrenci için 8001, other için 1003)
        if (this.currentUserType === 'student' && this.isVerified && topicId === 8001) {
            this.handleHorizontalTransferSection(true);
        } else {
            this.handleHorizontalTransferSection(false);
        }
        
        // IBAN bölümü kontrolü (öğrenci için konu 4002)
        if (this.currentUserType === 'student' && this.isVerified && topicId === 4002) {
            this.handleIBANSection(true);
        } else {
            this.handleIBANSection(false);
        }
        
        // Özel neden seçenekleri (öğrenci için konu 1003)
        if (this.currentUserType === 'student' && topicId === 1003) {
            this.handleStudentReason1003Section(true);
        } else {
            this.handleStudentReason1003Section(false);
        }
        
        // Kayıt dondurma nedenleri (öğrenci için konu 1004)
        if (this.currentUserType === 'student' && topicId === 1004) {
            this.handleStudentFreezeSection(true);
        } else {
            this.handleStudentFreezeSection(false);
        }
        
        // Muafiyet başvurusu (öğrenci için konu 1006)
        if (this.currentUserType === 'student' && topicId === 1006) {
            this.handleStudentExemptionSection(true);
        } else {
            this.handleStudentExemptionSection(false);
        }
        
        // Üç ders başvurusu (öğrenci için konu 1007)
        if (this.currentUserType === 'student' && topicId === 1007) {
            this.handleStudentThreeCourseSection(true);
        } else {
            this.handleStudentThreeCourseSection(false);
        }
        
        // Çift Anadal/Yandal (öğrenci için konu 1008)
        if (this.currentUserType === 'student' && topicId === 1008) {
            this.handleStudentDoubleMinorSection(true);
        } else {
            this.handleStudentDoubleMinorSection(false);
        }
        
        // Sınav İtiraz bölümü kontrolü (grup ID 2)
        if (this.currentUserType === 'student' && this.isVerified && this.selectedTopicGroupId === 2) {
            this.handleExamAppealSection(true);
        } else {
            this.handleExamAppealSection(false);
        }
        
        await this.examManager.handleTopicChange({
            selectedGroupId: this.selectedTopicGroupId,
            selectedOption,
            userType: this.currentUserType,
            isVerified: this.isVerified,
            studentData: this.currentStudentData
        });
    }

    async handleNonStudentTicketTopicChange(e) {
        const topicSelect = e.target;
        const selectedOption = topicSelect.options[topicSelect.selectedIndex];
        const topicId = topicSelect.value ? parseInt(topicSelect.value, 10) : null;
        
        // 1003 konu ID kontrolü - Yatay Geçiş (Other kullanıcı için)
        if (this.currentUserType === 'non-student' && topicId === 1003) {
            this.handleNonStudentHorizontalTransferSection(true);
        } else {
            this.handleNonStudentHorizontalTransferSection(false);
        }
    }

    async loadExamDataForCurrentStudent(forceRefresh = false) {
        await this.examManager.loadExamDataForCurrentStudent(forceRefresh);
    }

    async fetchAndRenderExamData(studentNumber, forceRefresh = false) {
        await this.examManager.fetchAndRenderExamData(studentNumber, forceRefresh);
    }

    normalizeExamData(rawData) {
        return this.examManager.normalizeExamData(rawData);
    }

    applyExamData(normalizedData) {
        this.examManager.applyExamData(normalizedData);
    }

    buildCourseKey(grade, index = 0) {
        return this.examManager.buildCourseKey(grade, index);
    }

    determineDefaultExamType(grade) {
        return this.examManager.determineDefaultExamType(grade);
    }

    renderExamSection() {
        this.examManager.renderExamSection();
    }

    handleExamCourseSelection(courseKey) {
        this.examManager.handleExamCourseSelection(courseKey);
    }

    handleExamTypeChange(courseKey, examType) {
        this.examManager.handleExamTypeChange(courseKey, examType);
    }

    highlightSelectedExamRow() {
        this.examManager.highlightSelectedExamRow();
    }

    showExamSelectionError(message) {
        this.examManager.showExamSelectionError(message);
    }

    clearExamSelectionError() {
        this.examManager.clearExamSelectionError();
    }

    validateExamSelection() {
        return this.examManager.validateExamSelection();
    }

    appendExamSelectionToFormData(formData, selectedTopic) {
        this.examManager.appendExamSelectionToFormData(formData, selectedTopic);
    }

    getTopicById(konuId) {
        return this.examManager.getTopicById(konuId, this.ticketTopics);
    }

    shouldLoadExamSectionForCurrentSelection() {
        return this.examManager.shouldLoadExamSectionForCurrentSelection();
    }

    async handleExamSelectionPostVerification() {
        await this.examManager.handleExamSelectionPostVerification();
    }

    showGlobalBlockingOverlay(message) {
        this.examManager.showBlockingOverlay(message);
    }

    hideGlobalBlockingOverlay() {
        this.examManager.hideBlockingOverlay();
    }

    scrollToElement(element) {
        ExamExcuseManager.scrollToElement(element);
    }

    resetExamSection(forceHide = false) {
        this.examManager.reset(forceHide);
    }

    escapeHtml(value) {
        return ExamExcuseManager.escapeHtml(value);
    }

    handleUserTypeChange(e) {
        const userType = e.target.value;
        this.currentUserType = userType;
        this.isVerified = false;
        this.resetStudentVerificationState();
        this.setResetPasswordAvailability(false);
        this.examManager.handleUserTypeChange(userType);
        
        // Hide all flow sections first
        const studentFlow = document.getElementById('studentFlow');
        const nonStudentFlow = document.getElementById('nonStudentFlow');
        const verifiedStudentInfo = document.getElementById('verifiedStudentInfo');
        const commonFormFields = document.getElementById('commonFormFields');
        const studentTicketSection = document.getElementById('studentTicketSection');
        
        const nonStudentTicketSection = document.getElementById('nonStudentTicketSection');
        
        if (studentFlow) studentFlow.classList.add('d-none');
        if (nonStudentFlow) nonStudentFlow.classList.add('d-none');
        if (verifiedStudentInfo) verifiedStudentInfo.classList.add('d-none');
        if (commonFormFields) commonFormFields.classList.add('d-none');
        if (studentTicketSection) studentTicketSection.classList.add('d-none');
        if (nonStudentTicketSection) nonStudentTicketSection.classList.add('d-none');
        // Yatay geçiş bölümlerini gizle
        this.handleHorizontalTransferSection(false);
        this.handleNonStudentHorizontalTransferSection(false);
        // 1003 neden bölümünü gizle
        this.handleStudentReason1003Section(false);
        // 1004 kayıt dondurma bölümünü gizle
        this.handleStudentFreezeSection(false);
        // 1006 muafiyet bölümünü gizle
        this.handleStudentExemptionSection(false);
        // 1007 üç ders bölümünü gizle
        this.handleStudentThreeCourseSection(false);
        // IBAN bölümünü gizle
        this.handleIBANSection(false);
        this.setResetPasswordAvailability(false);
        
        // Show appropriate flow based on selection
        if (userType === 'student') {
            // Öğrenci için önce doğrulama akışı, kod başarılı olunca ortak alanlar gösterilecek
            if (studentFlow) studentFlow.classList.remove('d-none');
            // Öğrenci konularını yükle
            this.loadAllTicketTopics('student');
        } else if (userType === 'non-student') {
            // Diğer kullanıcı için direkt ortak alanları göster
            if (nonStudentFlow) nonStudentFlow.classList.remove('d-none');
            if (commonFormFields) commonFormFields.classList.remove('d-none');
            // Other kullanıcı için konu seçimi bölümünü göster
            if (nonStudentTicketSection) nonStudentTicketSection.classList.remove('d-none');
            // Other kullanıcı konularını yükle
            this.loadAllTicketTopics('non-student');
        }
        
        // Smooth scroll to the selected flow
        setTimeout(() => {
            const targetElement = userType === 'student' ? studentFlow : nonStudentFlow;
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
        }, 100);
    }

    setupFileUploadEvents() {
        const fileInput = document.getElementById('dosya');
        const fileUploadArea = document.getElementById('fileUploadArea');
        const fileInfo = document.getElementById('fileInfo');

        if (fileInput && fileUploadArea) {
            // Click event
            fileUploadArea.addEventListener('click', () => {
                fileInput.click();
            });

            // File change event
            fileInput.addEventListener('change', (e) => {
                this.handleFileSelect(e.target.files[0]);
            });

            // Drag and drop events
            fileUploadArea.addEventListener('dragover', (e) => {
                e.preventDefault();
                fileUploadArea.classList.add('dragover');
            });

            fileUploadArea.addEventListener('dragleave', () => {
                fileUploadArea.classList.remove('dragover');
            });

            fileUploadArea.addEventListener('drop', (e) => {
                e.preventDefault();
                fileUploadArea.classList.remove('dragover');
                const files = e.dataTransfer.files;
                if (files.length > 0) {
                    this.handleFileSelect(files[0]);
                }
            });
        }
    }

    setupVerificationModal() {
        this.openVerificationButton = null;
        this.sendVerificationButton = document.getElementById('sendVerificationCodeBtn');
        this.resendVerificationButton = document.getElementById('resendVerificationCodeBtn');
        const modalElement = document.getElementById('studentVerificationModal');

        if (this.openVerificationButton) {
            this.openVerificationButton.addEventListener('click', () => {
        const email = this.currentStudentData ? this.currentStudentData.profil_email : '';
        const studentNo = this.currentStudentData ? this.currentStudentData.ogrenci_no : '';
        this.openStudentVerificationModal(email, studentNo);
            });
        }

        if (!modalElement) {
            this.verificationInputs = [];
            this.studentVerifyButton = null;
            return;
        }

        this.verificationInputs = Array.from(modalElement.querySelectorAll('.verification-code-input'));
        this.studentVerifyButton = modalElement.querySelector('#studentVerifyCodeBtn');

        modalElement.addEventListener('shown.bs.modal', () => {
            this.studentVerificationModalOpen = true;
            if (this.verificationInputs.length) {
                this.verificationInputs[0].focus();
                this.verificationInputs[0].select();
            }
        });

        modalElement.addEventListener('hidden.bs.modal', () => {
            this.studentVerificationModalOpen = false;
            this.clearVerificationInputs();
            this.updateVerificationButtonState();
            const statusEl = document.getElementById('studentVerificationStatus');
            if (statusEl) {
                statusEl.textContent = '';
            }
        });

        this.verificationInputs.forEach((input, index) => {
            input.addEventListener('input', (event) => this.handleVerificationInput(event, index));
            input.addEventListener('keydown', (event) => this.handleVerificationKeyDown(event, index));
            input.addEventListener('paste', (event) => this.handleVerificationPaste(event, index));
        });

        const form = document.getElementById('studentVerificationForm');
        if (form) {
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                verifyStudentCode();
            });
        }

        if (this.resendVerificationButton) {
            this.resendVerificationButton.addEventListener('click', () => {
                if (this.currentStudentData) {
                    this.lastVerificationSentFor = this.currentStudentData.ogrenci_no;
                    this.sendVerificationCodeAutomatically(this.currentStudentData.ogrenci_no, this.currentStudentData.profil_email);
                }
            });
        }

        this.updateVerificationButtonState();
    }

    handleSendVerificationCodeClick() {
        if (!this.currentStudentData || !this.currentStudentData.ogrenci_no) {
            const warningTitle = this.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.languageManager?.getTranslation('error.studentNotFound') || 'Lütfen geçerli bir öğrenci numarası giriniz.';
            this.showWarningToast(warningMsg, warningTitle);
            return;
        }

        const button = this.sendVerificationButton;
        if (button) {
            button.disabled = true;
            if (!button.dataset.originalContent) {
                button.dataset.originalContent = button.innerHTML;
            }
            const loadingText = this.languageManager?.getTranslation('loading.sendingCode') || 'Kod Gönderiliyor';
            button.innerHTML = `<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> ${loadingText}`;
        }

        this.sendVerificationCodeAutomatically(this.currentStudentData.ogrenci_no, this.currentStudentData.profil_email)
            .finally(() => {
                if (button) {
                    button.disabled = false;
                    if (button.dataset.originalContent) {
                        button.innerHTML = button.dataset.originalContent;
                    }
                }
            });

        this.openStudentVerificationModal(this.currentStudentData.profil_email, this.currentStudentData.ogrenci_no);
    }

    setResetPasswordLoading(isLoading) {
        const resetBtn = document.getElementById('resetPasswordBtn');
        if (!resetBtn) return;

        if (isLoading) {
            if (!resetBtn.dataset.originalContent) {
                resetBtn.dataset.originalContent = resetBtn.innerHTML;
            }
            resetBtn.disabled = true;
            resetBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> İşlem Yapılıyor...</span>';
        } else {
            resetBtn.disabled = false;
            if (resetBtn.dataset.originalContent) {
                resetBtn.innerHTML = resetBtn.dataset.originalContent;
            }
        }
    }

    setResetPasswordAvailability(isVisible) {
        const cardRow = document.getElementById('resetPasswordCard');
        const resetBtn = document.getElementById('resetPasswordBtn');

        if (cardRow) {
            cardRow.classList.toggle('d-none', !isVisible);
        }

        if (resetBtn) {
            resetBtn.disabled = !isVisible;
        }
    }

    async handleResetPassword() {
        const resetBtn = document.getElementById('resetPasswordBtn');
        if (!resetBtn) return;

        if (this.currentUserType !== 'student') {
            const warningTitle = this.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.languageManager?.getTranslation('warning.studentOnly') || 'Bu işlem yalnızca öğrenci doğrulaması sonrası yapılabilir.';
            this.showWarningToast(warningMsg, warningTitle);
            return;
        }

        if (!this.isVerified || !this.currentStudentData) {
            const warningTitle = this.languageManager?.getTranslation('warning.title') || 'Uyarı';
            const warningMsg = this.languageManager?.getTranslation('warning.verificationRequired') || 'Şifre sıfırlamak için önce öğrenci doğrulamasını tamamlayınız.';
            this.showWarningToast(warningMsg, warningTitle);
            return;
        }

        const ogrenciNo = (this.currentStudentData.ogrenci_no || '').toString().trim();
        if (!ogrenciNo) {
            const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
            const errorMsg = this.languageManager?.getTranslation('error.studentNumberNotFound') || 'Öğrenci numarası bulunamadı. Lütfen tekrar deneyiniz.';
            this.showErrorToast(errorMsg, errorTitle);
            return;
        }

        const infoTitle = this.languageManager?.getTranslation('info.passwordResetStartedTitle') || 'Şifre Sıfırlama Başlatıldı';
        const infoMsg = this.languageManager?.getTranslation('info.passwordResetStarted') || 'OBIS giriş şifreniz doğrulanmış öğrenci kimliğiniz kullanılarak güvenli şekilde sıfırlanacaktır. Lütfen işlemin tamamlanmasını bekleyiniz.';
        this.showInfoToast(infoMsg, infoTitle);
        this.setResetPasswordLoading(true);

        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ number: ogrenciNo })
            });

            let data = null;
            try {
                data = await response.json();
            } catch (jsonError) {
                data = null;
            }

            const success = response.ok && data?.success;
            if (success) {
                const baseMessage = data?.message || this.languageManager?.getTranslation('error.passwordResetSuccess') || 'Şifre sıfırlama işlemi başarıyla gerçekleştirildi.';
                const redirectMsg = this.languageManager?.getTranslation('error.redirecting') || 'İlgili sayfaya yönlendiriliyorsunuz, lütfen bekleyiniz...';
                const successTitle = this.languageManager?.getTranslation('success.title') || 'Başarılı!';
                const finalMessage = `${baseMessage.trim()} ${redirectMsg}`;
                this.showSuccessToast(finalMessage, successTitle);
                setTimeout(() => {
                    window.location.href = 'https://obis.nisantasi.edu.tr/UniFrame/lostpassword/default.aspx';
                }, 2000);
            } else {
                const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
                const errorMessage = data?.message || this.languageManager?.getTranslation('error.passwordResetFailed') || 'Şifre sıfırlama işlemi başarısız oldu. Lütfen daha sonra tekrar deneyiniz.';
                this.showErrorToast(errorMessage, errorTitle);
            }
        } catch (error) {
            console.error('Şifre sıfırlama hatası:', error);
            const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
            const errorMsg = this.languageManager?.getTranslation('error.passwordResetFailed') || 'Şifre sıfırlama işlemi başarısız oldu. Lütfen daha sonra tekrar deneyiniz.';
            this.showErrorToast(errorMsg, errorTitle);
        } finally {
            this.setResetPasswordLoading(false);
        }
    }

    handleVerificationInput(event, index) {
        const input = event.target;
        const value = (input.value || '').replace(/\D/g, '');
        input.value = value.slice(0, 1);

        if (value.length > 1) {
            this.fillVerificationInputsFromString(value.slice(1), index + 1);
        } else if (value.length === 0 && index > 0) {
            // keep focus on current box when deleting
        }

        if (value.length && index < this.verificationInputs.length - 1) {
            this.verificationInputs[index + 1].focus();
            this.verificationInputs[index + 1].select();
        }

        this.updateVerificationButtonState();
    }

    handleVerificationKeyDown(event, index) {
        const input = event.target;
        if (event.key === 'Backspace' && !input.value && index > 0) {
            event.preventDefault();
            this.verificationInputs[index - 1].value = '';
            this.verificationInputs[index - 1].focus();
            this.updateVerificationButtonState();
        } else if (event.key === 'ArrowLeft' && index > 0) {
            event.preventDefault();
            this.verificationInputs[index - 1].focus();
        } else if (event.key === 'ArrowRight' && index < this.verificationInputs.length - 1) {
            event.preventDefault();
            this.verificationInputs[index + 1].focus();
        }
    }

    handleVerificationPaste(event, index) {
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData).getData('text');
        const digits = (paste || '').replace(/\D/g, '');
        if (!digits) {
            return;
        }
        this.fillVerificationInputsFromString(digits, index);
        this.updateVerificationButtonState();
    }

    fillVerificationInputsFromString(value, startIndex = 0) {
        const chars = value.split('');
        for (let i = 0; i < chars.length; i++) {
            const targetIndex = startIndex + i;
            if (targetIndex >= this.verificationInputs.length) {
                break;
            }
            this.verificationInputs[targetIndex].value = chars[i];
        }
        const nextIndex = startIndex + chars.length;
        if (nextIndex >= 0 && nextIndex < this.verificationInputs.length) {
            this.verificationInputs[nextIndex].focus();
            this.verificationInputs[nextIndex].select();
        }
    }

    clearVerificationInputs() {
        if (!this.verificationInputs) return;
        this.verificationInputs.forEach(input => {
            input.value = '';
        });
    }

    updateVerificationButtonState() {
        if (!this.studentVerifyButton) {
            return;
        }
        const isComplete = this.verificationInputs && this.verificationInputs.every(input => (input.value || '').trim().length === 1);
        this.studentVerifyButton.disabled = !isComplete;
        if (!isComplete) {
            this.studentVerifyButton.innerHTML = '<i class="fas fa-check me-2"></i>Doğrula (Verify)';
        }
    }

    getVerificationCodeValue() {
        if (!this.verificationInputs) return '';
        return this.verificationInputs.map(input => (input.value || '').trim()).join('');
    }

    openStudentVerificationModal(email, studentNo) {
        const modalElement = document.getElementById('studentVerificationModal');
        if (!modalElement) return;

        const emailSpan = modalElement.querySelector('.verification-target-email');
        if (emailSpan) {
            emailSpan.textContent = email || '-';
        }

        const infoText = document.getElementById('studentVerificationInfo');
        if (infoText) {
            infoText.textContent = email
                ? `Öğrenci e-posta adresinize (${email}) 6 haneli doğrulama kodunu göndermek için "Kod Gönder" butonunu kullanabilirsiniz. (You can request the 6-digit verification code to your student email (${email}) by pressing the "Send Code" button.)`
                : 'Öğrenci e-posta adresinize doğrulama kodu göndermek için "Kod Gönder" butonunu kullanabilirsiniz.';
        }
        if (this.sendVerificationButton) {
            this.sendVerificationButton.classList.remove('d-none');
            this.sendVerificationButton.disabled = false;
        }

        if (this.studentVerificationModalOpen) {
            return;
        }

        this.clearVerificationInputs();
        this.updateVerificationButtonState();

        const statusEl = document.getElementById('studentVerificationStatus');
        if (statusEl) {
            statusEl.textContent = '';
        }

        const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement, { backdrop: 'static', keyboard: false });
        modalInstance.show();
        this.studentVerificationModalInstance = modalInstance;
        this.studentVerificationModalOpen = true;

        if (this.verificationInputs.length) {
            setTimeout(() => {
                this.verificationInputs[0].focus();
                this.verificationInputs[0].select();
            }, 150);
        }

        if (this.openVerificationButton) {
            this.openVerificationButton.classList.remove('d-none');
        }

        if (this.sendVerificationButton) {
            this.sendVerificationButton.classList.remove('d-none');
            this.sendVerificationButton.disabled = false;
        }

        const studentNoInput = document.getElementById('ogrenciNo');
        if (studentNoInput) {
            studentNoInput.disabled = false;
            studentNoInput.classList.remove('is-valid');
        }
    }

    initializeForm() {
        // Form validation
        const form = document.getElementById('helpForm');
        if (form) {
            form.classList.add('was-validated');
        }
    }

    hideLoadingSpinner() {
        const spinner = document.getElementById('loadingSpinner');
        if (spinner) {
            setTimeout(() => {
                spinner.classList.add('hidden');
            }, 500);
        }
    }

    showLoading() {
        this.isLoading = true;
        const submitBtn = document.getElementById('submitBtn');
        if (submitBtn) {
            submitBtn.disabled = true;
            const loadingText = this.languageManager?.getTranslation('loading.submittingForm') || 'Gönderiliyor...';
            submitBtn.innerHTML = `<i class="fas fa-spinner fa-spin me-2"></i>${loadingText}`;
        }
    }

    hideLoading() {
        this.isLoading = false;
        const submitBtn = document.getElementById('submitBtn');
        if (submitBtn) {
            submitBtn.disabled = false;
            const submitText = this.languageManager?.getTranslation('loading.submitButton') || 'Formu Gönder';
            submitBtn.innerHTML = `<i class="fas fa-paper-plane me-2"></i>${submitText}`;
        }
    }

    async handleOgrenciNoInput(e) {
        const raw = e.target.value;
        const value = raw.replace(/\D/g, '');
        e.target.value = value;

        if (value.length >= 11) {
            if (value !== this.lastFetchedStudentNo) {
                // Mail doğrulamasından önce sadece email adresini oluştur (backend'e istek atmadan)
                this.fetchStudentEmail(value);
            }
            if (this.currentStudentData && this.currentStudentData.ogrenci_no === value) {
                this.showVerificationControls(this.currentStudentData.profil_email, value);
            }
        } else {
            this.resetStudentVerificationState();
        }
    }

    async handleOgrenciNoBlur(e) {
        const raw = e.target.value;
        const value = raw.replace(/\D/g, '');
        if (value.length >= 11) {
            if (value !== this.lastFetchedStudentNo) {
                // Mail doğrulamasından önce sadece email adresini oluştur (backend'e istek atmadan)
                this.fetchStudentEmail(value);
            }
            if (this.currentStudentData && this.currentStudentData.ogrenci_no === value) {
                this.showVerificationControls(this.currentStudentData.profil_email, value);
            } else {
                this.resetStudentVerificationState();
            }
        } else if (!value.length) {
            this.resetStudentVerificationState();
        }
    }

    generateStudentEmail(ogrenciNo) {
        // Öğrenci numarasından standart email adresini oluştur (backend'e istek atmadan)
        // Format: {ogrenci_no}@std.nisantasi.edu.tr
        if (!ogrenciNo || ogrenciNo.length < 5) {
            return null;
        }
        return `${ogrenciNo.trim()}@std.nisantasi.edu.tr`;
    }

    fetchStudentEmail(ogrenciNo) {
        // Mail doğrulamasından önce sadece email adresini oluştur (backend'e istek atmadan)
        // Standart format kullanılıyor: {ogrenci_no}@std.nisantasi.edu.tr
        const email = this.generateStudentEmail(ogrenciNo);
        
        if (email) {
            // Sadece email adresini sakla (güvenlik: diğer bilgiler gizli)
            this.currentStudentData = {
                ogrenci_no: ogrenciNo,
                profil_email: email
            };
            this.lastFetchedStudentNo = ogrenciNo;
        } else {
            this.currentStudentData = null;
            this.lastFetchedStudentNo = null;
        }
    }

    async fetchStudentInfo(ogrenciNo) {
        try {
            this.showLoading();
            
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/student/${ogrenciNo}`);
            const data = await response.json();

            if (data.success) {
                this.currentStudentData = data.data;
                this.lastFetchedStudentNo = ogrenciNo;
            } else {
                this.currentStudentData = null;
                this.lastFetchedStudentNo = null;
                const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
                const errorMsg = this.languageManager?.getTranslation('error.studentNotFound') || 'Öğrenci bulunamadı. Lütfen geçerli bir öğrenci numarası giriniz.';
                this.showError(errorTitle, errorMsg);
            }
        } catch (error) {
            console.error('Öğrenci bilgisi getirme hatası:', error);
            this.currentStudentData = null;
            this.lastFetchedStudentNo = null;
            const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
            const errorMsg = this.languageManager?.getTranslation('error.studentInfoLoadFailed') || 'Öğrenci bilgileri yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.';
            this.showError(errorTitle, errorMsg);
        } finally {
            this.hideLoading();
        }
    }

	async sendVerificationCodeAutomatically(ogrenciNo, email) {
        if (!ogrenciNo || !email) {
            return;
        }

        const infoText = document.getElementById('emailInfoText');
        const modalInfo = document.getElementById('studentVerificationInfo');
        const statusEl = document.getElementById('studentVerificationStatus');
        const emailSpan = document.querySelector('#studentVerificationModal .verification-target-email');

        if (emailSpan) {
            emailSpan.textContent = email;
        }
        if (infoText) {
            infoText.textContent = email
                ? `Öğrenci e-posta adresinize (${email}) 6 haneli doğrulama kodu gönderiliyor. Kod geldikten sonra buraya giriniz. (A 6-digit verification code is being sent to your student email address (${email}). Please enter the code here once you receive it.)`
                : 'Öğrenci e-posta adresinize doğrulama kodu gönderiliyor.';
        }
        if (modalInfo) {
            modalInfo.textContent = email
                ? `Kod ${email} adresine gönderiliyor. Kod 10 dakika geçerlidir. (A verification code is being sent to ${email}. It is valid for 10 minutes.)`
                : 'Doğrulama kodu gönderiliyor. Kod 10 dakika geçerlidir.';
        }
        if (statusEl) {
            statusEl.textContent = '';
        }

        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/send-verification-code`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ogrenci_no: ogrenciNo,
                    email: email
                })
            });
            
            const data = await response.json();
            
			if (data.success) {
				if (infoText) {
                    const sentMsg = this.languageManager?.getTranslation('info.verificationCodeSent') || 'Öğrenci e-posta adresinize 6 haneli doğrulama kodu gönderildi. Lütfen kodu giriniz.';
                    infoText.textContent = email ? `${sentMsg} (${email})` : sentMsg;
                }
                if (modalInfo) {
                    const sentMsg = this.languageManager?.getTranslation('info.verificationCodeSent') || 'Doğrulama kodu gönderildi.';
                    modalInfo.textContent = email ? `${sentMsg} ${email}.` : sentMsg;
                }
			} else {
                this.lastVerificationSentFor = null;
                const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
                const errorMsg = this.languageManager?.getTranslation('error.verificationCodeSendFailed') || 'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyiniz.';
                this.showError(errorTitle, errorMsg);
                if (statusEl) {
                    const errorMsg = this.languageManager?.getTranslation('error.verificationCodeSendFailed') || 'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyiniz.';
                    statusEl.textContent = data.error || errorMsg;
                }
            }
        } catch (error) {
            console.error('Doğrulama kodu gönderme hatası:', error);
            this.lastVerificationSentFor = null;
            const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
            const errorMsg = this.languageManager?.getTranslation('error.verificationCodeSendError') || 'Doğrulama kodu gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.';
            this.showError(errorTitle, errorMsg);
                if (statusEl) {
                    const errorMsg = this.languageManager?.getTranslation('error.verificationCodeSendError') || 'Doğrulama kodu gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.';
                    statusEl.textContent = errorMsg;
                }
        }
    }

    showVerificationControls(email, studentNo) {
        const emailInfoSection = document.getElementById('emailInfoSection');
        const infoText = document.getElementById('emailInfoText');

        if (emailInfoSection) {
            emailInfoSection.style.display = email ? 'block' : 'none';
        }
        if (infoText) {
            infoText.textContent = email
                ? `Öğrenci e-posta adresinize (${email}) 6 haneli doğrulama kodunu göndermek için "Kod Gönder" butonunu kullanabilirsiniz. (You can request the 6-digit verification code to your student email (${email}) by pressing the "Send Code" button.)`
                : 'Öğrenci e-posta adresinize doğrulama kodu göndermek için "Kod Gönder" butonunu kullanabilirsiniz.';
        }
        if (this.sendVerificationButton) {
            this.sendVerificationButton.classList.remove('d-none');
            this.sendVerificationButton.disabled = false;
        }

        const studentNoInput = document.getElementById('ogrenciNo');
        if (studentNoInput) {
            studentNoInput.disabled = false;
            studentNoInput.classList.remove('is-valid');
        }
    }

    hideVerificationControls() {
        const emailInfoSection = document.getElementById('emailInfoSection');
        const infoText = document.getElementById('emailInfoText');
        const modalElement = document.getElementById('studentVerificationModal');

        if (emailInfoSection) {
            emailInfoSection.style.display = 'none';
        }
        if (infoText) {
            infoText.textContent = '';
        }

        if (this.sendVerificationButton) {
            this.sendVerificationButton.classList.add('d-none');
            this.sendVerificationButton.disabled = false;
        }

        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }

        this.clearVerificationInputs();
        this.updateVerificationButtonState();
        this.studentVerificationModalOpen = false;
        this.lastVerificationSentFor = null;

        const studentNoInput = document.getElementById('ogrenciNo');
        if (studentNoInput) {
            studentNoInput.disabled = false;
            studentNoInput.classList.remove('is-valid');
        }
    }

    resetStudentVerificationState() {
        this.clearStudentFields();
        this.hideVerificationControls();
        this.currentStudentData = null;
        this.isVerified = false;
        this.lastFetchedStudentNo = null;
        this.setResetPasswordAvailability(false);
        this.selectedTopicGroupId = null;
        this.resetExamSection(true);
    }

    populateStudentFields(studentData) {
        const fields = {
            'adSoyad': studentData.ad_soyad,
            'bolum': studentData.bolum,
            'sinif': studentData.sinif,
            'telefon': this.formatPhoneForDisplay(studentData.telefon),
            'profilEmail': studentData.profil_email,
            'kisiselEmail': studentData.kisisel_email
        };

        Object.entries(fields).forEach(([fieldId, value]) => {
            const field = document.getElementById(fieldId);
            if (field) {
                field.value = value || '';
            }
        });

        // Öğrenci fotoğrafını göster
        this.displayStudentPhoto(studentData.photo_base64);

        if (this.currentUserType === 'student') {
            const topicSelect = document.getElementById('ticketTopic');
            if (topicSelect) {
                const otherOption = Array.from(topicSelect.options || []).find(opt => {
                    const text = (opt.textContent || '').toLowerCase();
                    return text.includes('diğer') || text.includes('other');
                });
                if (otherOption) {
                    topicSelect.value = otherOption.value;
                    topicSelect.dispatchEvent(new Event('change'));
                }
            }
        }

        // Öğrenci bilgileri alanına yumuşak kaydırma
        this.scrollToStudentInfo();
    }

    displayStudentPhoto(photoBase64) {
        const photoImg = document.getElementById('studentPhoto');
        const photoPlaceholder = document.getElementById('studentPhotoPlaceholder');
        
        if (!photoImg || !photoPlaceholder) {
            return;
        }

        if (photoBase64 && photoBase64.trim() !== '') {
            try {
                // Base64 verisini data URL'ye çevir
                const dataUrl = photoBase64.startsWith('data:') 
                    ? photoBase64 
                    : `data:image/jpeg;base64,${photoBase64}`;
                
                // Fotoğrafı yükle
                photoImg.src = dataUrl;
                photoImg.classList.add('loading');
                photoImg.classList.remove('d-none');
                
                // Fotoğraf yüklendiğinde placeholder'ı gizle
                photoImg.onload = () => {
                    photoImg.classList.remove('loading');
                    photoImg.classList.add('loaded');
                    photoPlaceholder.classList.add('hidden');
                    
                    // Smooth fade-in animasyonu
                    setTimeout(() => {
                        photoPlaceholder.style.display = 'none';
                    }, 300);
                };
                
                // Hata durumunda placeholder'ı göster
                photoImg.onerror = () => {
                    photoImg.classList.add('d-none');
                    photoPlaceholder.classList.remove('hidden');
                    photoPlaceholder.style.display = 'flex';
                    photoPlaceholder.querySelector('.placeholder-text').textContent = 'Fotoğraf Yüklenemedi';
                };
            } catch (error) {
                console.error('Fotoğraf yükleme hatası:', error);
                photoImg.classList.add('d-none');
                photoPlaceholder.classList.remove('hidden');
                photoPlaceholder.style.display = 'flex';
                photoPlaceholder.querySelector('.placeholder-text').textContent = 'Fotoğraf Yüklenemedi';
            }
        } else {
            // Fotoğraf yoksa placeholder'ı göster
            photoImg.classList.add('d-none');
            photoPlaceholder.classList.remove('hidden');
            photoPlaceholder.style.display = 'flex';
            photoPlaceholder.querySelector('.placeholder-text').textContent = 'Fotoğraf Bulunamadı';
        }
    }

    scrollToStudentInfo() {
        const studentInfoSection = document.querySelector('.form-section:nth-child(2)');
        if (studentInfoSection) {
            studentInfoSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }

    clearStudentFields() {
        const fields = ['adSoyad', 'bolum', 'sinif', 'telefon', 'profilEmail', 'kisiselEmail'];
        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            if (field) {
                field.value = '';
            }
        });
        
        // Öğrenci numarası alanındaki hata mesajını temizle
        this.clearFieldError('ogrenciNo');
    }

    handleFileSelect(file) {
        if (!file) return;

        // Dosya türü kontrolü
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            const title = this.languageManager?.getTranslation('error.invalidFileType') || 'Geçersiz Dosya Türü';
            const message = this.languageManager?.getTranslation('error.invalidFileType') || 'Sadece JPG, PNG ve PDF dosyaları kabul edilir.';
            this.showError(title, message);
            return;
        }

        // Dosya boyutu kontrolü (10MB)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            const title = this.languageManager?.getTranslation('error.fileTooLarge') || 'Dosya Çok Büyük';
            const message = this.languageManager?.getTranslation('error.fileTooLarge') || 'Dosya boyutu 10MB\'dan küçük olmalıdır.';
            this.showError(title, message);
            return;
        }

        this.selectedFile = file;
        this.displayFileInfo(file);
    }

    displayFileInfo(file) {
        const fileInfo = document.getElementById('fileInfo');
        const fileName = document.getElementById('fileName');
        const fileSize = document.getElementById('fileSize');
        const fileUploadArea = document.getElementById('fileUploadArea');

        if (fileInfo && fileName && fileSize) {
            fileName.textContent = file.name;
            fileSize.textContent = this.formatFileSize(file.size);
            fileInfo.classList.remove('d-none');
            fileUploadArea.style.display = 'none';
        }
    }

    removeFile() {
        const fileInput = document.getElementById('dosya');
        const fileInfo = document.getElementById('fileInfo');
        const fileUploadArea = document.getElementById('fileUploadArea');

        if (fileInput) fileInput.value = '';
        if (fileInfo) fileInfo.classList.add('d-none');
        if (fileUploadArea) fileUploadArea.style.display = 'block';

        this.selectedFile = null;
    }

    formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    async handleFormSubmit(e) {
        e.preventDefault();
        
        if (this.isLoading) return;

        // ÖNCE: Öğrenci doğrulaması kontrolü (form validasyonundan önce)
        // Eğer öğrenci doğrulaması yapılmamışsa, form validasyonu yapmadan direkt hata göster
        if (this.currentUserType === 'student') {
            if (!this.isVerified) {
                const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
                const errorMsg = this.languageManager?.getTranslation('validation.emailVerificationRequired') || 'Lütfen email doğrulamasını tamamlayınız.';
                this.showError(errorTitle, errorMsg);
                return;
            }
            
            // Öğrenci bilgileri kontrolü
            if (!this.currentStudentData) {
                const errorTitle = this.languageManager?.getTranslation('error.title') || 'Hata';
                const errorMsg = this.languageManager?.getTranslation('error.studentInfoLoadFailed') || 'Öğrenci bilgileri yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.';
                this.showError(errorTitle, errorMsg);
                return;
            }
        }

        // Validasyon hatalarını topla
        const validationErrors = [];

        // Kullanıcı tipi kontrolü
        if (!this.currentUserType) {
            validationErrors.push({
                fieldId: null,
                message: this.languageManager?.getTranslation('validation.userTypeRequired') || 'Lütfen kullanıcı tipini seçiniz.'
            });
        }

        // Talep detayı kontrolü
        const istek = document.getElementById('istek').value;
        const consent = document.getElementById('consent');
        
        // Konu kontrolü - sadece öğrenci için (grup kaldırıldı)
        if (this.currentUserType === 'student') {
            const konuId = document.getElementById('ticketTopic').value;
            
            if (!konuId) {
                validationErrors.push({
                    fieldId: 'ticketTopic',
                    message: this.languageManager?.getTranslation('validation.topicRequired') || 'Lütfen bir konu seçiniz.'
                });
            }
            
            // Yatay geçiş validasyonu (öğrenci için 8001) - burada kontrol edilmeyecek, aşağıda toplanacak
            
            // IBAN validasyonu (öğrenci için konu 4002)
            if (parseInt(konuId, 10) === 4002) {
                const ibanAdSoyad = document.getElementById('ibanAdSoyad')?.value || '';
                const ibanValue = document.getElementById('ibanInput')?.value || '';
                
                if (!ibanAdSoyad || ibanAdSoyad.trim().length === 0) {
                    validationErrors.push({
                        fieldId: 'ibanAdSoyad',
                        message: this.languageManager?.getTranslation('validation.ibanNameRequired') || 'IBAN hesap sahibinin adı soyadı zorunludur.'
                    });
                }
                
                if (!ibanValue || !this.validateIBAN(ibanValue)) {
                    validationErrors.push({
                        fieldId: 'ibanInput',
                        message: this.languageManager?.getTranslation('validation.ibanInvalid') || 'Geçerli bir Türkiye IBAN numarası giriniz. (TR ile başlayan 26 karakter)'
                    });
                }
            }
            
            // 1003 konu ID için özel neden validasyonu
            if (parseInt(konuId, 10) === 1003) {
                const reasonErrors = this.validateStudentReason1003(true);
                if (reasonErrors && reasonErrors.length > 0) {
                    validationErrors.push(...reasonErrors);
                }
            }
            
            // 1004 konu ID için kayıt dondurma validasyonu
            if (parseInt(konuId, 10) === 1004) {
                const freezeErrors = this.validateStudentFreezeSection(true);
                if (freezeErrors && freezeErrors.length > 0) {
                    validationErrors.push(...freezeErrors);
                }
            }
            
            // 1006 konu ID için muafiyet validasyonu
            if (parseInt(konuId, 10) === 1006) {
                const exemptionErrors = this.validateStudentExemptionSection(true);
                if (exemptionErrors && exemptionErrors.length > 0) {
                    validationErrors.push(...exemptionErrors);
                }
            }
            
            // 1008 konu ID için çift anadal/yandal validasyonu
            if (parseInt(konuId, 10) === 1008) {
                const doubleMinorErrors = this.validateStudentDoubleMinorSection(true);
                if (doubleMinorErrors && doubleMinorErrors.length > 0) {
                    validationErrors.push(...doubleMinorErrors);
                }
            }
            
            // Yatay geçiş validasyonu (öğrenci için 8001)
            if (parseInt(konuId, 10) === 8001) {
                const transferErrors = this.validateHorizontalTransferForm(true);
                if (transferErrors && transferErrors.length > 0) {
                    validationErrors.push(...transferErrors);
                }
            }
            
            // Sınav itiraz validasyonu (grup ID 2)
            if (this.selectedTopicGroupId === 2) {
                if (!this.examAppealFile) {
                    validationErrors.push({
                        fieldId: 'examAppealDocument',
                        message: 'İmzalı sınav itiraz formu zorunludur.'
                    });
                }
            }
        }
        
        // İstek alanı kontrolü
        if (!istek || istek.trim().length < 10) {
            const message = this.languageManager?.getTranslation('error.requestMinLength') || 'İstek alanı en az 10 karakter olmalıdır.';
            validationErrors.push({
                fieldId: 'istek',
                message: message
            });
        }
        
        // Onay kontrolü
        if (!consent || !consent.checked) {
            const message = this.languageManager?.getTranslation('error.consentRequired') || 'Kişisel verilerin işlenmesi onayını vermelisiniz.';
            validationErrors.push({
                fieldId: 'consent',
                message: message
            });
        }
        
        // Validasyon hataları varsa göster ve durdur
        if (validationErrors.length > 0) {
            // Tüm hataları göster
            validationErrors.forEach(err => {
                if (err.fieldId) {
                    this.showFieldError(err.fieldId, err.message);
                }
            });
            
            // Kullanıcıya bildir ve ilk hataya scroll yap
            this.showValidationErrors(validationErrors);
            return;
        }

        try {
            this.showLoading();
            
            let formData;
            
            if (this.currentUserType === 'student') {
                // Öğrenci akışı
                // Not: Doğrulama kontrolü yukarıda yapıldı, burada tekrar kontrol etmeye gerek yok
                const ogrenciNo = document.getElementById('ogrenciNo').value;
                const studentInfo = this.currentStudentData;
                
                // Aktif ticket sayısı kontrolü (maksimum 3 aktif ticket)
                try {
                    const requestsResponse = await this.fetchWithAuth(`${this.apiBaseUrl}/requests/${ogrenciNo}`);
                    const requestsData = await requestsResponse.json();
                    
                    if (requestsData.success && Array.isArray(requestsData.data)) {
                        // "Talep edene bildirim yapıldı" statüsü haricindekileri say
                        const activeCount = requestsData.data.filter(req => {
                            const durum = (req.durum || '').trim();
                            return durum !== 'Talep edene bildirim yapıldı';
                        }).length;
                        
                        if (activeCount >= 3) {
                            this.showError(
                                'Maksimum Aktif Talep Limiti',
                                `Aktif 3 talebiniz bulunmaktadır.\n\nTalepleriniz sonuçlandığında tekrar başvuru hakkınız açılacaktır. Bilgi için help destek birimine başvurabilirsiniz.`
                            );
                            this.hideLoading();
                            return;
                        }
                    }
                } catch (error) {
                    // Aktif ticket kontrolünde hata olursa devam et (backend kontrolü yapacak)
                    console.warn('Aktif ticket kontrolü sırasında hata:', error);
                }

            const studentPhoneValue = document.getElementById('telefon') ? document.getElementById('telefon').value : '';
            const personalEmailValue = document.getElementById('kisiselEmail') ? document.getElementById('kisiselEmail').value : '';

            if (!studentPhoneValue || !this.validatePhone(studentPhoneValue)) {
                this.showFieldError('telefon', 'Telefon 5XX XXX XX XX formatında olmalıdır. (Phone number must be in 5XX XXX XX XX format.)');
                this.hideLoading();
                return;
            } else {
                this.clearFieldError('telefon');
            }

            if (!personalEmailValue || !this.validateEmail(personalEmailValue)) {
                this.showFieldError('kisiselEmail', 'Geçerli bir kişisel e-posta adresi giriniz. (Please enter a valid personal email address.)');
                this.hideLoading();
                return;
            } else {
                this.clearFieldError('kisiselEmail');
            }
                
                // Konu ID'yi al ve GrupID'yi konudan türet
                const konuIdValue = document.getElementById('ticketTopic').value;
                const selectedTopic = this.getTopicById(konuIdValue);
                const selectedGroupId = selectedTopic ? parseInt(selectedTopic.grup_id, 10) : null;
                if (selectedGroupId === 1) {
                    if (!this.validateExamSelection()) {
                        this.hideLoading();
                        return;
                    }
                }
                this.selectedTopicGroupId = selectedGroupId;

                // FormData oluştur - grup_id konudan, açıklama olarak konu adı ve id
            this.currentStudentData.telefon = studentPhoneValue;
            this.currentStudentData.kisisel_email = personalEmailValue;
            formData = await this.createFormDataForBPM(ogrenciNo, istek, studentInfo, konuIdValue, selectedTopic);
                
            } else if (this.currentUserType === 'non-student') {
                // Öğrenci olmayan kullanıcı akışı
                const nonStudentName = document.getElementById('nonStudentName').value;
                const nonStudentPhone = document.getElementById('nonStudentPhone').value;
                const nonStudentEmail = document.getElementById('nonStudentEmail').value;
                
                // Validasyon
                if (!nonStudentName || nonStudentName.trim().length === 0) {
                    this.showFieldError('nonStudentName', 'Ad soyad giriniz. (Please enter name and surname.)');
                    this.hideLoading();
                    return;
                }
                
                if (!nonStudentPhone || nonStudentPhone.trim().length === 0) {
                    this.showFieldError('nonStudentPhone', 'Telefon numarası giriniz. (Please enter phone number.)');
                    this.hideLoading();
                    return;
                }

                if (!this.validatePhone(nonStudentPhone)) {
                    this.showFieldError('nonStudentPhone', 'Telefon 5XX XXX XX XX formatında olmalıdır.');
                    this.hideLoading();
                    return;
                }
                
                if (!nonStudentEmail || !this.validateEmail(nonStudentEmail)) {
                    this.showFieldError('nonStudentEmail', 'Geçerli bir e-posta adresi giriniz. (Please enter a valid email address.)');
                    this.hideLoading();
                    return;
                }

                // Konu kontrolü - Other kullanıcı için
                const nonStudentKonuId = document.getElementById('nonStudentTicketTopic')?.value;
                if (!nonStudentKonuId) {
                    this.showFieldError('nonStudentTicketTopicError', 'Lütfen bir konu seçiniz. (Please select a topic.)');
                    this.hideLoading();
                    return;
                }

                // Yatay geçiş validasyonu (1003 konu ID)
                if (parseInt(nonStudentKonuId, 10) === 1003) {
                    if (!this.validateNonStudentHorizontalTransferForm()) {
                        this.hideLoading();
                        return;
                    }
                }
                
                // FormData oluştur
                formData = await this.createFormDataForNonStudent(nonStudentName, nonStudentPhone, nonStudentEmail, istek, nonStudentKonuId);
            }
            
            // Backend proxy'ye gönder (Token backend'de ekleniyor)
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/bpm-submit`, {
                method: 'POST',
                body: formData // FormData kullanıldığında Content-Type otomatik ayarlanır
            });

            const data = await response.json();

            if (data.ExceptionMessage || data.error) {
                // Özel hata mesajları için kontrol (sadece kullanıcıya gösterilmesi gerekenler)
                if (data.code === 'MAX_ACTIVE_REQUESTS_EXCEEDED') {
                    this.showError(
                        'Maksimum Aktif Talep Limiti',
                        data.error || 'Aktif 3 talebiniz bulunmaktadır.\n\nTalepleriniz sonuçlandığında tekrar başvuru hakkınız açılacaktır. Bilgi için help destek birimine başvurabilirsiniz.'
                    );
                } else {
                    // Tüm teknik hataları gizle, sadece genel mesaj göster
                    console.error('BPM API Hatası:', data.ExceptionMessage || data.error, data);
                    this.showError('Hata', 'Form gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
                }
                this.hideLoading();
            } else {
                // TIID değerini al (API'den dönen talep numarası)
                const requestId = data.TaskInstanceId ||  'N/A';
                
                // Önce başarılı notification'ı göster (kullanıcıya hızlı feedback)
                this.showSuccessModal(requestId);
                
                // Arka planda veritabanı insert işlemlerini yap (kullanıcı beklemeden)
                const topicSelect = document.getElementById('ticketTopic');
                const konuId = topicSelect ? parseInt(topicSelect.value, 10) : null;
                
                // Konu 1007 ise üç ders verilerini veritabanına kaydet (arka planda)
                if (konuId === 1007 && requestId && requestId !== 'N/A') {
                    // await olmadan arka planda çalıştır
                    this.saveThreeCourseDataAsync(requestId).catch(error => {
                        console.error('Üç ders verisi kaydetme hatası:', error);
                        // Hata olsa bile kullanıcıya başarı mesajı zaten gösterildi (BPM başarılı oldu)
                    });
                }
                
                // Konu 1006 ise muafiyet ders verilerini veritabanına kaydet (arka planda)
                if (konuId === 1006 && requestId && requestId !== 'N/A') {
                    // await olmadan arka planda çalıştır
                    this.saveExemptionDataAsync(requestId).catch(error => {
                        console.error('Muafiyet ders verisi kaydetme hatası:', error);
                        // Hata olsa bile kullanıcıya başarı mesajı zaten gösterildi (BPM başarılı oldu)
                    });
                }
                
                // Konu 1008 ise çift anadal/yandal ders verilerini veritabanına kaydet (arka planda)
                if (konuId === 1008 && requestId && requestId !== 'N/A') {
                    // await olmadan arka planda çalıştır
                    this.saveDoubleMinorDataAsync(requestId).catch(error => {
                        console.error('Çift Anadal/Yandal ders verisi kaydetme hatası:', error);
                        // Hata olsa bile kullanıcıya başarı mesajı zaten gösterildi (BPM başarılı oldu)
                    });
                }
                
                // Formu 3 saniye sonra sıfırla (kullanıcı toast'ı görsün diye)
                setTimeout(() => {
                    this.resetForm();
                    // Sayfayı yumuşak şekilde en üste kaydır
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    this.hideLoading();
                }, 3000);
            }
        } catch (error) {
            // Teknik hata detaylarını console'a yaz, kullanıcıya genel mesaj göster
            console.error('Form gönderim hatası:', error);
            this.showError('Hata', 'Form gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
            this.hideLoading();
        }
    }

    async createFormDataForNonStudent(name, phone, email, istek, konuId = null) {
        const formData = new FormData();
        
        // Öğrenci olmayan kullanıcı bilgileri
        formData.append('name', name);
        formData.append('phone', this.normalizePhoneDigits(phone));
        formData.append('email', email);
        formData.append('request_detail', istek);
        formData.append('user_type', 'non-student');
        
        // Konu ID ekle (eğer varsa)
        if (konuId) {
            formData.append('konu_id', String(konuId));
            
            // Konu bilgisini bul ve ekle
            const selectedTopic = this.getTopicById(konuId);
            if (selectedTopic) {
                if (selectedTopic.grup_id) {
                    formData.append('grup_id', String(selectedTopic.grup_id));
                }
                formData.append('konu_aciklama', selectedTopic.name);
            }
        }
        
        // Yatay geçiş verileri (1003 konu ID)
        if (konuId && parseInt(konuId, 10) === 1003) {
            // Yatay geçiş belgeleri
            if (this.nonStudentHorizontalTransferFiles.ogrenciBelgesi) {
                const file = this.nonStudentHorizontalTransferFiles.ogrenciBelgesi;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_ogrenci_belgesi_base64', base64);
                formData.append('yatay_gecis_ogrenci_belgesi_mimetype', mimetype);
                formData.append('yatay_gecis_ogrenci_belgesi_filename', file.name);
            }
            
            if (this.nonStudentHorizontalTransferFiles.dersIcerikBilgisi) {
                const file = this.nonStudentHorizontalTransferFiles.dersIcerikBilgisi;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_ders_icerik_bilgisi_base64', base64);
                formData.append('yatay_gecis_ders_icerik_bilgisi_mimetype', mimetype);
                formData.append('yatay_gecis_ders_icerik_bilgisi_filename', file.name);
            }
            
            if (this.nonStudentHorizontalTransferFiles.transkript) {
                const file = this.nonStudentHorizontalTransferFiles.transkript;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_transkript_base64', base64);
                formData.append('yatay_gecis_transkript_mimetype', mimetype);
                formData.append('yatay_gecis_transkript_filename', file.name);
            }
            
            // Fakülte ve Program
            const facultyId = document.getElementById('nonStudentHorizontalTransferFaculty')?.value;
            const programId = document.getElementById('nonStudentHorizontalTransferProgram')?.value;
            if (facultyId) {
                formData.append('yatay_gecis_fakulte_id', facultyId);
            }
            if (programId) {
                formData.append('yatay_gecis_program_id', programId);
            }
            
            // Geçiş türü (radio button - sadece bir seçim)
            const transferType = document.querySelector('input[name="nonStudentTransferType"]:checked');
            if (transferType) {
                formData.append('yatay_gecis_turu', transferType.value);
            }
        }
        
        // Dosya varsa ekle (multipart/form-data olarak - base64 yerine, öğrenci tipindeki gibi)
        if (this.selectedFile) {
            let mimetype = this.selectedFile.type;
            let fileToUpload = this.selectedFile;
            
            if (mimetype && mimetype.startsWith('image/')) {
                // Resimleri sıkıştır ve Blob olarak ekle
                const compressedBase64 = await this.compressImageToBase64(this.selectedFile, 1280, 1280, 0.75);
                const compressedBlob = this.base64ToBlob(compressedBase64, 'image/jpeg');
                fileToUpload = new File([compressedBlob], this.selectedFile.name || 'image.jpg', { type: 'image/jpeg' });
                mimetype = 'image/jpeg';
            }
            // Dosyayı direkt multipart olarak ekle (base64 yerine)
            formData.append('file', fileToUpload);
            formData.append('mimetype', mimetype);
        }
        
        return formData;
    }

    async getStudentInfo(ogrenciNo) {
        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/student/${ogrenciNo}`);
            const data = await response.json();
            return data.success ? data.data : null;
        } catch (error) {
            console.error('Öğrenci bilgisi getirme hatası:', error);
            return null;
        }
    }

    async createFormDataForBPM(ogrenciNo, istek, studentInfo, konuId, selectedTopicArg = null) {
        const formData = new FormData();
        
        // Öğrenci bilgileri
        formData.append('ogrenci_no', ogrenciNo);
        formData.append('ogrenci_ad_soyad', studentInfo.ad_soyad);
        formData.append('ogrenci_bolum', studentInfo.bolum);
        formData.append('ogrenci_sinif', studentInfo.sinif);
        const studentPhone = document.getElementById('telefon') ? document.getElementById('telefon').value : '';
        const personalEmail = document.getElementById('kisiselEmail') ? document.getElementById('kisiselEmail').value.trim() : '';
        formData.append('ogrenci_telefon', this.normalizePhoneDigits(studentPhone));
        formData.append('ogrenci_mail', studentInfo.profil_email);
        formData.append('ogrenci_kisisel_mail', personalEmail);
        formData.append('ogrenci_talep_detaylari', istek);
        formData.append('ogrenci_ust_birim_id', studentInfo.ust_birim_id ?? '');
        if (studentInfo.ust_birim_id !== undefined && studentInfo.ust_birim_id !== null && studentInfo.ust_birim_id !== '') {
            formData.append('ogrenci_ust_birim_id', String(studentInfo.ust_birim_id));
        }
        
        // Konu seçimine göre GrupID'yi türet ve açıklama oluştur
        let selectedTopic = selectedTopicArg;
        if (!selectedTopic && konuId && this.ticketTopics && this.ticketTopics.length) {
            const topicIdNum = parseInt(konuId, 10);
            selectedTopic = this.ticketTopics.find(t => parseInt(t.id, 10) === topicIdNum);
        }

        if (selectedTopic && selectedTopic.grup_id) {
            formData.append('grup_id', String(selectedTopic.grup_id));
        }
        if (selectedTopic && selectedTopic.id) {
            formData.append('konu_id', String(selectedTopic.id));
        }
        // Açıklama: Konu adı ve id bilgisi
        if (selectedTopic) {
            formData.append('konu_aciklama', selectedTopic.name);
        }
        this.appendExamSelectionToFormData(formData, selectedTopic);
        
        // Diğer konu detayı varsa ekle
        // Ek konu detayı alanı kaldırıldı
        
        // Dosya varsa ekle (multipart/form-data olarak - base64 yerine)
        if (this.selectedFile) {
            let mimetype = this.selectedFile.type;
            let fileToUpload = this.selectedFile;
            
            if (mimetype && mimetype.startsWith('image/')) {
                // Resimleri sıkıştır ve Blob olarak ekle
                const compressedBase64 = await this.compressImageToBase64(this.selectedFile, 1280, 1280, 0.75);
                const compressedBlob = this.base64ToBlob(compressedBase64, 'image/jpeg');
                fileToUpload = new File([compressedBlob], this.selectedFile.name || 'image.jpg', { type: 'image/jpeg' });
                mimetype = 'image/jpeg';
            }
            // Dosyayı direkt multipart olarak ekle (base64 yerine)
            formData.append('file', fileToUpload);
            formData.append('mimetype', mimetype);
        }
        
        // IBAN verisi (öğrenci için konu 4002)
        if (parseInt(konuId, 10) === 4002) {
            const ibanAdSoyad = document.getElementById('ibanAdSoyad')?.value || '';
            const ibanValue = document.getElementById('ibanInput')?.value || '';
            
            if (ibanAdSoyad) {
                formData.append('iban_ad_soyad', ibanAdSoyad.trim());
            }
            
            if (ibanValue) {
                // IBAN'ı normalize ederek gönder (boşlukları kaldır, büyük harf)
                const normalizedIBAN = this.normalizeIBAN(ibanValue);
                formData.append('iban', normalizedIBAN);
            }
        }
        
        // Konu 1003 neden detayları
        if (parseInt(konuId, 10) === 1003) {
            const selectedReason = document.querySelector('input[name="studentReason1003"]:checked');
            if (selectedReason) {
                // Value'ları Türkçe label'lara çevir
                const reasonValueMap = {
                    'financial': 'Mali Nedenler',
                    'personal': 'Kişisel Neden',
                    'military': 'Askerlik',
                    'horizontal': 'Yatay Geçiş',
                    'other': 'Diğer'
                };
                const turkishReason = reasonValueMap[selectedReason.value] || selectedReason.value;
                formData.append('konu_1003_neden', turkishReason);
                
                if (selectedReason.value === 'horizontal') {
                    // Tom Select kullanılıyorsa value'yu ondan al
                    let horizontalDetail = '';
                    if (this.universityTomSelect) {
                        horizontalDetail = this.universityTomSelect.getValue() || '';
                    } else {
                        const horizontalField = document.getElementById('studentReasonHorizontalDetails');
                        horizontalDetail = horizontalField?.value.trim() || '';
                    }
                    if (horizontalDetail) {
                        // Dropdown'dan seçilen üniversiteyi gönder
                        formData.append('konu_1003_yatay_gecis_detay', horizontalDetail);
                    }
                }
                if (selectedReason.value === 'other') {
                    const otherDetail = document.getElementById('studentReasonOtherDetails')?.value.trim();
                    if (otherDetail) {
                        // Textbox'ta ne yazıyorsa aynı şekilde gönder
                        formData.append('konu_1003_diger_detay', otherDetail);
                    }
                }
            }
        }
        
        // Konu 1004 kayıt dondurma detayları
        if (parseInt(konuId, 10) === 1004) {
            const freezeReason = document.querySelector('input[name="studentFreezeReason"]:checked');
            if (freezeReason) {
                // Value'ları Türkçe label'lara çevir
                const freezeValueMap = {
                    'yurtdisi': 'Yurtdışı Eğitimi',
                    'saglik': 'Sağlık',
                    'askerlik': 'Askerlik',
                    'hazirlik': 'Hazırlık Prog. Erken Bitirme',
                    'other': 'Diğer'
                };
                const turkishFreezeReason = freezeValueMap[freezeReason.value] || freezeReason.value;
                formData.append('konu_1004_neden', turkishFreezeReason);
                
                if (freezeReason.value === 'other') {
                    const otherDetail = document.getElementById('studentFreezeOtherDetails')?.value.trim();
                    if (otherDetail) {
                        // Textbox'ta ne yazıyorsa aynı şekilde gönder
                        formData.append('konu_1004_diger_detay', otherDetail);
                    }
                }
            }
            const historySelection = document.querySelector('input[name="studentFreezeHistory"]:checked');
            if (historySelection) {
                // History value'larını Türkçe label'lara çevir
                const historyValueMap = {
                    'evet': 'Evet',
                    'hayir': 'Hayır'
                };
                const turkishHistory = historyValueMap[historySelection.value] || historySelection.value;
                formData.append('konu_1004_onceki_dondurma', turkishHistory);
            }

            // Talep dönemi ve akademik takvim bilgileri
            const freezeRequestPeriod = document.getElementById('freezeRequestPeriod');
            const freezeStartYear = document.getElementById('freezeStartYear');
            const freezeStartTerm = document.getElementById('freezeStartTerm');
            const freezeEndInfo = document.getElementById('freezeEndInfo');

            if (freezeRequestPeriod && freezeRequestPeriod.value) {
                const periodMap = {
                    '1': '1 Yarıyıl İzinli',
                    '2': '2 Yarıyıl İzinli',
                    '3': '3 Yarıyıl İzinli',
                    '4': '4 Yarıyıl İzinli'
                };
                const periodLabel = periodMap[freezeRequestPeriod.value] || freezeRequestPeriod.value;
                formData.append('konu_1004_talep_donemi', periodLabel);
            }

            if (freezeStartYear && freezeStartYear.value) {
                formData.append('konu_1004_baslama_yil', freezeStartYear.value);
            }

            if (freezeStartTerm && freezeStartTerm.value) {
                const termMap = {
                    'guz': 'Güz',
                    'bahar': 'Bahar'
                };
                const termLabel = termMap[freezeStartTerm.value] || freezeStartTerm.value;
                formData.append('konu_1004_baslama_donem', termLabel);
            }

            if (freezeEndInfo && freezeEndInfo.dataset && freezeEndInfo.dataset.endYear && freezeEndInfo.dataset.endTerm) {
                const endYear = freezeEndInfo.dataset.endYear;
                const endTermValue = freezeEndInfo.dataset.endTerm;
                const termMap = {
                    'guz': 'Güz',
                    'bahar': 'Bahar'
                };
                const endTermLabel = termMap[endTermValue] || endTermValue;
                formData.append('konu_1004_bitis_yil', endYear);
                formData.append('konu_1004_bitis_donem', endTermLabel);
            }
        }
        
        // Konu 1006 muafiyet başvurusu detayları
        if (parseInt(konuId, 10) === 1006) {
            // Ders listesi artık form-data'ya eklenmiyor, sadece veritabanına kaydediliyor
            await this.appendExemptionDocumentsToFormData(formData);
        }

        if (parseInt(konuId, 10) === 1007) {
            await this.appendThreeCourseTranscriptToFormData(formData);
        }
        
        // Konu 1008 çift anadal/yandal program tipi
        if (parseInt(konuId, 10) === 1008) {
            const programTypeRadio = document.querySelector('input[name="programType1008"]:checked');
            if (programTypeRadio) {
                // "cift_anadal" -> "Anadal", "yandal" -> "Yandal"
                const programTypeValue = programTypeRadio.value === 'cift_anadal' ? 'Anadal' : 'Yandal';
                formData.append('konu_1008_program_type', programTypeValue);
            }
        }
        
        // Yatay geçiş verileri (öğrenci için 8001)
        if (parseInt(konuId, 10) === 8001) {
            // Yatay geçiş belgeleri
            if (this.horizontalTransferFiles.ogrenciBelgesi) {
                const file = this.horizontalTransferFiles.ogrenciBelgesi;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_ogrenci_belgesi_base64', base64);
                formData.append('yatay_gecis_ogrenci_belgesi_mimetype', mimetype);
                formData.append('yatay_gecis_ogrenci_belgesi_filename', file.name);
            }
            
            if (this.horizontalTransferFiles.dersIcerikBilgisi) {
                const file = this.horizontalTransferFiles.dersIcerikBilgisi;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_ders_icerik_bilgisi_base64', base64);
                formData.append('yatay_gecis_ders_icerik_bilgisi_mimetype', mimetype);
                formData.append('yatay_gecis_ders_icerik_bilgisi_filename', file.name);
            }
            
            if (this.horizontalTransferFiles.transkript) {
                const file = this.horizontalTransferFiles.transkript;
                let mimetype = file.type;
                let base64;
                if (mimetype && mimetype.startsWith('image/')) {
                    base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                    mimetype = 'image/jpeg';
                } else {
                    base64 = await this.convertFileToBase64(file);
                }
                formData.append('yatay_gecis_transkript_base64', base64);
                formData.append('yatay_gecis_transkript_mimetype', mimetype);
                formData.append('yatay_gecis_transkript_filename', file.name);
            }
            
            // Fakülte ve Program
            const facultyId = document.getElementById('horizontalTransferFaculty')?.value;
            const programId = document.getElementById('horizontalTransferProgram')?.value;
            if (facultyId) {
                formData.append('yatay_gecis_fakulte_id', facultyId);
            }
            if (programId) {
                formData.append('yatay_gecis_program_id', programId);
            }
            
            // Geçiş türü (radio button - sadece bir seçim)
            const transferType = document.querySelector('input[name="transferType"]:checked');
            if (transferType) {
                formData.append('yatay_gecis_turu', transferType.value);
            }
        }
        
        // Sınav itiraz dokümanı (grup ID 2)
        if (selectedTopic && selectedTopic.grup_id === 2 && this.examAppealFile) {
            const file = this.examAppealFile;
            let mimetype = file.type;
            let base64;
            if (mimetype && mimetype.startsWith('image/')) {
                base64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                mimetype = 'image/jpeg';
            } else {
                base64 = await this.convertFileToBase64(file);
            }
            formData.append('sinav_itiraz_formu_base64', base64);
            formData.append('sinav_itiraz_formu_mimetype', mimetype);
            formData.append('sinav_itiraz_formu_filename', file.name);
        }
        
        // Token backend'de ekleniyor (güvenlik için frontend'de yok)
        
        return formData;
    }

    convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = error => reject(error);
        });
    }

    base64ToBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    }

    async compressImageToBase64(file, maxWidth = 1600, maxHeight = 1600, quality = 0.8) {
        // Canvas ile yeniden örnekleme (EXIF/metaveri kaldırılır)
        const imgUrl = URL.createObjectURL(file);
        try {
            const img = await new Promise((resolve, reject) => {
                const image = new Image();
                image.onload = () => resolve(image);
                image.onerror = reject;
                image.src = imgUrl;
            });

            let { width, height } = img;
            const scale = Math.min(maxWidth / width, maxHeight / height, 1);
            const targetW = Math.round(width * scale);
            const targetH = Math.round(height * scale);

            const canvas = document.createElement('canvas');
            canvas.width = targetW;
            canvas.height = targetH;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, targetW, targetH);

            const dataUrl = canvas.toDataURL('image/jpeg', quality);
            return dataUrl.split(',')[1];
        } finally {
            URL.revokeObjectURL(imgUrl);
        }
    }

    validateForm(formData) {
        let isValid = true;

        // Öğrenci numarası kontrolü - sadece boş olup olmadığını kontrol et
        if (!formData.ogrenci_no || formData.ogrenci_no.trim().length === 0) {
            this.showFieldError('ogrenciNo', 'Öğrenci numarası giriniz. (Please enter student number.)');
            isValid = false;
        }

        // İstek kontrolü
        if (!formData.istek || formData.istek.trim().length < 10) {
            this.showFieldError('istek', 'İstek alanı en az 10 karakter olmalıdır. (Request field must be at least 10 characters.)');
            isValid = false;
        }

        // Onay kontrolü
        const consent = document.getElementById('consent');
        if (!consent.checked) {
            this.showFieldError('consent', 'Kişisel verilerin işlenmesi onayını vermelisiniz. (You must give consent for processing personal data.)');
            isValid = false;
        }

        return isValid;
    }

    showFieldError(fieldId, message) {
        const field = document.getElementById(fieldId);
        const errorElement = document.getElementById(fieldId + 'Error');
        
        if (field) {
            field.classList.add('is-invalid');
            // Tom Select için wrapper'a da is-invalid class'ı ekle
            if (fieldId === 'studentReasonHorizontalDetails' && this.universityTomSelect) {
                this.universityTomSelect.wrapper.classList.add('is-invalid');
            }
            // Tom Select için ticketTopic ve nonStudentTicketTopic
            if ((fieldId === 'ticketTopic' && this.ticketTopicTomSelect) || 
                (fieldId === 'nonStudentTicketTopic' && this.nonStudentTopicTomSelect)) {
                const tomSelect = fieldId === 'ticketTopic' ? this.ticketTopicTomSelect : this.nonStudentTopicTomSelect;
                if (tomSelect && tomSelect.wrapper) {
                    tomSelect.wrapper.classList.add('is-invalid');
                }
            }
        }
        
        if (errorElement) {
            errorElement.textContent = message;
            errorElement.classList.remove('d-none');
        }
    }
    
    scrollToField(fieldId) {
        const field = document.getElementById(fieldId);
        if (field) {
            // Alan görünür olana kadar scroll yap
            setTimeout(() => {
                field.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
                // Focus yap (eğer input ise)
                if (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA' || field.tagName === 'SELECT') {
                    field.focus();
                }
            }, 100);
        }
    }
    
    showValidationErrors(errors) {
        // Eksik alanları bildir
        if (errors.length > 0) {
            const errorMessages = errors.map(err => `• ${err.message}`).join('\n');
            const missingFieldsMsg = this.languageManager?.getTranslation('validation.missingFields') || 'Lütfen aşağıdaki alanları doldurunuz:';
            const missingFieldsTitle = this.languageManager?.getTranslation('validation.missingFieldsTitle') || 'Eksik Bilgiler';
            this.showErrorToast(
                `${missingFieldsMsg}\n\n${errorMessages}`,
                missingFieldsTitle
            );
            
            // İlk hataya scroll yap
            if (errors[0] && errors[0].fieldId) {
                this.scrollToField(errors[0].fieldId);
            }
        }
    }

    clearFieldError(fieldId) {
        const field = document.getElementById(fieldId);
        const errorElement = document.getElementById(fieldId + 'Error');
        
        if (field) {
            field.classList.remove('is-invalid');
        }
        
        if (errorElement) {
            errorElement.textContent = '';
        }
    }

    resetForm() {
        const form = document.getElementById('helpForm');
        if (form) {
            form.reset();
        }
        
        this.clearStudentFields();
        this.removeFile();
        this.resetStudentReasonSection();
        this.resetStudentFreezeSection();
        this.resetStudentExemptionSection();
        this.resetExamAppealSection();
        
        // Kullanıcı tipi seçimini sıfırla
        const userTypeInputs = document.querySelectorAll('input[name="userType"]');
        userTypeInputs.forEach(input => input.checked = false);
        
        // Tüm akışları gizle (null kontrolü ile)
        const studentFlow = document.getElementById('studentFlow');
        if (studentFlow) studentFlow.classList.add('d-none');
        
        const nonStudentFlow = document.getElementById('nonStudentFlow');
        if (nonStudentFlow) nonStudentFlow.classList.add('d-none');
        
        const verifiedStudentInfo = document.getElementById('verifiedStudentInfo');
        if (verifiedStudentInfo) verifiedStudentInfo.classList.add('d-none');
        
        const commonFormFields = document.getElementById('commonFormFields');
        if (commonFormFields) commonFormFields.classList.add('d-none');
        
        const studentTicketSection = document.getElementById('studentTicketSection');
        if (studentTicketSection) studentTicketSection.classList.add('d-none');
        const emailInfoSection = document.getElementById('emailInfoSection');
        if (emailInfoSection) emailInfoSection.style.display = 'none';

        // Kod alanını ve butonu gizle
        this.hideVerificationControls();
        this.setResetPasswordAvailability(false);

        // Tom Select'leri temizle
        if (this.ticketTopicTomSelect) {
            this.ticketTopicTomSelect.clear();
        }
        if (this.nonStudentTopicTomSelect) {
            this.nonStudentTopicTomSelect.clear();
        }
        
        // Durum değişkenlerini sıfırla
        this.currentUserType = null;
        this.currentStudentData = null;
        this.isVerified = false;
        this.lastFetchedStudentNo = null;
        this.lastVerificationSentFor = null;
        
        // Butonu sıfırla
        const verifyEmailBtn = document.getElementById('verifyEmailBtn');
        if (verifyEmailBtn) {
            verifyEmailBtn.textContent = '<i class="fas fa-paper-plane me-2"></i>Doğrulama Kodu Gönder (Send Verification Code)';
            verifyEmailBtn.disabled = false;
        }
        
        // Tüm hata mesajlarını temizle
        const errorElements = document.querySelectorAll('.invalid-feedback');
        errorElements.forEach(element => {
            element.textContent = '';
        });
        
        const invalidFields = document.querySelectorAll('.is-invalid');
        invalidFields.forEach(field => {
            field.classList.remove('is-invalid');
        });
    }

    showSuccessModal(requestId) {
        // Fallback - eğer toast container yoksa alert kullan
        if (!this.toastContainer) {
            alert(`Başarılı!\n\nTalebiniz başarıyla gönderildi!\nTalep Numaranız: ${requestId}\n\nTalebinizin durumunu "Talep Sonuçlarım" bölümünden takip edebilirsiniz.`);
            return;
        }
        
        // Modern toast notification kullan (10 saniye göster)
        this.showToast(
            'success',
            '🎉 Başarılı!',
            `✓ Talebiniz başarıyla gönderildi!<br>` +
            `📋 Talep Numaranız: <strong>${requestId}</strong><br>` +
            `💡 Talebinizin durumunu "Talep Sonuçlarım" bölümünden takip edebilirsiniz.<br>` +
            `<small><i>Form 3 saniye sonra sıfırlanacaktır...</i></small>`,
            10000 // 10 saniye
        );
    }

    showError(title, message) {
        // Modern toast notification kullan
        this.showErrorToast(message, title);
    }

    showSuccess(title, message) {
        // Modern toast notification kullan
        this.showSuccessToast(message, title);
    }

    async searchRequests() {
        const searchInput = document.getElementById('searchOgrenciNo');
        const ogrenciNo = searchInput ? searchInput.value.replace(/\D/g, '') : '';

        if (searchInput) {
            searchInput.value = ogrenciNo;
        }
        
        if (!ogrenciNo || ogrenciNo.length < 5) {
            this.showError('Hata', 'Lütfen geçerli bir öğrenci numarası giriniz.');
            return;
        }

        this.currentRequestStudentNo = ogrenciNo;
        try {
            this.showLoading();
            
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/requests/${ogrenciNo}`);
            const data = await response.json();

            if (data.success) {
                this.displayRequestResults(data.data);
            } else {
                this.showError('Hata', 'Bu öğrenci numarasına ait talep bulunamadı.');
            }
        } catch (error) {
            console.error('Talep arama hatası:', error);
            this.showError('Hata', 'Talepler yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.');
        } finally {
            this.hideLoading();
        }
    }
    
    // Arka planda veritabanı insert işlemleri için async helper fonksiyonlar
    async saveThreeCourseDataAsync(requestId) {
        try {
            const ucDersTablosu = this.collectThreeCourseData();
            if (ucDersTablosu && ucDersTablosu.length > 0) {
                const saveResponse = await this.fetchWithAuth(`${this.apiBaseUrl}/save-three-course-data`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        surec_no: parseInt(requestId, 10),
                        uc_ders_tablosu: ucDersTablosu
                    })
                });
                
                const saveData = await saveResponse.json();
                if (!saveResponse.ok || saveData.error) {
                    console.error('Üç ders verisi kaydetme hatası:', saveData.error || 'Bilinmeyen hata');
                }
            }
        } catch (saveError) {
            console.error('Üç ders verisi kaydetme hatası:', saveError);
        }
    }
    
    async saveExemptionDataAsync(requestId) {
        try {
            const muafiyetDersListesi = this.collectExemptionCourseData();
            if (muafiyetDersListesi && muafiyetDersListesi.length > 0) {
                const saveResponse = await this.fetchWithAuth(`${this.apiBaseUrl}/save-exemption-data`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        surec_no: parseInt(requestId, 10),
                        muafiyet_ders_listesi: muafiyetDersListesi
                    })
                });
                
                const saveData = await saveResponse.json();
                if (!saveResponse.ok || saveData.error) {
                    console.error('Muafiyet ders verisi kaydetme hatası:', saveData.error || 'Bilinmeyen hata');
                }
            }
        } catch (saveError) {
            console.error('Muafiyet ders verisi kaydetme hatası:', saveError);
        }
    }
    
    async saveDoubleMinorDataAsync(requestId) {
        try {
            const doubleMinorDersListesi = this.collectDoubleMinorCourseData();
            if (doubleMinorDersListesi && doubleMinorDersListesi.length > 0) {
                const saveResponse = await this.fetchWithAuth(`${this.apiBaseUrl}/save-double-minor-data`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        surec_no: parseInt(requestId, 10),
                        cift_yandal_ders_listesi: doubleMinorDersListesi
                    })
                });
                
                const saveData = await saveResponse.json();
                if (!saveResponse.ok || saveData.error) {
                    console.error('Çift Anadal/Yandal ders verisi kaydetme hatası:', saveData.error || 'Bilinmeyen hata');
                }
            }
        } catch (saveError) {
            console.error('Çift Anadal/Yandal ders verisi kaydetme hatası:', saveError);
        }
    }

    displayRequestResults(requests) {
        const resultsContainer = document.getElementById('requestResults');
        if (!resultsContainer) {
            return;
        }

        this.currentRequestStudentNo = currentOgrenciNo || this.currentRequestStudentNo || null;
        this.currentRequestSummaries = Array.isArray(requests) ? requests : [];

        if (!this.currentRequestSummaries.length) {
            resultsContainer.innerHTML = `
                <div class="request-empty-state">
                    <div class="icon">
                        <i class="fas fa-inbox"></i>
                    </div>
                    <h5>Talep Bulunamadı</h5>
                    <p>Bu öğrenci numarasına ait talep kaydı bulunamadı.</p>
                </div>
            `;
            return;
        }

        const cardsHTML = this.currentRequestSummaries.map(request => {
            const processNo = this.escapeHtml(request.surec_no ?? '');
            const subject = this.escapeHtml(request.konu_baslik || '');
            const detailPreview = this.escapeHtml(
                (request.ogrenci_detay || '').replace(/\s+/g, ' ').trim()
            );
            const statusText = this.escapeHtml(request.durum || 'Durum Bilgisi Yok');
            const statusAppearance = this.resolveStatusAppearance(request.durum);
            const createdAt = this.formatDateTime(request.baslangic_tarihi);

            const previewText = detailPreview ? detailPreview : 'Detay bilgisi bulunamadı.';

            return `
                <article class="request-summary-card">
                    <div class="request-summary-header">
                        <button type="button"
                                class="request-process-btn"
                                data-process-id="${processNo}">
                            <span class="process-icon">
                                <i class="fas fa-hashtag"></i>
                            </span>
                            ${processNo}
                        </button>
                        <span class="status-badge ${statusAppearance}">
                            ${statusText}
                        </span>
                    </div>
                    <div class="request-summary-body">
                        ${subject ? `<h6>${subject}</h6>` : ''}
                        <p>${previewText}</p>
                    </div>
                    <div class="request-summary-footer">
                        <span class="request-date-label">
                            <i class="far fa-calendar-alt me-1"></i>${createdAt}
                        </span>
                        <button type="button"
                                class="btn request-detail-btn btn-sm"
                                data-process-id="${processNo}">
                            Detayları Görüntüle
                        </button>
                    </div>
                </article>
            `;
        }).join('');

        resultsContainer.innerHTML = `
            <div class="request-summary-grid">
                ${cardsHTML}
            </div>
        `;

        const detailButtons = resultsContainer.querySelectorAll('[data-process-id]');
        detailButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const processId = button.getAttribute('data-process-id');
                this.openRequestDetailModal(processId);
            });
        });
    }

    resolveStatusAppearance(status) {
        const normalized = (status || '').toString().toLowerCase();
        if (!normalized) {
            return 'status-neutral';
        }
        if (normalized.includes('tamam') || normalized.includes('kap') || normalized.includes('closed')) {
            return 'status-success';
        }
        if (normalized.includes('devam') || normalized.includes('bekle') || normalized.includes('pending')) {
            return 'status-warning';
        }
        if (normalized.includes('red') || normalized.includes('iptal') || normalized.includes('fail')) {
            return 'status-danger';
        }
        if (normalized.includes('yanit') || normalized.includes('onay')) {
            return 'status-info';
        }
        return 'status-neutral';
    }

    formatDateTime(value) {
        if (!value) {
            return 'Tarih bilgisi yok';
        }
        try {
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return this.escapeHtml(value);
            }
            return date.toLocaleString('tr-TR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return this.escapeHtml(value);
        }
    }

    formatMultilineText(text) {
        if (!text) {
            return '<span class="text-muted">Bilgi bulunamadı.</span>';
        }
        // XSS koruması: HTML escape + sadece <br> tag'ine izin ver
        const escaped = this.escapeHtml(text);
        // Newline'ları <br> ile değiştir (zaten escape edilmiş, güvenli)
        return escaped.replace(/\r?\n/g, '<br>');
    }
    
    // Güvenli HTML set etme fonksiyonu (XSS koruması)
    safeSetHTML(element, htmlContent) {
        if (!element) return;
        
        // XSS koruması: textContent kullan (en güvenli)
        // Eğer HTML formatı gerekiyorsa, sadece whitelist tag'lere izin ver
        const tempDiv = document.createElement('div');
        tempDiv.textContent = htmlContent; // Önce text olarak set et
        
        // Sadece <br> tag'lerini koru (newline'lar için)
        const sanitized = htmlContent
            .replace(/<script[^>]*>.*?<\/script>/gi, '') // Script tag'lerini kaldır
            .replace(/<iframe[^>]*>.*?<\/iframe>/gi, '') // Iframe'leri kaldır
            .replace(/on\w+\s*=/gi, '') // Event handler'ları kaldır
            .replace(/javascript:/gi, '') // JavaScript: protocol'unu kaldır
            .replace(/<[^>]+>/g, function(match) {
                // Sadece <br> ve <span> tag'lerine izin ver
                const tagName = match.match(/<\/?(\w+)/);
                if (tagName && ['br', 'span', 'p', 'strong', 'em', 'ul', 'ol', 'li'].includes(tagName[1].toLowerCase())) {
                    return match;
                }
                return ''; // Diğer tag'leri kaldır
            });
        
        // innerHTML yerine textContent kullan (daha güvenli)
        // Eğer format korunması gerekiyorsa, sanitized HTML kullan
        if (sanitized !== htmlContent) {
            // HTML içerik varsa, sanitize edilmiş versiyonu kullan
            element.innerHTML = sanitized;
        } else {
            // Sadece text ise, textContent kullan (en güvenli)
            element.textContent = htmlContent.replace(/<br>/g, '\n');
        }
    }

    ensureRequestDetailRefs() {
        if (this.requestDetailRefs) {
            return this.requestDetailRefs;
        }
        const modalElement = document.getElementById('requestDetailModal');
        if (!modalElement) {
            return null;
        }

        this.requestDetailRefs = {
            modalElement,
            modalInstance: bootstrap.Modal.getOrCreateInstance(modalElement),
            loading: modalElement.querySelector('[data-detail-loading]'),
            content: modalElement.querySelector('[data-detail-content]'),
            error: modalElement.querySelector('[data-detail-error]'),
            process: modalElement.querySelector('[data-detail-process]'),
            subject: modalElement.querySelector('[data-detail-subject]'),
            status: modalElement.querySelector('[data-detail-status]'),
            start: modalElement.querySelector('[data-detail-start]'),
            closed: modalElement.querySelector('[data-detail-closed]'),
            requestBody: modalElement.querySelector('[data-detail-request]'),
            responseBody: modalElement.querySelector('[data-detail-response]')
        };

        return this.requestDetailRefs;
    }

    async openRequestDetailModal(processId) {
        const trimmedProcessId = (processId || '').toString().trim();
        if (!trimmedProcessId) {
            this.showErrorToast('Süreç numarası bulunamadı.', 'Hata');
            return;
        }
        const studentNumber = this.currentRequestStudentNo || currentOgrenciNo;
        if (!studentNumber) {
            this.showErrorToast('Öğrenci doğrulaması tamamlanmadan detay görüntülenemez.', 'Hata');
            return;
        }

        const refs = this.ensureRequestDetailRefs();
        if (!refs) {
            this.showErrorToast('Talep detay modali bulunamadı.', 'Hata');
            return;
        }

        if (refs.loading) {
            refs.loading.classList.remove('d-none');
        }
        if (refs.content) {
            refs.content.classList.add('d-none');
        }
        if (refs.error) {
            refs.error.classList.add('d-none');
            refs.error.textContent = '';
        }
        if (refs.process) {
            refs.process.textContent = `${trimmedProcessId}`;
        }
        if (refs.status) {
            refs.status.className = 'status-badge status-neutral';
            refs.status.textContent = 'Yükleniyor...';
        }

        refs.modalInstance.show();

        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/requests/${studentNumber}/${trimmedProcessId}`);
            const data = await response.json();

            if (response.ok && data?.success) {
                this.renderRequestDetail(data.data || {});
            } else {
                const errorMessage = data?.error || 'Talep detayları getirilemedi.';
                this.renderRequestDetailError(errorMessage);
            }
        } catch (error) {
            console.error('Talep detay yükleme hatası:', error);
            this.renderRequestDetailError('Talep detayları yüklenirken bir hata oluştu.');
        }
    }

    renderRequestDetail(detail) {
        const refs = this.ensureRequestDetailRefs();
        if (!refs) {
            return;
        }

        if (refs.loading) {
            refs.loading.classList.add('d-none');
        }
        if (refs.content) {
            refs.content.classList.remove('d-none');
        }

        const normalizedStatus = detail?.durum || 'Durum Bilgisi Yok';
        const statusAppearance = this.resolveStatusAppearance(normalizedStatus);

        if (refs.status) {
            refs.status.className = `status-badge ${statusAppearance}`;
            refs.status.textContent = normalizedStatus;
        }

        if (refs.subject) {
            refs.subject.textContent = detail?.konu_baslik || 'Konu bilgisi bulunamadı.';
        }

        if (refs.start) {
            refs.start.textContent = this.formatDateTime(detail?.baslangic_tarihi);
        }

        if (refs.closed) {
            if (detail?.kapanis_tarihi) {
                refs.closed.textContent = this.formatDateTime(detail.kapanis_tarihi);
            } else {
                refs.closed.textContent = detail?.kapanis_tarihi_display || 'İşlem Devam Ediyor';
            }
        }

        if (refs.requestBody) {
            // XSS koruması: formatMultilineText zaten escape ediyor ama ekstra güvenlik için safeSetHTML kullan
            const requestText = detail?.ogrenci_detaylar || '';
            if (requestText) {
                refs.requestBody.innerHTML = this.formatMultilineText(requestText);
            } else {
                refs.requestBody.textContent = 'Bilgi bulunamadı.';
            }
        }

        if (refs.responseBody) {
            // XSS koruması: formatMultilineText zaten escape ediyor
            const responseText = detail?.talep_yanit;
            if (responseText) {
                refs.responseBody.innerHTML = this.formatMultilineText(responseText);
            } else {
                refs.responseBody.innerHTML = '<span class="text-muted">Yanıt bilgisi bulunmamaktadır.</span>';
            }
        }
    }

    renderRequestDetailError(message) {
        const refs = this.ensureRequestDetailRefs();
        if (!refs) {
            return;
        }
        if (refs.loading) {
            refs.loading.classList.add('d-none');
        }
        if (refs.content) {
            refs.content.classList.add('d-none');
        }
        if (refs.error) {
            refs.error.textContent = message;
            refs.error.classList.remove('d-none');
        }
    }

    // Telefon yardımcıları
    getDigitsOnly(value) {
        return (value || '').toString().replace(/\D/g, '');
    }

    normalizePhoneDigits(value) {
        // Sadece rakamlar, baştaki 0'ı kaldır, 5 ile başlamalı
        let digits = this.getDigitsOnly(value);
        if (digits.startsWith('0')) {
            digits = digits.slice(1);
        }
        // En fazla 10 hane (5XXXXXXXXX)
        if (digits.length > 10) {
            digits = digits.slice(0, 10);
        }
        return digits;
    }

    formatPhoneForDisplay(value) {
        let digits = this.normalizePhoneDigits(value);
        // 5XXXXXXXXX -> 539 695 62 20  (3-3-2-2)
        const g1 = digits.substring(0, Math.min(3, digits.length));
        const g2 = digits.length > 3 ? digits.substring(3, Math.min(6, digits.length)) : '';
        const g3 = digits.length > 6 ? digits.substring(6, Math.min(8, digits.length)) : '';
        const g4 = digits.length > 8 ? digits.substring(8, Math.min(10, digits.length)) : '';
        return [g1, g2, g3, g4].filter(Boolean).join(' ');
    }

    validatePhone(value) {
        const digits = this.normalizePhoneDigits(value);
        return /^5\d{9}$/.test(digits);
    }

    handlePhoneInput(inputEl) {
        const start = inputEl.selectionStart;
        const before = inputEl.value;
        inputEl.value = this.formatPhoneForDisplay(inputEl.value);
        // Basit caret düzeltmesi
        const delta = inputEl.value.length - before.length;
        inputEl.selectionStart = inputEl.selectionEnd = Math.max(0, (start || 0) + delta);
    }

    handlePhoneBlur(inputEl, fieldId) {
        if (!this.validatePhone(inputEl.value)) {
            this.showFieldError(fieldId, 'Telefon 5XX XXX XX XX formatında olmalıdır.');
        } else {
            this.clearFieldError(fieldId);
        }
    }

    // IBAN yardımcıları
    normalizeIBAN(value) {
        // Sadece harfler ve rakamlar, boşlukları kaldır, büyük harfe çevir
        let normalized = (value || '').toString().replace(/\s/g, '').toUpperCase();
        // Sadece alfanümerik karakterleri tut
        normalized = normalized.replace(/[^A-Z0-9]/g, '');
        // En fazla 26 karakter
        if (normalized.length > 26) {
            normalized = normalized.slice(0, 26);
        }
        return normalized;
    }

    formatIBANForDisplay(value) {
        let normalized = this.normalizeIBAN(value);
        // Her 4 karakterde bir boşluk ekle
        let formatted = '';
        for (let i = 0; i < normalized.length; i++) {
            if (i > 0 && i % 4 === 0) {
                formatted += ' ';
            }
            formatted += normalized[i];
        }
        return formatted;
    }

    validateIBAN(value) {
        const normalized = this.normalizeIBAN(value);
        // TR ile başlamalı ve tam 26 karakter olmalı
        if (!normalized.startsWith('TR')) {
            return false;
        }
        if (normalized.length !== 26) {
            return false;
        }
        // Türkiye IBAN formatı: TR + 2 check digit + 4 banka kodu + 5 sıfır + 16 hesap numarası
        // Basit format kontrolü (26 karakter, TR ile başlayan, alfanümerik)
        const ibanRegex = /^TR\d{2}[A-Z0-9]{22}$/;
        return ibanRegex.test(normalized);
    }

    handleIBANInput(inputEl) {
        const start = inputEl.selectionStart;
        const before = inputEl.value;
        const normalizedBefore = this.normalizeIBAN(before);
        inputEl.value = this.formatIBANForDisplay(inputEl.value);
        const normalizedAfter = this.normalizeIBAN(inputEl.value);
        
        // Caret pozisyonunu koru (boşluk eklemelerini hesaba katarak)
        let newPosition = start;
        if (normalizedAfter.length !== normalizedBefore.length) {
            // Karakter eklendi veya silindi, caret'i ayarla
            const spacesBefore = (before.substring(0, start).match(/\s/g) || []).length;
            const spacesAfter = (inputEl.value.substring(0, inputEl.selectionStart).match(/\s/g) || []).length;
            newPosition = inputEl.selectionStart;
        } else {
            // Sadece formatlama değişti, caret pozisyonunu koruyalım
            const spacesBefore = (before.substring(0, start).match(/\s/g) || []).length;
            const normalizedStart = normalizedBefore.substring(0, start - spacesBefore).length;
            // Yeni pozisyonda kaç boşluk var?
            let newSpaces = 0;
            let newCharIndex = 0;
            for (let i = 0; i < inputEl.value.length && newCharIndex < normalizedStart; i++) {
                if (inputEl.value[i] === ' ') {
                    newSpaces++;
                } else {
                    newCharIndex++;
                }
            }
            newPosition = normalizedStart + newSpaces;
        }
        inputEl.selectionStart = inputEl.selectionEnd = Math.max(0, Math.min(newPosition, inputEl.value.length));
        
        // Anlık doğrulama
        this.validateIBANRealTime(inputEl.value);
    }

    validateIBANRealTime(value) {
        const ibanInput = document.getElementById('ibanInput');
        const errorDiv = document.getElementById('ibanError');
        
        if (!ibanInput) return;
        
        const normalized = this.normalizeIBAN(value);
        const isValid = normalized.length > 0 && this.validateIBAN(value);
        const isEmpty = normalized.length === 0;
        
        if (isEmpty) {
            // Boşsa border rengini temizle
            ibanInput.classList.remove('is-valid', 'is-invalid');
            if (errorDiv) {
                errorDiv.textContent = '';
                errorDiv.classList.add('d-none');
            }
        } else if (isValid) {
            // Geçerli: yeşil border
            ibanInput.classList.remove('is-invalid');
            ibanInput.classList.add('is-valid');
            if (errorDiv) {
                errorDiv.textContent = '';
                errorDiv.classList.add('d-none');
            }
        } else {
            // Geçersiz: kırmızı border
            ibanInput.classList.remove('is-valid');
            ibanInput.classList.add('is-invalid');
            if (errorDiv) {
                errorDiv.textContent = 'Geçerli bir Türkiye IBAN numarası giriniz. (TR ile başlayan 26 karakter)';
                errorDiv.classList.remove('d-none');
            }
        }
    }

    handleIBANBlur(inputEl, fieldId) {
        if (!this.validateIBAN(inputEl.value)) {
            this.showFieldError(fieldId, 'Geçerli bir Türkiye IBAN numarası giriniz. (TR ile başlayan 26 karakter)');
        } else {
            this.clearFieldError(fieldId);
        }
    }

    handleIBANSection(show) {
        const ibanSection = document.getElementById('ibanSection');
        if (ibanSection) {
            if (show) {
                ibanSection.classList.remove('d-none');
            } else {
                ibanSection.classList.add('d-none');
                // IBAN alanlarını temizle
                const ibanAdSoyad = document.getElementById('ibanAdSoyad');
                const ibanInput = document.getElementById('ibanInput');
                if (ibanAdSoyad) {
                    ibanAdSoyad.value = '';
                    ibanAdSoyad.classList.remove('is-valid', 'is-invalid');
                    this.clearFieldError('ibanAdSoyad');
                }
                if (ibanInput) {
                    ibanInput.value = '';
                    ibanInput.classList.remove('is-valid', 'is-invalid');
                    this.clearFieldError('ibanInput');
                }
            }
        }
    }

    // Öğrenci konu 1003 - Neden seçenekleri
    handleStudentReason1003Section(show) {
        const section = document.getElementById('studentReason1003Section');
        if (!section) return;
        
        if (show) {
            section.classList.remove('d-none');
        } else {
            section.classList.add('d-none');
            this.resetStudentReasonSection();
        }
    }

    resetStudentReasonSection() {
        const reasonInputs = document.querySelectorAll('input[name="studentReason1003"]');
        reasonInputs.forEach(input => {
            input.checked = false;
        });
        this.toggleStudentReasonDetail('horizontal', false);
        this.toggleStudentReasonDetail('other', false);
        
        const horizontalField = document.getElementById('studentReasonHorizontalDetails');
        if (horizontalField) {
            // Tom Select instance'ı varsa onu da temizle
            if (this.universityTomSelect) {
                this.universityTomSelect.clear();
                this.universityTomSelect.wrapper.classList.remove('is-invalid');
            }
            horizontalField.value = '';
            horizontalField.classList.remove('is-invalid');
            this.clearFieldError('studentReasonHorizontalDetails');
        }
        
        const otherField = document.getElementById('studentReasonOtherDetails');
        if (otherField) {
            otherField.value = '';
            otherField.classList.remove('is-invalid');
            this.clearFieldError('studentReasonOtherDetails');
        }
        
        this.clearStudentReasonErrors();
    }

    setupStudentReasonEvents() {
        const reasonInputs = document.querySelectorAll('input[name="studentReason1003"]');
        if (!reasonInputs.length) {
            return;
        }
        reasonInputs.forEach(input => {
            input.addEventListener('change', (event) => this.handleStudentReasonChange(event));
        });
        
        ['studentReasonHorizontalDetails', 'studentReasonOtherDetails'].forEach(fieldId => {
            const field = document.getElementById(fieldId);
            if (field) {
                // Dropdown için 'change', textarea için 'input' event'i
                const eventType = field.tagName === 'SELECT' ? 'change' : 'input';
                field.addEventListener(eventType, () => {
                    field.classList.remove('is-invalid');
                    // Tom Select için wrapper'dan da is-invalid class'ını kaldır
                    if (fieldId === 'studentReasonHorizontalDetails' && this.universityTomSelect) {
                        this.universityTomSelect.wrapper.classList.remove('is-invalid');
                    }
                    this.clearFieldError(fieldId);
                });
            }
        });
    }

    handleStudentReasonChange(event) {
        const selectedValue = event.target.value;
        this.clearStudentReasonErrors();
        this.toggleStudentReasonDetail('horizontal', selectedValue === 'horizontal');
        this.toggleStudentReasonDetail('other', selectedValue === 'other');
    }

    async toggleStudentReasonDetail(detailType, show) {
        const wrapperId = detailType === 'horizontal'
            ? 'studentReasonHorizontalDetailsWrapper'
            : 'studentReasonOtherDetailsWrapper';
        const fieldId = detailType === 'horizontal'
            ? 'studentReasonHorizontalDetails'
            : 'studentReasonOtherDetails';
        const wrapper = document.getElementById(wrapperId);
        const field = document.getElementById(fieldId);
        
        if (!wrapper) return;
        
        if (show) {
            wrapper.classList.remove('d-none');
            // Eğer horizontal seçildiyse ve dropdown ise üniversiteleri yükle
            if (detailType === 'horizontal' && field && field.tagName === 'SELECT') {
                await this.loadUniversitiesIntoDropdown(field);
            }
        } else {
            wrapper.classList.add('d-none');
            if (field) {
                field.value = '';
                field.classList.remove('is-invalid');
            }
            this.clearFieldError(fieldId);
        }
    }

    async loadUniversitiesIntoDropdown(dropdownElement) {
        // Eğer Tom Select zaten initialize edilmişse tekrar yükleme
        if (this.universityTomSelect) {
            return;
        }
        
        try {
            // Cache'den kontrol et
            if (!this.universitiesList) {
                const response = await fetch(`${this.apiBaseUrl}/universities`);
                if (!response.ok) {
                    throw new Error('Üniversiteler yüklenemedi');
                }
                const data = await response.json();
                this.universitiesList = data.universities || [];
            }
            
            // Dropdown'ı temizle (ilk option hariç)
            dropdownElement.innerHTML = '<option value="">Üniversite seçiniz...</option>';
            
            // Üniversiteleri ekle
            this.universitiesList.forEach(university => {
                const option = document.createElement('option');
                option.value = university;
                option.textContent = university;
                dropdownElement.appendChild(option);
            });
            
            // Tom Select'i initialize et
            if (typeof TomSelect !== 'undefined') {
                const self = this;
                this.universityTomSelect = new TomSelect(dropdownElement, {
                    placeholder: 'Üniversite seçiniz veya arayın...',
                    allowEmptyOption: false,
                    maxOptions: null,
                    searchField: ['text'],
                    valueField: 'value',
                    labelField: 'text',
                    searchPlaceholder: 'Üniversite ara...',
                    plugins: ['clear_button'],
                    dropdownParent: 'body', // Dropdown'u body'ye ekle ki z-index sorunu olmasın
                    render: {
                        no_results: function(data, escape) {
                            return '<div class="no-results">Üniversite bulunamadı</div>';
                        },
                        option: function(data, escape) {
                            return '<div class="d-flex align-items-center"><i class="fas fa-university me-2 text-muted"></i>' + escape(data.text) + '</div>';
                        },
                        item: function(data, escape) {
                            return '<div class="d-flex align-items-center"><i class="fas fa-university me-2 text-muted"></i>' + escape(data.text) + '</div>';
                        }
                    },
                    onInitialize: function() {
                        // Custom styling için class ekle
                        this.wrapper.classList.add('university-select-wrapper');
                    },
                    onChange: function(value) {
                        // Değer değiştiğinde hata durumunu temizle
                        if (value) {
                            dropdownElement.classList.remove('is-invalid');
                            this.wrapper.classList.remove('is-invalid');
                            self.clearFieldError('studentReasonHorizontalDetails');
                        }
                    }
                });
            }
        } catch (error) {
            console.error('Üniversiteler yüklenirken hata:', error);
            // Hata durumunda kullanıcıya bilgi ver
            dropdownElement.innerHTML = '<option value="">Üniversiteler yüklenemedi. Lütfen sayfayı yenileyin.</option>';
        }
    }

    clearStudentReasonErrors() {
        const errorEl = document.getElementById('studentReason1003Error');
        if (errorEl) {
            errorEl.textContent = '';
        }
        const grid = document.getElementById('studentReason1003Grid');
        if (grid) {
            grid.classList.remove('is-invalid');
        }
    }

    setStudentReasonError(message) {
        const errorEl = document.getElementById('studentReason1003Error');
        if (errorEl) {
            errorEl.textContent = message;
        }
        const grid = document.getElementById('studentReason1003Grid');
        if (grid) {
            grid.classList.add('is-invalid');
        }
    }

    validateStudentReason1003() {
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect || parseInt(topicSelect.value, 10) !== 1003) {
            return true;
        }
        
        const selectedReason = document.querySelector('input[name="studentReason1003"]:checked');
        if (!selectedReason) {
            const message = this.languageManager?.getTranslation('studentReason1003.errors.reasonRequired') || 'Lütfen bir neden seçiniz.';
            this.setStudentReasonError(message);
            return false;
        }
        
        this.clearStudentReasonErrors();
        
        if (selectedReason.value === 'horizontal') {
            const horizontalField = document.getElementById('studentReasonHorizontalDetails');
            // Tom Select kullanılıyorsa value'yu ondan al
            let value = '';
            if (this.universityTomSelect) {
                value = this.universityTomSelect.getValue() || '';
            } else {
                value = horizontalField?.value.trim() || '';
            }
            if (!value || value === '') {
                const message = this.languageManager?.getTranslation('studentReason1003.errors.horizontalRequired') || 'Lütfen bir üniversite seçiniz.';
                this.showFieldError('studentReasonHorizontalDetails', message);
                this.toggleStudentReasonDetail('horizontal', true);
                return false;
            }
        }
        
        if (selectedReason.value === 'other') {
            const otherField = document.getElementById('studentReasonOtherDetails');
            const value = otherField?.value.trim() || '';
            if (value.length < 5) {
                const message = this.languageManager?.getTranslation('studentReason1003.errors.otherRequired') || 'Lütfen en az 5 karakter olacak şekilde açıklama yazınız.';
                this.showFieldError('studentReasonOtherDetails', message);
                this.toggleStudentReasonDetail('other', true);
                return false;
            }
        }
        
        return true;
    }
    
    // Konu 1004 - Kayıt dondurma nedenleri
    handleStudentFreezeSection(show) {
        const section = document.getElementById('studentFreezeReasonSection');
        if (!section) return;
        
        if (show) {
            section.classList.remove('d-none');
        } else {
            section.classList.add('d-none');
            this.resetStudentFreezeSection();
        }
    }

    resetStudentFreezeSection() {
        const reasonInputs = document.querySelectorAll('input[name="studentFreezeReason"]');
        reasonInputs.forEach(input => input.checked = false);
        this.toggleStudentFreezeOther(false);
        
        const otherField = document.getElementById('studentFreezeOtherDetails');
        if (otherField) {
            otherField.value = '';
            otherField.classList.remove('is-invalid');
            this.clearFieldError('studentFreezeOtherDetails');
        }
        
        const historyInputs = document.querySelectorAll('input[name="studentFreezeHistory"]');
        historyInputs.forEach(input => input.checked = false);
        this.clearStudentFreezeErrors();
        this.clearStudentFreezeHistoryError();

        // Talep dönemi ve akademik takvim alanlarını sıfırla
        const freezeRequestPeriod = document.getElementById('freezeRequestPeriod');
        const freezeStartYear = document.getElementById('freezeStartYear');
        const freezeStartTerm = document.getElementById('freezeStartTerm');
        const freezeEndInfo = document.getElementById('freezeEndInfo');

        if (freezeRequestPeriod) {
            freezeRequestPeriod.value = '';
            freezeRequestPeriod.classList.remove('is-invalid');
        }
        if (freezeStartYear) {
            freezeStartYear.value = '';
            freezeStartYear.classList.remove('is-invalid');
        }
        if (freezeStartTerm) {
            freezeStartTerm.value = '';
            freezeStartTerm.classList.remove('is-invalid');
        }
        if (freezeEndInfo) {
            const placeholder = this.languageManager?.getTranslation('studentFreeze.endInfoPlaceholder') ||
                'Talep dönemi, başlama yılı ve dönemi seçtiğinizde bitiş yılı ve dönemi burada otomatik görüntülenecektir.';
            freezeEndInfo.textContent = placeholder;
        }
    }

    setupStudentFreezeEvents() {
        const reasonInputs = document.querySelectorAll('input[name="studentFreezeReason"]');
        if (!reasonInputs.length) {
            return;
        }
        reasonInputs.forEach(input => {
            input.addEventListener('change', (event) => this.handleStudentFreezeReasonChange(event));
        });
        
        const otherField = document.getElementById('studentFreezeOtherDetails');
        if (otherField) {
            otherField.addEventListener('input', () => {
                otherField.classList.remove('is-invalid');
                this.clearFieldError('studentFreezeOtherDetails');
            });
        }
        
        const historyInputs = document.querySelectorAll('input[name="studentFreezeHistory"]');
        historyInputs.forEach(input => {
            input.addEventListener('change', () => {
                this.clearStudentFreezeHistoryError();
            });
        });

        // Talep dönemi ve akademik takvim alanları
        const freezeRequestPeriod = document.getElementById('freezeRequestPeriod');
        const freezeStartYear = document.getElementById('freezeStartYear');
        const freezeStartTerm = document.getElementById('freezeStartTerm');

        // Başlama yılları dropdown'unu dinamik doldur
        if (freezeStartYear && !freezeStartYear.dataset.initialized) {
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - 1;
            const endYear = currentYear + 4;

            for (let year = startYear; year <= endYear; year++) {
                const nextYear = year + 1;
                const option = document.createElement('option');
                option.value = `${year}-${nextYear}`;
                option.textContent = `${year}-${nextYear}`;
                freezeStartYear.appendChild(option);
            }

            freezeStartYear.dataset.initialized = 'true';
        }

        const onFreezeAcademicChange = () => {
            this.handleFreezeAcademicSelectionChange();
        };

        if (freezeRequestPeriod) {
            freezeRequestPeriod.addEventListener('change', () => {
                freezeRequestPeriod.classList.remove('is-invalid');
                this.clearFieldError('freezeRequestPeriod');
                onFreezeAcademicChange();
            });
        }
        if (freezeStartYear) {
            freezeStartYear.addEventListener('change', () => {
                freezeStartYear.classList.remove('is-invalid');
                this.clearFieldError('freezeStartYear');
                onFreezeAcademicChange();
            });
        }
        if (freezeStartTerm) {
            freezeStartTerm.addEventListener('change', () => {
                freezeStartTerm.classList.remove('is-invalid');
                this.clearFieldError('freezeStartTerm');
                onFreezeAcademicChange();
            });
        }
    }

    handleStudentFreezeReasonChange(event) {
        const selectedValue = event.target.value;
        this.clearStudentFreezeErrors();
        this.toggleStudentFreezeOther(selectedValue === 'other');
    }

    toggleStudentFreezeOther(show) {
        const wrapper = document.getElementById('studentFreezeOtherDetailsWrapper');
        const field = document.getElementById('studentFreezeOtherDetails');
        if (!wrapper) return;
        
        if (show) {
            wrapper.classList.remove('d-none');
        } else {
            wrapper.classList.add('d-none');
            if (field) {
                field.value = '';
                field.classList.remove('is-invalid');
                this.clearFieldError('studentFreezeOtherDetails');
            }
        }
    }

    clearStudentFreezeErrors() {
        const errorEl = document.getElementById('studentFreezeReasonError');
        if (errorEl) {
            errorEl.textContent = '';
        }
        const grid = document.getElementById('studentFreezeReasonGrid');
        if (grid) {
            grid.classList.remove('is-invalid');
        }
    }

    setStudentFreezeError(message) {
        const errorEl = document.getElementById('studentFreezeReasonError');
        if (errorEl) {
            errorEl.textContent = message;
        }
        const grid = document.getElementById('studentFreezeReasonGrid');
        if (grid) {
            grid.classList.add('is-invalid');
        }
    }

    clearStudentFreezeHistoryError() {
        const errorEl = document.getElementById('studentFreezeHistoryError');
        if (errorEl) {
            errorEl.textContent = '';
        }
        const wrapper = document.getElementById('studentFreezeHistoryOptions');
        if (wrapper) {
            wrapper.classList.remove('is-invalid');
        }
    }

    setStudentFreezeHistoryError(message) {
        const errorEl = document.getElementById('studentFreezeHistoryError');
        if (errorEl) {
            errorEl.textContent = message;
        }
        const wrapper = document.getElementById('studentFreezeHistoryOptions');
        if (wrapper) {
            wrapper.classList.add('is-invalid');
        }
    }

    handleFreezeAcademicSelectionChange() {
        const freezeRequestPeriod = document.getElementById('freezeRequestPeriod');
        const freezeStartYear = document.getElementById('freezeStartYear');
        const freezeStartTerm = document.getElementById('freezeStartTerm');
        const freezeEndInfo = document.getElementById('freezeEndInfo');

        if (!freezeEndInfo) return;

        const periodValue = freezeRequestPeriod?.value;
        const startYearValue = freezeStartYear?.value;
        const startTermValue = freezeStartTerm?.value;

        if (!periodValue || !startYearValue || !startTermValue) {
            const placeholder = this.languageManager?.getTranslation('studentFreeze.endInfoPlaceholder') ||
                'Talep dönemi, başlama yılı ve dönemi seçtiğinizde bitiş yılı ve dönemi burada otomatik görüntülenecektir.';
            freezeEndInfo.textContent = placeholder;
            return;
        }

        const periodCount = parseInt(periodValue, 10);
        if (isNaN(periodCount) || periodCount < 1) {
            return;
        }

        const terms = ['guz', 'bahar'];
        let startIndex = terms.indexOf(startTermValue);
        if (startIndex === -1) {
            return;
        }

        const [startYear1Str, startYear2Str] = startYearValue.split('-');
        let startYear1 = parseInt(startYear1Str, 10);
        let startYear2 = parseInt(startYear2Str, 10);
        if (isNaN(startYear1) || isNaN(startYear2)) {
            return;
        }

        // N yarıyıl için bitiş yarıyılı: (N-1) adım ilerle
        let steps = periodCount - 1;
        let endIndex = startIndex;
        let yearOffset = 0;

        while (steps > 0) {
            endIndex += 1;
            if (endIndex >= terms.length) {
                endIndex = 0;
                yearOffset += 1;
            }
            steps -= 1;
        }

        const endYear1 = startYear1 + yearOffset;
        const endYear2 = startYear2 + yearOffset;
        const endYearText = `${endYear1}-${endYear2}`;
        const endTermValue = terms[endIndex];

        const termLabelKey = endTermValue === 'guz' ? 'studentFreeze.term.fall' : 'studentFreeze.term.spring';
        const termLabel = this.languageManager?.getTranslation(termLabelKey) || (endTermValue === 'guz' ? 'Güz' : 'Bahar');

        const startTermLabelKey = startTermValue === 'guz' ? 'studentFreeze.term.fall' : 'studentFreeze.term.spring';
        const startTermLabel = this.languageManager?.getTranslation(startTermLabelKey) || (startTermValue === 'guz' ? 'Güz' : 'Bahar');

        const labelTemplate = this.languageManager?.getTranslation('studentFreeze.endInfoComputed') ||
            'Başlangıç: {startYear} {startTerm} • Bitiş: {endYear} {endTerm}';

        const text = labelTemplate
            .replace('{startYear}', startYearValue)
            .replace('{startTerm}', startTermLabel)
            .replace('{endYear}', endYearText)
            .replace('{endTerm}', termLabel);

        freezeEndInfo.textContent = text;

        // Bitiş değerlerini data attribute olarak da sakla (gerekirse backend tarafında kullanılabilir)
        freezeEndInfo.dataset.startYear = startYearValue;
        freezeEndInfo.dataset.startTerm = startTermValue;
        freezeEndInfo.dataset.endYear = endYearText;
        freezeEndInfo.dataset.endTerm = endTermValue;
    }

    validateStudentFreezeSection() {
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect || parseInt(topicSelect.value, 10) !== 1004) {
            return true;
        }
        
        const selectedReason = document.querySelector('input[name="studentFreezeReason"]:checked');
        const errors = [];

        if (!selectedReason) {
            const message = this.languageManager?.getTranslation('studentFreeze.errors.reasonRequired') || 'Lütfen kayıt dondurma nedenini seçiniz.';
            this.setStudentFreezeError(message);
            errors.push({ fieldId: 'studentFreezeReasonGrid', message });
        } else {
            this.clearStudentFreezeErrors();

            if (selectedReason.value === 'other') {
                const otherField = document.getElementById('studentFreezeOtherDetails');
                const value = otherField?.value.trim() || '';
                if (value.length < 5) {
                    const message = this.languageManager?.getTranslation('studentFreeze.errors.otherRequired') || 'Diğer nedeni en az 5 karakter olacak şekilde belirtiniz.';
                    this.showFieldError('studentFreezeOtherDetails', message);
                    this.toggleStudentFreezeOther(true);
                    errors.push({ fieldId: 'studentFreezeOtherDetails', message });
                }
            }
        }

        const historySelection = document.querySelector('input[name="studentFreezeHistory"]:checked');
        if (!historySelection) {
            const message = this.languageManager?.getTranslation('studentFreeze.errors.historyRequired') || 'Lütfen önceki yıllarda kayıt dondurma durumunu seçiniz.';
            this.setStudentFreezeHistoryError(message);
            errors.push({ fieldId: 'studentFreezeHistoryOptions', message });
        } else {
            this.clearStudentFreezeHistoryError();
        }

        const freezeRequestPeriod = document.getElementById('freezeRequestPeriod');
        const freezeStartYear = document.getElementById('freezeStartYear');
        const freezeStartTerm = document.getElementById('freezeStartTerm');

        if (!freezeRequestPeriod || !freezeRequestPeriod.value) {
            const message = this.languageManager?.getTranslation('studentFreeze.errors.periodRequired') || 'Lütfen talep dönemi bilgisini seçiniz.';
            this.showFieldError('freezeRequestPeriod', message);
            errors.push({ fieldId: 'freezeRequestPeriod', message });
        }

        if (!freezeStartYear || !freezeStartYear.value) {
            const message = this.languageManager?.getTranslation('studentFreeze.errors.startYearRequired') || 'Lütfen başlama yılını seçiniz.';
            this.showFieldError('freezeStartYear', message);
            errors.push({ fieldId: 'freezeStartYear', message });
        }

        if (!freezeStartTerm || !freezeStartTerm.value) {
            const message = this.languageManager?.getTranslation('studentFreeze.errors.startTermRequired') || 'Lütfen başlama dönemini seçiniz.';
            this.showFieldError('freezeStartTerm', message);
            errors.push({ fieldId: 'freezeStartTerm', message });
        }

        return errors.length === 0 ? true : errors;
    }

    // Konu 1006 - Muafiyet başvurusu
    handleStudentExemptionSection(show) {
        const section = document.getElementById('studentExemptionSection');
        if (!section) return;

        if (show) {
            this.setupStudentExemptionEvents();
            section.classList.remove('d-none');
            if (this.exemptionCoursesBody && !this.exemptionCoursesBody.childElementCount) {
                this.addExemptionCourseRow();
            }
        } else {
            section.classList.add('d-none');
            this.resetStudentExemptionSection();
        }
    }

    resetStudentExemptionSection() {
        if (!this.exemptionCoursesBody) {
            this.exemptionCoursesBody = document.getElementById('exemptionCoursesBody');
        }
        if (!this.exemptionCoursesError) {
            this.exemptionCoursesError = document.getElementById('exemptionCoursesError');
        }
        if (this.exemptionCoursesBody) {
            this.exemptionCoursesBody.innerHTML = '';
            this.addExemptionCourseRow();
        }
        if (this.exemptionCoursesError) {
            this.exemptionCoursesError.textContent = '';
        }

        this.studentExemptionFiles = {
            appendix1: null,
            appendix2: null
        };

        ['exemptionAppendix1', 'exemptionAppendix2'].forEach(id => {
            const input = document.getElementById(id);
            const info = document.getElementById(`${id}Info`);
            const uploadArea = document.getElementById(`${id}UploadArea`);
            const errorEl = document.getElementById(`${id}Error`);
            if (input) input.value = '';
            if (info) info.classList.add('d-none');
            if (uploadArea) uploadArea.style.display = 'block';
            if (errorEl) errorEl.textContent = '';
        });
    }

    setupStudentExemptionEvents() {
        if (this.exemptionEventsInitialized) {
            return;
        }
        this.exemptionEventsInitialized = true;
        this.exemptionCoursesBody = document.getElementById('exemptionCoursesBody');
        this.exemptionCoursesError = document.getElementById('exemptionCoursesError');
        const addRowBtn = document.getElementById('addExemptionCourseRowBtn');
        if (addRowBtn) {
            addRowBtn.addEventListener('click', () => this.addExemptionCourseRow());
        }
        if (this.exemptionCoursesBody && !this.exemptionCoursesBody.childElementCount) {
            this.addExemptionCourseRow();
        }
        ['exemptionAppendix1', 'exemptionAppendix2'].forEach((inputId, index) => {
            this.setupExemptionDocumentUpload(inputId, `appendix${index + 1}`);
        });
        this.setupThreeCourseTranscriptUpload();
    }

    addExemptionCourseRow(prefill = {}) {
        if (!this.exemptionCoursesBody) return;
        const currentRows = this.exemptionCoursesBody.querySelectorAll('tr[data-exemption-row]').length;
        if (this.exemptionCourseMaxRows && currentRows >= this.exemptionCourseMaxRows) {
            const message = this.languageManager?.getTranslation('studentExemption1006.errors.maxRows') || 'You can add up to 8 rows.';
            this.showWarningToast(message, 'Bilgi');
            return;
        }

        const row = document.createElement('tr');
        row.dataset.exemptionRow = 'true';
        row.innerHTML = `
            <td>
                <input type="text" class="form-control" data-field="code" placeholder="CS101" aria-label="Course code">
            </td>
            <td>
                <input type="text" class="form-control" data-field="name" placeholder="Course Name" aria-label="Course name">
            </td>
            <td>
                <input type="text" class="form-control" data-field="credit" placeholder="3" aria-label="Credit">
            </td>
            <td>
                <input type="text" class="form-control" data-field="ects" placeholder="5" aria-label="ECTS">
            </td>
            <td>
                <input type="text" class="form-control" data-field="grade" placeholder="AA" aria-label="Letter grade">
            </td>
            <td>
                <button type="button" class="btn btn-outline-danger btn-sm remove-exemption-row-btn" aria-label="Satırı kaldır">
                    <i class="fas fa-times"></i>
                </button>
            </td>
        `;
        this.exemptionCoursesBody.appendChild(row);

        row.querySelectorAll('input[data-field]').forEach(input => {
            const key = input.dataset.field;
            if (prefill[key]) {
                input.value = prefill[key];
            }
            input.addEventListener('input', () => {
                input.classList.remove('is-invalid');
                row.classList.remove('invalid-row');
                if (this.exemptionCoursesError) {
                    this.exemptionCoursesError.textContent = '';
                }
            });
        });

        const removeBtn = row.querySelector('.remove-exemption-row-btn');
        if (removeBtn) {
            removeBtn.addEventListener('click', () => this.removeExemptionCourseRow(row));
        }

        this.updateExemptionRemoveButtons();
    }

    removeExemptionCourseRow(row) {
        if (!this.exemptionCoursesBody) return;
        const rowCount = this.exemptionCoursesBody.querySelectorAll('tr[data-exemption-row]').length;
        if (rowCount <= this.exemptionCourseMinRows) {
            return;
        }
        row.remove();
        this.updateExemptionRemoveButtons();
    }

    updateExemptionRemoveButtons() {
        if (!this.exemptionCoursesBody) return;
        const rows = Array.from(this.exemptionCoursesBody.querySelectorAll('tr[data-exemption-row]'));
        const disable = rows.length <= this.exemptionCourseMinRows;
        rows.forEach(row => {
            const removeBtn = row.querySelector('.remove-exemption-row-btn');
            if (removeBtn) {
                removeBtn.disabled = disable;
            }
        });
    }

    collectExemptionCourseData() {
        if (!this.exemptionCoursesBody) return [];
        const rows = Array.from(this.exemptionCoursesBody.querySelectorAll('tr[data-exemption-row]'));
        return rows.map(row => {
            const getValue = (field) => row.querySelector(`[data-field="${field}"]`)?.value.trim() || '';
            return {
                course_code: getValue('code'),
                course_name: getValue('name'),
                credit: getValue('credit'),
                ects: getValue('ects'),
                letter_grade: getValue('grade')
            };
        }).filter(item => Object.values(item).some(value => value));
    }

    validateStudentExemptionSection() {
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect || parseInt(topicSelect.value, 10) !== 1006) {
            return true;
        }

        if (!this.exemptionCoursesBody) {
            this.setupStudentExemptionEvents();
        }

        const rows = Array.from(this.exemptionCoursesBody?.querySelectorAll('tr[data-exemption-row]') || []);
        let filledRowCount = 0;
        let rowError = false;
        const errorMessageRow = this.languageManager?.getTranslation('studentExemption1006.errors.rowRequired') || 'All columns must be filled.';
        const errorMessageTable = this.languageManager?.getTranslation('studentExemption1006.errors.tableRequired') || 'Please add at least one course row.';

        rows.forEach(row => {
            const inputs = Array.from(row.querySelectorAll('input[data-field]'));
            const values = inputs.map(input => input.value.trim());
            const hasAny = values.some(v => v.length > 0);
            const hasAll = values.every(v => v.length > 0);

            if (hasAny && !hasAll) {
                rowError = true;
                row.classList.add('invalid-row');
                inputs.forEach(input => {
                    if (!input.value.trim()) {
                        input.classList.add('is-invalid');
                    }
                });
            } else {
                row.classList.remove('invalid-row');
                inputs.forEach(input => input.classList.remove('is-invalid'));
            }

            if (hasAll) {
                filledRowCount += 1;
            }
        });

        if (rowError) {
            if (this.exemptionCoursesError) {
                this.exemptionCoursesError.textContent = errorMessageRow;
            }
            return false;
        }

        if (filledRowCount === 0) {
            if (this.exemptionCoursesError) {
                this.exemptionCoursesError.textContent = errorMessageTable;
            }
            return false;
        }

        if (this.exemptionCoursesError) {
            this.exemptionCoursesError.textContent = '';
        }

        const docMessage = this.languageManager?.getTranslation('studentExemption1006.errors.documentRequired') || 'This document is required.';
        const docMap = [
            { key: 'appendix1', errorId: 'exemptionAppendix1Error' },
            { key: 'appendix2', errorId: 'exemptionAppendix2Error' }
        ];

        let docError = false;
        docMap.forEach(doc => {
            if (!this.studentExemptionFiles[doc.key]) {
                const errorEl = document.getElementById(doc.errorId);
                if (errorEl) {
                    errorEl.textContent = docMessage;
                }
                docError = true;
            } else {
                const errorEl = document.getElementById(doc.errorId);
                if (errorEl) {
                    errorEl.textContent = '';
                }
            }
        });

        return !docError;
    }

    setupExemptionDocumentUpload(fileInputId, fileKey) {
        const fileInput = document.getElementById(fileInputId);
        const uploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const removeBtn = document.getElementById(`remove${fileInputId.charAt(0).toUpperCase()}${fileInputId.slice(1)}Btn`);

        if (!fileInput || !uploadArea) return;
        if (uploadArea.dataset.exemptionInit === 'true') return;
        uploadArea.dataset.exemptionInit = 'true';

        uploadArea.addEventListener('click', () => fileInput.click());
        fileInput.addEventListener('change', (e) => this.handleExemptionDocumentSelect(e.target.files[0], fileKey, fileInputId));
        uploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            uploadArea.classList.add('dragover');
        });
        uploadArea.addEventListener('dragleave', () => {
            uploadArea.classList.remove('dragover');
        });
        uploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            uploadArea.classList.remove('dragover');
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleExemptionDocumentSelect(files[0], fileKey, fileInputId);
            }
        });

        if (removeBtn) {
            removeBtn.addEventListener('click', () => this.removeExemptionDocumentFile(fileKey, fileInputId));
        }
    }

    handleExemptionDocumentSelect(file, fileKey, fileInputId) {
        if (!file) return;
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const extension = '.' + (file.name.split('.').pop() || '').toLowerCase();

        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(extension)) {
            const message = 'Sadece PDF, JPG, JPEG ve PNG dosyaları yüklenebilir.';
            const errorEl = document.getElementById(`${fileInputId}Error`);
            if (errorEl) errorEl.textContent = message;
            const input = document.getElementById(fileInputId);
            if (input) input.value = '';
            return;
        }

        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            const message = 'Dosya boyutu maksimum 10MB olmalıdır.';
            const errorEl = document.getElementById(`${fileInputId}Error`);
            if (errorEl) errorEl.textContent = message;
            const input = document.getElementById(fileInputId);
            if (input) input.value = '';
            return;
        }

        this.studentExemptionFiles[fileKey] = file;

        const info = document.getElementById(`${fileInputId}Info`);
        const uploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileName = document.getElementById(`${fileInputId}FileName`);
        const fileSize = document.getElementById(`${fileInputId}FileSize`);
        if (info) {
            info.classList.remove('d-none');
        }
        if (uploadArea) {
            uploadArea.style.display = 'none';
        }
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);

        const errorEl = document.getElementById(`${fileInputId}Error`);
        if (errorEl) errorEl.textContent = '';
    }

    removeExemptionDocumentFile(fileKey, fileInputId) {
        this.studentExemptionFiles[fileKey] = null;
        const input = document.getElementById(fileInputId);
        const info = document.getElementById(`${fileInputId}Info`);
        const uploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const errorEl = document.getElementById(`${fileInputId}Error`);

        if (input) input.value = '';
        if (info) info.classList.add('d-none');
        if (uploadArea) uploadArea.style.display = 'block';
        if (errorEl) errorEl.textContent = '';
    }

    async appendExemptionDocumentsToFormData(formData) {
        const docs = [
            { key: 'appendix1', formKey: 'konu_1006_appendix1' },
            { key: 'appendix2', formKey: 'konu_1006_appendix2' }
        ];

        for (const doc of docs) {
            const file = this.studentExemptionFiles[doc.key];
            if (!file) {
                continue;
            }
            let mimetype = file.type || '';
            let fileToUpload = file;
            
            // Normal formdaki gibi multipart olarak gönder (sıkıştırma frontend'de)
            if (mimetype && mimetype.startsWith('image/')) {
                // Resimleri sıkıştır ve Blob olarak ekle
                const compressedBase64 = await this.compressImageToBase64(file, 1280, 1280, 0.75);
                const compressedBlob = this.base64ToBlob(compressedBase64, 'image/jpeg');
                fileToUpload = new File([compressedBlob], file.name || 'image.jpg', { type: 'image/jpeg' });
                mimetype = 'image/jpeg';
            }
            // Dosyayı multipart olarak ekle (backend'de sıkıştırma yapılacak ve base64'e çevrilecek)
            formData.append(doc.formKey, fileToUpload);
            formData.append(`${doc.formKey}_mimetype`, mimetype);
        }
    }

    // Konu 1008 - Çift Anadal/Yandal Ders Bilgileri
    handleStudentDoubleMinorSection(show) {
        const section = document.getElementById('studentDoubleMinorSection');
        if (!section) return;

        if (show) {
            this.setupStudentDoubleMinorEvents();
            section.classList.remove('d-none');
            if (this.doubleMinorCoursesBody && !this.doubleMinorCoursesBody.childElementCount) {
                this.addDoubleMinorCourseRow();
            }
        } else {
            section.classList.add('d-none');
            this.resetStudentDoubleMinorSection();
        }
    }

    resetStudentDoubleMinorSection() {
        if (!this.doubleMinorCoursesBody) {
            this.doubleMinorCoursesBody = document.getElementById('doubleMinorCoursesBody');
        }
        if (!this.doubleMinorCoursesError) {
            this.doubleMinorCoursesError = document.getElementById('doubleMinorCoursesError');
        }
        if (this.doubleMinorCoursesBody) {
            this.doubleMinorCoursesBody.innerHTML = '';
            this.addDoubleMinorCourseRow();
        }
        if (this.doubleMinorCoursesError) {
            this.doubleMinorCoursesError.textContent = '';
        }
        
        // Program tipi seçimini sıfırla
        const programTypeInputs = document.querySelectorAll('input[name="programType1008"]');
        programTypeInputs.forEach(input => {
            input.checked = false;
            input.classList.remove('is-invalid');
        });
        this.doubleMinorProgramType = null;
        const programTypeError = document.getElementById('programType1008Error');
        if (programTypeError) {
            programTypeError.textContent = '';
        }
    }

    setupStudentDoubleMinorEvents() {
        if (this.doubleMinorEventsInitialized) {
            return;
        }
        this.doubleMinorEventsInitialized = true;
        this.doubleMinorCoursesBody = document.getElementById('doubleMinorCoursesBody');
        this.doubleMinorCoursesError = document.getElementById('doubleMinorCoursesError');
        const addRowBtn = document.getElementById('addDoubleMinorCourseRowBtn');
        if (addRowBtn) {
            addRowBtn.addEventListener('click', () => this.addDoubleMinorCourseRow());
        }
        if (this.doubleMinorCoursesBody && !this.doubleMinorCoursesBody.childElementCount) {
            this.addDoubleMinorCourseRow();
        }
        
        // Program tipi seçimi event'leri
        const programTypeInputs = document.querySelectorAll('input[name="programType1008"]');
        programTypeInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.doubleMinorProgramType = e.target.value;
                const errorEl = document.getElementById('programType1008Error');
                if (errorEl) {
                    errorEl.textContent = '';
                }
                // Tüm input'lardan is-invalid'i kaldır
                programTypeInputs.forEach(inp => inp.classList.remove('is-invalid'));
            });
        });
    }

    addDoubleMinorCourseRow(prefill = {}) {
        if (!this.doubleMinorCoursesBody) return;
        const currentRows = this.doubleMinorCoursesBody.querySelectorAll('tr[data-double-minor-row]').length;
        if (this.doubleMinorCourseMaxRows && currentRows >= this.doubleMinorCourseMaxRows) {
            this.showWarningToast('En fazla 8 satır ekleyebilirsiniz.', 'Bilgi');
            return;
        }

        const row = document.createElement('tr');
        row.dataset.doubleMinorRow = 'true';
        const rowNumber = currentRows + 1;
        row.innerHTML = `
            <td>
                <input type="text" class="form-control form-control-sm" data-field="code" 
                       value="${prefill.course_code || ''}" 
                       placeholder="CS101" required>
            </td>
            <td>
                <input type="text" class="form-control form-control-sm" data-field="name" 
                       value="${prefill.course_name || ''}" 
                       placeholder="Programlama Temelleri" required>
            </td>
            <td>
                <input type="text" class="form-control form-control-sm" data-field="credit" 
                       value="${prefill.credit || ''}" 
                       placeholder="3" required>
            </td>
            <td>
                <input type="text" class="form-control form-control-sm" data-field="ects" 
                       value="${prefill.ects || ''}" 
                       placeholder="5" required>
            </td>
            <td>
                <input type="text" class="form-control form-control-sm" data-field="grade" 
                       value="${prefill.letter_grade || ''}" 
                       placeholder="AA" required>
            </td>
            <td class="text-center">
                <button type="button" class="btn btn-sm btn-outline-danger remove-double-minor-row-btn" 
                        onclick="app.removeDoubleMinorCourseRow(this.closest('tr'))">
                    <i class="fas fa-times"></i>
                </button>
            </td>
        `;
        this.doubleMinorCoursesBody.appendChild(row);
        this.updateDoubleMinorRemoveButtons();
    }

    removeDoubleMinorCourseRow(row) {
        if (!this.doubleMinorCoursesBody) return;
        const rowCount = this.doubleMinorCoursesBody.querySelectorAll('tr[data-double-minor-row]').length;
        if (rowCount <= this.doubleMinorCourseMinRows) {
            return;
        }
        row.remove();
        this.updateDoubleMinorRemoveButtons();
    }

    updateDoubleMinorRemoveButtons() {
        if (!this.doubleMinorCoursesBody) return;
        const rows = Array.from(this.doubleMinorCoursesBody.querySelectorAll('tr[data-double-minor-row]'));
        const disable = rows.length <= this.doubleMinorCourseMinRows;
        rows.forEach(row => {
            const removeBtn = row.querySelector('.remove-double-minor-row-btn');
            if (removeBtn) {
                removeBtn.disabled = disable;
            }
        });
    }

    collectDoubleMinorCourseData() {
        if (!this.doubleMinorCoursesBody) return [];
        const rows = Array.from(this.doubleMinorCoursesBody.querySelectorAll('tr[data-double-minor-row]'));
        return rows.map(row => {
            const getValue = (field) => row.querySelector(`[data-field="${field}"]`)?.value.trim() || '';
            return {
                course_code: getValue('code'),
                course_name: getValue('name'),
                credit: getValue('credit'),
                ects: getValue('ects'),
                letter_grade: getValue('grade')
            };
        }).filter(item => Object.values(item).some(value => value));
    }

    validateStudentDoubleMinorSection() {
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect || parseInt(topicSelect.value, 10) !== 1008) {
            return true;
        }

        if (!this.doubleMinorCoursesBody) {
            this.setupStudentDoubleMinorEvents();
        }

        // Program tipi kontrolü
        const programTypeInputs = document.querySelectorAll('input[name="programType1008"]:checked');
        if (programTypeInputs.length === 0) {
            const errorEl = document.getElementById('programType1008Error');
            if (errorEl) {
                errorEl.textContent = this.languageManager?.getTranslation('validation.programTypeRequired') || 'Lütfen program tipini seçiniz (Çift Anadal veya Yandal).';
            }
            // Tüm input'lara is-invalid ekle
            document.querySelectorAll('input[name="programType1008"]').forEach(input => {
                input.classList.add('is-invalid');
            });
            return false;
        } else {
            const errorEl = document.getElementById('programType1008Error');
            if (errorEl) {
                errorEl.textContent = '';
            }
            document.querySelectorAll('input[name="programType1008"]').forEach(input => {
                input.classList.remove('is-invalid');
            });
        }

        const rows = Array.from(this.doubleMinorCoursesBody?.querySelectorAll('tr[data-double-minor-row]') || []);
        let filledRowCount = 0;
        let rowError = false;

        rows.forEach(row => {
            const inputs = Array.from(row.querySelectorAll('input[data-field]'));
            const values = inputs.map(input => input.value.trim());
            const hasAny = values.some(v => v.length > 0);
            const hasAll = values.every(v => v.length > 0);

            if (hasAny && !hasAll) {
                rowError = true;
                row.classList.add('invalid-row');
                inputs.forEach(input => {
                    if (!input.value.trim()) {
                        input.classList.add('is-invalid');
                    }
                });
            } else {
                row.classList.remove('invalid-row');
                inputs.forEach(input => input.classList.remove('is-invalid'));
            }

            if (hasAll) {
                filledRowCount += 1;
            }
        });

        if (rowError && this.doubleMinorCoursesError) {
            this.doubleMinorCoursesError.textContent = 'Tüm sütunları doldurunuz.';
        } else if (this.doubleMinorCoursesError) {
            this.doubleMinorCoursesError.textContent = '';
        }

        if (filledRowCount === 0) {
            if (this.doubleMinorCoursesError) {
                this.doubleMinorCoursesError.textContent = 'Lütfen en az bir ders satırı ekleyiniz.';
            }
            return false;
        }

        return !rowError;
    }

    // Konu 1007 - Üç ders başvurusu
    handleStudentThreeCourseSection(show) {
        const section = document.getElementById('studentThreeCourseSection');
        if (!section) return;

        if (show) {
            this.setupStudentThreeCourseEvents();
            section.classList.remove('d-none');
        } else {
            section.classList.add('d-none');
            this.resetStudentThreeCourseSection();
        }
    }

    setupStudentThreeCourseEvents() {
        if (this.threeCourseEventsInitialized) {
            return;
        }
        this.threeCourseEventsInitialized = true;
        this.threeCourseTableBody = document.getElementById('threeCourseTableBody');
        this.threeCourseTableError = document.getElementById('threeCourseTableError');
        const inputs = document.querySelectorAll('[data-three-course-input]');
        inputs.forEach(input => {
            input.addEventListener('input', () => {
                input.classList.remove('is-invalid');
                const row = input.closest('tr');
                if (row) {
                    row.classList.remove('invalid-row');
                }
                if (this.threeCourseTableError) {
                    this.threeCourseTableError.textContent = '';
                }
            });
        });
        this.setupThreeCourseTranscriptUpload();
    }

    resetStudentThreeCourseSection() {
        if (!this.threeCourseTableBody) {
            this.threeCourseTableBody = document.getElementById('threeCourseTableBody');
        }
        if (!this.threeCourseTableError) {
            this.threeCourseTableError = document.getElementById('threeCourseTableError');
        }
        if (this.threeCourseTableBody) {
            this.threeCourseTableBody.querySelectorAll('[data-three-course-input]').forEach(input => {
                input.value = '';
                input.classList.remove('is-invalid');
            });
            this.threeCourseTableBody.querySelectorAll('tr').forEach(row => row.classList.remove('invalid-row'));
        }
        if (this.threeCourseTableError) {
            this.threeCourseTableError.textContent = '';
        }
        this.removeThreeCourseTranscriptFile();
    }

    collectThreeCourseData() {
        if (!this.threeCourseTableBody) {
            this.threeCourseTableBody = document.getElementById('threeCourseTableBody');
        }
        const rows = Array.from(this.threeCourseTableBody?.querySelectorAll('tr[data-three-course-row]') || []);
        return rows.map(row => {
            const getValue = (field) => row.querySelector(`[data-field="${field}"]`)?.value.trim() || '';
            return {
                row: row.dataset.threeCourseRow || '',
                course_code: getValue('code'),
                course_name: getValue('name'),
                credit: getValue('credit'),
                ects: getValue('ects'),
                letter_grade: getValue('grade')
            };
        });
    }

    validateStudentThreeCourseSection() {
        const topicSelect = document.getElementById('ticketTopic');
        if (!topicSelect || parseInt(topicSelect.value, 10) !== 1007) {
            return true;
        }
        this.setupStudentThreeCourseEvents();
        const rows = Array.from(this.threeCourseTableBody?.querySelectorAll('tr[data-three-course-row]') || []);
        const errorMessage = this.languageManager?.getTranslation('studentThreeCourse1007.errors.rowRequired') || 'All rows must be completed.';
        const docErrorMessage = this.languageManager?.getTranslation('studentThreeCourse1007.errors.documentRequired') || 'Please upload your transcript document.';
        let isValid = true;

        rows.forEach(row => {
            const inputs = Array.from(row.querySelectorAll('[data-three-course-input]'));
            const hasAll = inputs.every(input => input.value.trim().length > 0);
            if (!hasAll) {
                row.classList.add('invalid-row');
                inputs.forEach(input => {
                    if (!input.value.trim()) {
                        input.classList.add('is-invalid');
                    }
                });
                isValid = false;
            } else {
                row.classList.remove('invalid-row');
                inputs.forEach(input => input.classList.remove('is-invalid'));
            }
        });

        if (!isValid && this.threeCourseTableError) {
            this.threeCourseTableError.textContent = errorMessage;
        } else if (this.threeCourseTableError) {
            this.threeCourseTableError.textContent = '';
        }
        if (!this.threeCourseTranscriptFile) {
            const errEl = document.getElementById('threeCourseTranscriptError');
            if (errEl) errEl.textContent = docErrorMessage;
            isValid = false;
        } else {
            const errEl = document.getElementById('threeCourseTranscriptError');
            if (errEl) errEl.textContent = '';
        }
        return isValid;
    }

    setupThreeCourseTranscriptUpload() {
        const fileInput = document.getElementById('threeCourseTranscript');
        const uploadArea = document.getElementById('threeCourseTranscriptUploadArea');
        const removeBtn = document.getElementById('removeThreeCourseTranscriptBtn');

        if (!fileInput || !uploadArea) return;
        if (uploadArea.dataset.threeCourseInit === 'true') return;
        uploadArea.dataset.threeCourseInit = 'true';

        uploadArea.addEventListener('click', () => fileInput.click());
        fileInput.addEventListener('change', (e) => this.handleThreeCourseTranscriptSelect(e.target.files[0]));
        uploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            uploadArea.classList.add('dragover');
        });
        uploadArea.addEventListener('dragleave', () => uploadArea.classList.remove('dragover'));
        uploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            uploadArea.classList.remove('dragover');
            const files = e.dataTransfer.files;
            if (files.length) {
                this.handleThreeCourseTranscriptSelect(files[0]);
            }
        });
        if (removeBtn) {
            removeBtn.addEventListener('click', () => this.removeThreeCourseTranscriptFile());
        }
    }

    handleThreeCourseTranscriptSelect(file) {
        if (!file) return;
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const extension = '.' + (file.name.split('.').pop() || '').toLowerCase();

        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(extension)) {
            const errorEl = document.getElementById('threeCourseTranscriptError');
            if (errorEl) errorEl.textContent = 'Sadece PDF, JPG, JPEG ve PNG dosyaları yüklenebilir.';
            const input = document.getElementById('threeCourseTranscript');
            if (input) input.value = '';
            return;
        }

        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            const errorEl = document.getElementById('threeCourseTranscriptError');
            if (errorEl) errorEl.textContent = 'Dosya boyutu maksimum 10MB olmalıdır.';
            const input = document.getElementById('threeCourseTranscript');
            if (input) input.value = '';
            return;
        }

        this.threeCourseTranscriptFile = file;
        const info = document.getElementById('threeCourseTranscriptInfo');
        const uploadArea = document.getElementById('threeCourseTranscriptUploadArea');
        const fileName = document.getElementById('threeCourseTranscriptFileName');
        const fileSize = document.getElementById('threeCourseTranscriptFileSize');

        if (info) info.classList.remove('d-none');
        if (uploadArea) uploadArea.style.display = 'none';
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);

        const errorEl = document.getElementById('threeCourseTranscriptError');
        if (errorEl) errorEl.textContent = '';
    }

    removeThreeCourseTranscriptFile() {
        this.threeCourseTranscriptFile = null;
        const input = document.getElementById('threeCourseTranscript');
        const info = document.getElementById('threeCourseTranscriptInfo');
        const uploadArea = document.getElementById('threeCourseTranscriptUploadArea');
        const errorEl = document.getElementById('threeCourseTranscriptError');

        if (input) input.value = '';
        if (info) info.classList.add('d-none');
        if (uploadArea) uploadArea.style.display = 'block';
        if (errorEl) errorEl.textContent = '';
    }

    async appendThreeCourseTranscriptToFormData(formData) {
        if (!this.threeCourseTranscriptFile) return;
        let mimetype = this.threeCourseTranscriptFile.type || '';
        let fileToUpload = this.threeCourseTranscriptFile;
        
        // Normal formdaki gibi multipart olarak gönder (sıkıştırma frontend'de)
        if (mimetype && mimetype.startsWith('image/')) {
            // Resimleri sıkıştır ve Blob olarak ekle
            const compressedBase64 = await this.compressImageToBase64(this.threeCourseTranscriptFile, 1280, 1280, 0.75);
            const compressedBlob = this.base64ToBlob(compressedBase64, 'image/jpeg');
            fileToUpload = new File([compressedBlob], this.threeCourseTranscriptFile.name || 'image.jpg', { type: 'image/jpeg' });
            mimetype = 'image/jpeg';
        }
        // Dosyayı multipart olarak ekle (backend'de sıkıştırma yapılacak ve base64'e çevrilecek)
        formData.append('konu_1007_transkript', fileToUpload);
        formData.append('konu_1007_transkript_mimetype', mimetype);
    }

    async downloadHandbook() {
        try {
            this.showLoading();
            
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/download-handbook`);
            
            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ogrenci_el_kitabi_student_handbook.pdf';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                const data = await response.json();
                this.showError('Hata', 'El kitabı indirilemedi. Lütfen tekrar deneyiniz.');
            }
        } catch (error) {
            console.error('El kitabı indirme hatası:', error);
            this.showError('Hata', 'El kitabı indirilirken bir hata oluştu.');
        } finally {
            this.hideLoading();
        }
    }

    // Yatay Geçiş Fonksiyonları
    handleHorizontalTransferSection(show) {
        const section = document.getElementById('horizontalTransferSection');
        if (!section) return;
        
        if (show) {
            section.classList.remove('d-none');
            // Fakülteleri yükle
            this.loadFaculties();
        } else {
            section.classList.add('d-none');
            // Form alanlarını sıfırla
            this.resetHorizontalTransferSection();
        }
    }

    resetHorizontalTransferSection() {
        // Dosyaları sıfırla
        this.horizontalTransferFiles = {
            ogrenciBelgesi: null,
            dersIcerikBilgisi: null,
            transkript: null
        };
        
        // Dosya input'larını sıfırla
        ['ogrenciBelgesi', 'dersIcerikBilgisi', 'transkript'].forEach(fileId => {
            const input = document.getElementById(fileId);
            const info = document.getElementById(`${fileId}Info`);
            const uploadArea = document.getElementById(`${fileId}UploadArea`);
            
            if (input) input.value = '';
            if (info) info.classList.add('d-none');
            if (uploadArea) uploadArea.style.display = 'block';
        });
        
        // Fakülte ve program dropdown'larını sıfırla
        const facultySelect = document.getElementById('horizontalTransferFaculty');
        const programSelect = document.getElementById('horizontalTransferProgram');
        
        if (facultySelect) {
            facultySelect.value = '';
            facultySelect.innerHTML = '<option value="">Fakülte seçiniz...</option>';
        }
        if (programSelect) {
            programSelect.value = '';
            programSelect.innerHTML = '<option value="">Önce fakülte seçiniz...</option>';
            programSelect.disabled = true;
        }
        
        // Switch'leri sıfırla
        document.querySelectorAll('input[name="transferType"]').forEach(switchInput => {
            switchInput.checked = false;
        });
    }

    setupHorizontalTransferEvents() {
        // Öğrenci Belgesi
        this.setupFileUploadForHorizontalTransfer('ogrenciBelgesi', 'ogrenciBelgesi');
        // Alınan Ders İçerik Bilgisi
        this.setupFileUploadForHorizontalTransfer('dersIcerikBilgisi', 'dersIcerikBilgisi');
        // Transkript
        this.setupFileUploadForHorizontalTransfer('transkript', 'transkript');
        
        // Fakülte değiştiğinde programları yükle
        const facultySelect = document.getElementById('horizontalTransferFaculty');
        if (facultySelect) {
            facultySelect.addEventListener('change', (e) => {
                const facultyId = e.target.value;
                if (facultyId) {
                    this.loadPrograms(facultyId);
                } else {
                    const programSelect = document.getElementById('horizontalTransferProgram');
                    if (programSelect) {
                        programSelect.innerHTML = '<option value="">Önce fakülte seçiniz...</option>';
                        programSelect.disabled = true;
                    }
                }
            });
        }
        
        // Switch'ler için seçim event'leri - hata durumunu temizle
        document.querySelectorAll('input[name="transferType"]').forEach(switchInput => {
            switchInput.addEventListener('change', () => {
                const errorEl = document.getElementById('transferTypeError');
                if (errorEl) {
                    errorEl.textContent = '';
                    errorEl.classList.remove('d-block');
                    errorEl.classList.add('d-none');
                }
                const segmentedControl = document.querySelector('.transfer-type-segmented-control');
                if (segmentedControl) {
                    segmentedControl.classList.remove('is-invalid');
                }
            });
        });
    }

    setupFileUploadForHorizontalTransfer(fileInputId, fileKey) {
        const fileInput = document.getElementById(fileInputId);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const removeBtn = document.getElementById(`remove${fileInputId.charAt(0).toUpperCase() + fileInputId.slice(1)}Btn`);

        if (!fileInput || !fileUploadArea) return;

        // Click event
        fileUploadArea.addEventListener('click', () => {
            fileInput.click();
        });

        // File change event
        fileInput.addEventListener('change', (e) => {
            this.handleHorizontalTransferFileSelect(e.target.files[0], fileKey, fileInputId);
        });

        // Drag and drop events
        fileUploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            fileUploadArea.classList.add('dragover');
        });

        fileUploadArea.addEventListener('dragleave', () => {
            fileUploadArea.classList.remove('dragover');
        });

        fileUploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            fileUploadArea.classList.remove('dragover');
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleHorizontalTransferFileSelect(files[0], fileKey, fileInputId);
            }
        });

        // Remove button
        if (removeBtn) {
            removeBtn.addEventListener('click', () => {
                this.removeHorizontalTransferFile(fileKey, fileInputId);
            });
        }
    }

    handleHorizontalTransferFileSelect(file, fileKey, fileInputId) {
        if (!file) return;

        // Dosya tipi kontrolü
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            this.showFieldError(`${fileInputId}Error`, 'Sadece PDF, JPG, JPEG ve PNG dosyaları yüklenebilir.');
            return;
        }

        // Dosya boyutu kontrolü (10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            this.showFieldError(`${fileInputId}Error`, 'Dosya boyutu maksimum 10MB olmalıdır.');
            return;
        }

        // Dosyayı kaydet
        this.horizontalTransferFiles[fileKey] = file;

        // UI güncelle
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileName = document.getElementById(`${fileInputId}FileName`);
        const fileSize = document.getElementById(`${fileInputId}FileSize`);

        if (fileInfo) {
            fileInfo.classList.remove('d-none');
            fileUploadArea.style.display = 'none';
        }
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);

        this.clearFieldError(`${fileInputId}Error`);
    }

    removeHorizontalTransferFile(fileKey, fileInputId) {
        this.horizontalTransferFiles[fileKey] = null;

        const fileInput = document.getElementById(fileInputId);
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);

        if (fileInput) fileInput.value = '';
        if (fileInfo) fileInfo.classList.add('d-none');
        if (fileUploadArea) fileUploadArea.style.display = 'block';
    }

    // Sınav İtiraz Fonksiyonları
    handleExamAppealSection(show) {
        const section = document.getElementById('examAppealSection');
        if (!section) return;
        
        if (show) {
            section.classList.remove('d-none');
            // Dosya yükleme event'lerini ayarla
            this.setupExamAppealFileUpload();
        } else {
            section.classList.add('d-none');
            // Form alanlarını sıfırla
            this.resetExamAppealSection();
        }
    }

    resetExamAppealSection() {
        // Dosyayı sıfırla
        this.examAppealFile = null;
        
        // Dosya input'unu sıfırla
        const input = document.getElementById('examAppealDocument');
        const info = document.getElementById('examAppealDocumentInfo');
        const uploadArea = document.getElementById('examAppealDocumentUploadArea');
        
        if (input) input.value = '';
        if (info) info.classList.add('d-none');
        if (uploadArea) uploadArea.style.display = 'block';
    }

    setupExamAppealFileUpload() {
        // Event listener'lar zaten eklenmişse tekrar ekleme
        if (this.examAppealFileUploadSetup) return;
        
        const fileInputId = 'examAppealDocument';
        const fileInput = document.getElementById(fileInputId);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const removeBtn = document.getElementById(`remove${fileInputId.charAt(0).toUpperCase() + fileInputId.slice(1)}Btn`);

        if (!fileInput || !fileUploadArea) return;
        
        this.examAppealFileUploadSetup = true;

        // Click event
        fileUploadArea.addEventListener('click', () => {
            fileInput.click();
        });

        // File change event
        fileInput.addEventListener('change', (e) => {
            this.handleExamAppealFileSelect(e.target.files[0]);
        });

        // Drag and drop events
        fileUploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            fileUploadArea.classList.add('dragover');
        });

        fileUploadArea.addEventListener('dragleave', () => {
            fileUploadArea.classList.remove('dragover');
        });

        fileUploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            fileUploadArea.classList.remove('dragover');
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleExamAppealFileSelect(files[0]);
            }
        });

        // Remove button
        if (removeBtn) {
            removeBtn.addEventListener('click', () => {
                this.removeExamAppealFile();
            });
        }
    }

    handleExamAppealFileSelect(file) {
        if (!file) return;

        // Dosya tipi kontrolü
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            this.showFieldError('examAppealDocumentError', 'Sadece PDF, JPG, JPEG ve PNG dosyaları yüklenebilir.');
            return;
        }

        // Dosya boyutu kontrolü (10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            this.showFieldError('examAppealDocumentError', 'Dosya boyutu maksimum 10MB olmalıdır.');
            return;
        }

        // Dosyayı kaydet
        this.examAppealFile = file;

        // UI güncelle
        const fileInfo = document.getElementById('examAppealDocumentInfo');
        const fileUploadArea = document.getElementById('examAppealDocumentUploadArea');
        const fileName = document.getElementById('examAppealDocumentFileName');
        const fileSize = document.getElementById('examAppealDocumentFileSize');

        if (fileInfo) {
            fileInfo.classList.remove('d-none');
            fileUploadArea.style.display = 'none';
        }
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);

        this.clearFieldError('examAppealDocumentError');
    }

    removeExamAppealFile() {
        this.examAppealFile = null;

        const fileInput = document.getElementById('examAppealDocument');
        const fileInfo = document.getElementById('examAppealDocumentInfo');
        const fileUploadArea = document.getElementById('examAppealDocumentUploadArea');

        if (fileInput) fileInput.value = '';
        if (fileInfo) fileInfo.classList.add('d-none');
        if (fileUploadArea) fileUploadArea.style.display = 'block';
    }

    async loadFaculties() {
        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/faculties`);
            const data = await response.json();
            
            if (data.success && data.data) {
                const facultySelect = document.getElementById('horizontalTransferFaculty');
                if (facultySelect) {
                    // Mevcut seçili değeri koru
                    const currentValue = facultySelect.value;
                    facultySelect.innerHTML = '<option value="">Fakülte seçiniz...</option>';
                    
                    data.data.forEach(faculty => {
                        const option = document.createElement('option');
                        option.value = faculty.id;
                        option.textContent = faculty.name;
                        facultySelect.appendChild(option);
                    });
                    
                    // Önceki değeri geri yükle
                    if (currentValue) {
                        facultySelect.value = currentValue;
                    }
                }
            }
        } catch (error) {
            console.error('Fakülteler yüklenirken hata:', error);
        }
    }

    async loadPrograms(facultyId) {
        try {
            const programSelect = document.getElementById('horizontalTransferProgram');
            if (!programSelect) return;

            programSelect.disabled = true;
            programSelect.innerHTML = '<option value="">Yükleniyor...</option>';

            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/programs/${encodeURIComponent(facultyId)}`);
            const data = await response.json();
            
            if (data.success && data.data) {
                programSelect.innerHTML = '<option value="">Program seçiniz...</option>';
                
                data.data.forEach(program => {
                    const option = document.createElement('option');
                    option.value = program.id;
                    option.textContent = program.name;
                    programSelect.appendChild(option);
                });
                
                programSelect.disabled = false;
            } else {
                programSelect.innerHTML = '<option value="">Program yüklenemedi</option>';
            }
        } catch (error) {
            console.error('Programlar yüklenirken hata:', error);
            const programSelect = document.getElementById('horizontalTransferProgram');
            if (programSelect) {
                programSelect.innerHTML = '<option value="">Program yüklenemedi</option>';
            }
        }
    }

    validateHorizontalTransferForm() {
        const topicId = document.getElementById('ticketTopic').value;
        if (parseInt(topicId, 10) !== 8001) {
            return true; // Yatay geçiş değilse validasyon yapma
        }

        // Dosya kontrolleri
        if (!this.horizontalTransferFiles.ogrenciBelgesi) {
            this.showFieldError('ogrenciBelgesiError', 'Öğrenci belgesi zorunludur.');
            return false;
        }
        if (!this.horizontalTransferFiles.dersIcerikBilgisi) {
            this.showFieldError('dersIcerikBilgisiError', 'Alınan ders içerik bilgisi zorunludur.');
            return false;
        }
        if (!this.horizontalTransferFiles.transkript) {
            this.showFieldError('transkriptError', 'Transkript belgesi zorunludur.');
            return false;
        }

        // Fakülte ve program kontrolleri
        const facultyId = document.getElementById('horizontalTransferFaculty')?.value;
        const programId = document.getElementById('horizontalTransferProgram')?.value;
        
        if (!facultyId) {
            this.showFieldError('horizontalTransferFacultyError', 'Fakülte seçimi zorunludur.');
            return false;
        }
        if (!programId) {
            this.showFieldError('horizontalTransferProgramError', 'Program seçimi zorunludur.');
            return false;
        }

        // Geçiş türü kontrolü (radio button - sadece bir seçim)
        const transferType = document.querySelector('input[name="transferType"]:checked');
        if (!transferType) {
            const errorEl = document.getElementById('transferTypeError');
            if (errorEl) {
                errorEl.textContent = 'Lütfen bir geçiş türü seçiniz.';
                errorEl.classList.add('d-block');
                errorEl.classList.remove('d-none');
            }
            // Segmented control'u invalid yap
            const segmentedControl = document.querySelector('.transfer-type-segmented-control');
            if (segmentedControl) {
                segmentedControl.classList.add('is-invalid');
            }
            return false;
        }
        
        // Hata yoksa temizle
        const errorEl = document.getElementById('transferTypeError');
        if (errorEl) {
            errorEl.textContent = '';
            errorEl.classList.remove('d-block');
            errorEl.classList.add('d-none');
        }
        const segmentedControl = document.querySelector('.transfer-type-segmented-control');
        if (segmentedControl) {
            segmentedControl.classList.remove('is-invalid');
        }

        return true;
    }

    // Other Kullanıcı Tipi için Yatay Geçiş Fonksiyonları
    handleNonStudentHorizontalTransferSection(show) {
        const section = document.getElementById('nonStudentHorizontalTransferSection');
        if (!section) return;
        
        if (show) {
            section.classList.remove('d-none');
            // Fakülteleri yükle (Other kullanıcı için)
            this.loadNonStudentFaculties();
        } else {
            section.classList.add('d-none');
            // Form alanlarını sıfırla
            this.resetNonStudentHorizontalTransferSection();
        }
    }

    resetNonStudentHorizontalTransferSection() {
        // Dosyaları sıfırla
        this.nonStudentHorizontalTransferFiles = {
            ogrenciBelgesi: null,
            dersIcerikBilgisi: null,
            transkript: null
        };
        
        // Dosya input'larını sıfırla
        ['nonStudentOgrenciBelgesi', 'nonStudentDersIcerikBilgisi', 'nonStudentTranskript'].forEach(fileId => {
            const input = document.getElementById(fileId);
            const info = document.getElementById(`${fileId}Info`);
            const uploadArea = document.getElementById(`${fileId}UploadArea`);
            
            if (input) input.value = '';
            if (info) info.classList.add('d-none');
            if (uploadArea) uploadArea.style.display = 'block';
        });
        
        // Fakülte ve program dropdown'larını sıfırla
        const facultySelect = document.getElementById('nonStudentHorizontalTransferFaculty');
        const programSelect = document.getElementById('nonStudentHorizontalTransferProgram');
        
        if (facultySelect) {
            facultySelect.value = '';
            facultySelect.innerHTML = '<option value="">Fakülte seçiniz...</option>';
        }
        if (programSelect) {
            programSelect.value = '';
            programSelect.innerHTML = '<option value="">Önce fakülte seçiniz...</option>';
            programSelect.disabled = true;
        }
        
        // Switch'leri sıfırla
        document.querySelectorAll('input[name="nonStudentTransferType"]').forEach(switchInput => {
            switchInput.checked = false;
        });
    }

    setupNonStudentHorizontalTransferEvents() {
        // Öğrenci Belgesi
        this.setupFileUploadForNonStudentHorizontalTransfer('nonStudentOgrenciBelgesi', 'ogrenciBelgesi');
        // Alınan Ders İçerik Bilgisi
        this.setupFileUploadForNonStudentHorizontalTransfer('nonStudentDersIcerikBilgisi', 'dersIcerikBilgisi');
        // Transkript
        this.setupFileUploadForNonStudentHorizontalTransfer('nonStudentTranskript', 'transkript');
        
        // Fakülte değiştiğinde programları yükle
        const facultySelect = document.getElementById('nonStudentHorizontalTransferFaculty');
        if (facultySelect) {
            facultySelect.addEventListener('change', (e) => {
                const facultyId = e.target.value;
                if (facultyId) {
                    this.loadNonStudentPrograms(facultyId);
                } else {
                    const programSelect = document.getElementById('nonStudentHorizontalTransferProgram');
                    if (programSelect) {
                        programSelect.innerHTML = '<option value="">Önce fakülte seçiniz...</option>';
                        programSelect.disabled = true;
                    }
                }
            });
        }
        
        // Switch'ler için seçim event'leri - hata durumunu temizle
        document.querySelectorAll('input[name="nonStudentTransferType"]').forEach(switchInput => {
            switchInput.addEventListener('change', () => {
                const errorEl = document.getElementById('nonStudentTransferTypeError');
                if (errorEl) {
                    errorEl.textContent = '';
                    errorEl.classList.remove('d-block');
                    errorEl.classList.add('d-none');
                }
                const segmentedControl = document.querySelector('#nonStudentHorizontalTransferSection .transfer-type-segmented-control');
                if (segmentedControl) {
                    segmentedControl.classList.remove('is-invalid');
                }
            });
        });
    }

    setupFileUploadForNonStudentHorizontalTransfer(fileInputId, fileKey) {
        const fileInput = document.getElementById(fileInputId);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const removeBtn = document.getElementById(`remove${fileInputId.charAt(0).toUpperCase() + fileInputId.slice(1)}Btn`);

        if (!fileInput || !fileUploadArea) return;

        // Click event
        fileUploadArea.addEventListener('click', () => {
            fileInput.click();
        });

        // File change event
        fileInput.addEventListener('change', (e) => {
            this.handleNonStudentHorizontalTransferFileSelect(e.target.files[0], fileKey, fileInputId);
        });

        // Drag and drop events
        fileUploadArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            fileUploadArea.classList.add('dragover');
        });

        fileUploadArea.addEventListener('dragleave', () => {
            fileUploadArea.classList.remove('dragover');
        });

        fileUploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            fileUploadArea.classList.remove('dragover');
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleNonStudentHorizontalTransferFileSelect(files[0], fileKey, fileInputId);
            }
        });

        // Remove button
        if (removeBtn) {
            removeBtn.addEventListener('click', () => {
                this.removeNonStudentHorizontalTransferFile(fileKey, fileInputId);
            });
        }
    }

    handleNonStudentHorizontalTransferFileSelect(file, fileKey, fileInputId) {
        if (!file) return;

        // Dosya tipi kontrolü
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            this.showFieldError(`${fileInputId}Error`, 'Sadece PDF, JPG, JPEG ve PNG dosyaları yüklenebilir.');
            return;
        }

        // Dosya boyutu kontrolü (10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            this.showFieldError(`${fileInputId}Error`, 'Dosya boyutu maksimum 10MB olmalıdır.');
            return;
        }

        // Dosyayı kaydet
        this.nonStudentHorizontalTransferFiles[fileKey] = file;

        // UI güncelle
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);
        const fileName = document.getElementById(`${fileInputId}FileName`);
        const fileSize = document.getElementById(`${fileInputId}FileSize`);

        if (fileInfo) {
            fileInfo.classList.remove('d-none');
            fileUploadArea.style.display = 'none';
        }
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);

        this.clearFieldError(`${fileInputId}Error`);
    }

    removeNonStudentHorizontalTransferFile(fileKey, fileInputId) {
        this.nonStudentHorizontalTransferFiles[fileKey] = null;

        const fileInput = document.getElementById(fileInputId);
        const fileInfo = document.getElementById(`${fileInputId}Info`);
        const fileUploadArea = document.getElementById(`${fileInputId}UploadArea`);

        if (fileInput) fileInput.value = '';
        if (fileInfo) fileInfo.classList.add('d-none');
        if (fileUploadArea) fileUploadArea.style.display = 'block';
    }

    async loadNonStudentFaculties() {
        try {
            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/faculties`);
            const data = await response.json();
            
            if (data.success && data.data) {
                const facultySelect = document.getElementById('nonStudentHorizontalTransferFaculty');
                if (facultySelect) {
                    const currentValue = facultySelect.value;
                    facultySelect.innerHTML = '<option value="">Fakülte seçiniz...</option>';
                    
                    data.data.forEach(faculty => {
                        const option = document.createElement('option');
                        option.value = faculty.id;
                        option.textContent = faculty.name;
                        facultySelect.appendChild(option);
                    });
                    
                    if (currentValue) {
                        facultySelect.value = currentValue;
                    }
                }
            }
        } catch (error) {
            console.error('Fakülteler yüklenirken hata:', error);
        }
    }

    async loadNonStudentPrograms(facultyId) {
        try {
            const programSelect = document.getElementById('nonStudentHorizontalTransferProgram');
            if (!programSelect) return;

            programSelect.disabled = true;
            programSelect.innerHTML = '<option value="">Yükleniyor...</option>';

            const response = await this.fetchWithAuth(`${this.apiBaseUrl}/programs/${encodeURIComponent(facultyId)}`);
            const data = await response.json();
            
            if (data.success && data.data) {
                programSelect.innerHTML = '<option value="">Program seçiniz...</option>';
                
                data.data.forEach(program => {
                    const option = document.createElement('option');
                    option.value = program.id;
                    option.textContent = program.name;
                    programSelect.appendChild(option);
                });
                
                programSelect.disabled = false;
            } else {
                programSelect.innerHTML = '<option value="">Program yüklenemedi</option>';
            }
        } catch (error) {
            console.error('Programlar yüklenirken hata:', error);
            const programSelect = document.getElementById('nonStudentHorizontalTransferProgram');
            if (programSelect) {
                programSelect.innerHTML = '<option value="">Program yüklenemedi</option>';
            }
        }
    }

    // Other Kullanıcı Tipi için Yatay Geçiş Validasyonu
    validateNonStudentHorizontalTransferForm() {
        const topicId = document.getElementById('nonStudentTicketTopic')?.value;
        // Other kullanıcı için 1003 kalıyor
        if (!topicId || parseInt(topicId, 10) !== 1003) {
            return true; // Yatay geçiş değilse validasyon yapma
        }

        // Dosya kontrolleri
        if (!this.nonStudentHorizontalTransferFiles.ogrenciBelgesi) {
            this.showFieldError('nonStudentOgrenciBelgesiError', 'Öğrenci belgesi zorunludur.');
            return false;
        }
        if (!this.nonStudentHorizontalTransferFiles.dersIcerikBilgisi) {
            this.showFieldError('nonStudentDersIcerikBilgisiError', 'Alınan ders içerik bilgisi zorunludur.');
            return false;
        }
        if (!this.nonStudentHorizontalTransferFiles.transkript) {
            this.showFieldError('nonStudentTranskriptError', 'Transkript belgesi zorunludur.');
            return false;
        }

        // Fakülte ve program kontrolleri
        const facultyId = document.getElementById('nonStudentHorizontalTransferFaculty')?.value;
        const programId = document.getElementById('nonStudentHorizontalTransferProgram')?.value;
        
        if (!facultyId) {
            this.showFieldError('nonStudentHorizontalTransferFacultyError', 'Fakülte seçimi zorunludur.');
            return false;
        }
        if (!programId) {
            this.showFieldError('nonStudentHorizontalTransferProgramError', 'Program seçimi zorunludur.');
            return false;
        }

        // Geçiş türü kontrolü (radio button - sadece bir seçim)
        const transferType = document.querySelector('input[name="nonStudentTransferType"]:checked');
        if (!transferType) {
            const errorEl = document.getElementById('nonStudentTransferTypeError');
            if (errorEl) {
                errorEl.textContent = 'Lütfen bir geçiş türü seçiniz.';
                errorEl.classList.add('d-block');
                errorEl.classList.remove('d-none');
            }
            // Segmented control'u invalid yap
            const segmentedControl = document.querySelector('#nonStudentHorizontalTransferSection .transfer-type-segmented-control');
            if (segmentedControl) {
                segmentedControl.classList.add('is-invalid');
            }
            return false;
        }
        
        // Hata yoksa temizle
        const errorEl = document.getElementById('nonStudentTransferTypeError');
        if (errorEl) {
            errorEl.textContent = '';
            errorEl.classList.remove('d-block');
            errorEl.classList.add('d-none');
        }
        const segmentedControl = document.querySelector('#nonStudentHorizontalTransferSection .transfer-type-segmented-control');
        if (segmentedControl) {
            segmentedControl.classList.remove('is-invalid');
        }

        return true;
    }
}

// ============================================
// SECTION 6: GLOBAL FUNCTIONS
// ============================================
// HTML onclick event handlers ve global utility fonksiyonlar
function showRequestResults() {
    const modalElement = document.getElementById('requestResultsModal');
    const modal = new bootstrap.Modal(modalElement);
    
    // Modal kapanış olayını dinle
    modalElement.addEventListener('hidden.bs.modal', () => {
        // Modal kapandığında backdrop'u temizle
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
            backdrop.remove();
        }
        // Body'den modal class'larını kaldır
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Talep sonuçları verilerini sıfırla
        clearRequestResultsData();
    }, { once: true });
    
    modal.show();
}

// Talep sonuçları verilerini temizle
function clearRequestResultsData() {
    // Öğrenci numarası input'unu temizle
    const studentInput = document.getElementById('searchOgrenciNo');
    if (studentInput) {
        studentInput.value = '';
    }
    
    // Talep sonuçları listesini temizle
    const resultsContainer = document.getElementById('requestResults');
    if (resultsContainer) {
        resultsContainer.innerHTML = '';
    }
    
    // Arama durumu mesajını temizle
    const searchStatus = document.getElementById('searchStatus');
    if (searchStatus) {
        searchStatus.textContent = '';
        searchStatus.className = '';
    }
    
    // Hata mesajlarını temizle
    const searchError = document.getElementById('searchError');
    if (searchError) {
        searchError.textContent = '';
        searchError.className = '';
    }
}

function searchRequests() {
    if (window.helpFormApp) {
        window.helpFormApp.searchRequests();
    }
}

function downloadHandbook() {
    if (window.helpFormApp) {
        window.helpFormApp.downloadHandbook();
    }
}

function removeFile() {
    if (window.helpFormApp) {
        window.helpFormApp.removeFile();
    }
}

// Performance: Optimized initialization with requestIdleCallback
function initAppWhenReady() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAppWhenReady);
        return;
    }
    
    // Initialize language manager first
    languageManager = new LanguageManager();
    
    // Then initialize the app
    window.helpFormApp = new HelpFormApp();
    initCharCounters();
    
    // Use requestIdleCallback for non-critical initialization
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
            lazyLoadImages();
        }, { timeout: 2000 });
    } else {
        setTimeout(lazyLoadImages, 100);
    }
}

// Initialize app when DOM is loaded
initAppWhenReady();

// ============================================
// PHOTO GALLERY SLIDER
// ============================================
class PhotoGallerySlider {
    constructor() {
        this.modal = null;
        this.modalElement = null;
        this.carousel = null;
        this.carouselInner = null;
        this.indicatorsContainer = null;
        this.currentIndex = 0;
        this.photos = [];
        this.config = {
            enabled: true,
            showOnLoad: true,
            autoClose: false,
            autoCloseDelay: 0
        };
        this.init();
    }

    async init() {
        // Load configuration
        await this.loadConfig();
        
        // Initialize overlay (Bootstrap Modal kullanmıyoruz)
        this.modalElement = document.getElementById('photoGalleryModal');
        if (!this.modalElement) {
            console.warn('Photo gallery modal not found');
            return;
        }

        // Bootstrap Modal kullanmıyoruz - direkt overlay kullanıyoruz
        this.modal = null;

        this.carouselInner = document.getElementById('photoGalleryCarouselInner');
        this.indicatorsContainer = document.getElementById('photoGalleryIndicators');
        
        // Setup event listeners
        this.setupEventListeners();
        
        // Load photos
        await this.loadPhotos();
        
        // Show on load if enabled
        if (this.config.enabled && this.config.showOnLoad && this.photos.length > 0) {
            // Wait for page to be fully loaded
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    setTimeout(() => this.show(), 500);
                });
            } else {
                setTimeout(() => this.show(), 500);
            }
        }
    }

    async loadConfig() {
        try {
            const response = await fetch('/ticket/api/gallery-config');
            if (response.ok) {
                const data = await response.json();
                this.config = { ...this.config, ...data };
                this.photos = data.photos || [];
            } else {
                // Fallback to default config
                this.loadDefaultConfig();
            }
        } catch (error) {
            console.warn('Could not load gallery config, using defaults:', error);
            this.loadDefaultConfig();
        }
    }

    loadDefaultConfig() {
        // Try to load from static file
        fetch('/static/gallery_config.json')
            .then(response => response.json())
            .then(data => {
                this.config = { ...this.config, ...data };
                this.photos = data.photos || [];
                if (this.config.enabled && this.config.showOnLoad && this.photos.length > 0) {
                    setTimeout(() => this.show(), 500);
                }
            })
            .catch(() => {
                // If no config file, use empty photos array
                this.photos = [];
            });
    }

    async loadPhotos() {
        // Photos are already loaded from config
        if (this.photos.length === 0) {
            this.showEmptyState();
            return;
        }

        this.renderPhotos();
    }

    renderPhotos() {
        if (!this.carouselInner) {
            return;
        }

        // Clear existing content
        this.carouselInner.innerHTML = '';

        // Fotoğrafları ID'ye göre sırala (küçük ID önce)
        const sortedPhotos = [...this.photos].sort((a, b) => (a.id || 0) - (b.id || 0));
        
        // En küçük ID'li fotoğrafı bul (ortada gözükecek)
        const minId = Math.min(...sortedPhotos.map(p => p.id || 0));
        const minIdIndex = sortedPhotos.findIndex(p => (p.id || 0) === minId);

        // Render carousel items
        sortedPhotos.forEach((photo, index) => {
            // En küçük ID'li fotoğraf aktif olacak
            const isActive = index === minIdIndex ? 'active' : '';
            const carouselItem = document.createElement('div');
            carouselItem.className = `carousel-item ${isActive}`;
            carouselItem.setAttribute('data-index', index);
            
            const img = document.createElement('img');
            img.src = photo.url;
            img.alt = photo.alt || photo.title || `Fotoğraf ${index + 1}`;
            img.className = 'img-fluid';
            img.loading = 'lazy';
            
            // Fotoğrafı tam ortala
            img.style.position = 'absolute';
            img.style.top = '50%';
            img.style.left = '50%';
            img.style.transform = 'translate(-50%, -50%)';
            img.style.margin = '0';
            img.style.maxWidth = '90vw';
            img.style.maxHeight = '90vh';
            img.style.width = 'auto';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
            
            // Handle image load error
            img.onerror = () => {
                img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23ddd" width="400" height="300"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="18" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3EFotoğraf Yüklenemedi%3C/text%3E%3C/svg%3E';
            };
            
            carouselItem.appendChild(img);
            this.carouselInner.appendChild(carouselItem);
        });
        
        // Initialize carousel - otomatik geçiş tamamen kapalı
        const carouselElement = document.getElementById('photoGalleryCarousel');
        if (carouselElement) {
            // Önce mevcut carousel instance'ını temizle
            const existingCarousel = bootstrap.Carousel.getInstance(carouselElement);
            if (existingCarousel) {
                existingCarousel.dispose();
            }
            
            // HTML'deki data attribute'ları kaldır (otomatik başlamayı engellemek için)
            carouselElement.removeAttribute('data-bs-ride');
            carouselElement.setAttribute('data-bs-interval', 'false');
            
            // Yeni carousel instance oluştur - otomatik geçiş kapalı
            this.carousel = new bootstrap.Carousel(carouselElement, {
                interval: false,
                ride: false,
                wrap: true
            });
            
            // Otomatik geçişi tamamen devre dışı bırak
            if (this.carousel) {
                this.carousel.pause();
                if (this.carousel._config) {
                    this.carousel._config.interval = false;
                }
                // Interval'ı sıfırla
                if (this.carousel._interval) {
                    clearInterval(this.carousel._interval);
                    this.carousel._interval = null;
                }
            }
            
            // Listen to slide events
            carouselElement.addEventListener('slid.bs.carousel', (e) => {
                const activeIndex = Array.from(this.carouselInner.children).indexOf(e.relatedTarget);
                this.currentIndex = activeIndex;
                // Her slide sonrası pause yap
                if (this.carousel) {
                    this.carousel.pause();
                }
                // Fotoğrafları tekrar ortala
                this.centerImages();
            });
        }
    }

    showEmptyState() {
        if (!this.carouselInner) return;
        
        this.carouselInner.innerHTML = `
            <div class="photo-gallery-empty">
                <i class="fas fa-images"></i>
                <p>Henüz fotoğraf eklenmemiş</p>
            </div>
        `;
    }

    goToPhoto(index) {
        if (index < 0 || index >= this.photos.length) return;
        
        if (this.carousel) {
            this.carousel.to(index);
        }
    }

    updateCounter() {
        const currentIndexEl = document.getElementById('currentPhotoIndex');
        const totalPhotosEl = document.getElementById('totalPhotos');
        
        if (currentIndexEl) {
            currentIndexEl.textContent = this.currentIndex + 1;
        }
        if (totalPhotosEl) {
            totalPhotosEl.textContent = this.photos.length;
        }
    }

    updateThumbnails() {
        const thumbnails = this.indicatorsContainer.querySelectorAll('.photo-thumbnail');
        thumbnails.forEach((thumb, index) => {
            if (index === this.currentIndex) {
                thumb.classList.add('active');
            } else {
                thumb.classList.remove('active');
            }
        });
    }

    setupEventListeners() {
        if (!this.modalElement) return;

        // Close button (şeffaf X butonu)
        const closeBtn = document.getElementById('closeGalleryBtn');
        
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.hide());
        }

        // Backdrop'a tıklanınca kapatma (opsiyonel - şimdilik kapalı)
        const backdrop = this.modalElement.querySelector('.photo-gallery-backdrop');
        if (backdrop) {
            backdrop.addEventListener('click', (e) => {
                // Sadece backdrop'a tıklanırsa kapat (içerik alanına değil)
                if (e.target === backdrop) {
                    this.hide();
                }
            });
        }

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (!this.modalElement.classList.contains('show')) return;
            
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                this.previous();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                this.next();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                this.hide();
            }
        });
    }

    show() {
        if (!this.modalElement || this.photos.length === 0) return;
        
        this.currentIndex = 0;
        
        if (this.carousel) {
            this.carousel.to(0);
        }
        
        // Custom overlay göster - Bootstrap Modal kullanmıyoruz
        // Overlay'i tam ekran ve ortada yap
        this.modalElement.style.position = 'fixed';
        this.modalElement.style.top = '0';
        this.modalElement.style.left = '0';
        this.modalElement.style.right = '0';
        this.modalElement.style.bottom = '0';
        this.modalElement.style.width = '100vw';
        this.modalElement.style.height = '100vh';
        this.modalElement.style.margin = '0';
        this.modalElement.style.padding = '0';
        this.modalElement.style.display = 'flex';
        this.modalElement.style.alignItems = 'center';
        this.modalElement.style.justifyContent = 'center';
        this.modalElement.classList.add('show');
        
        // Body scroll'u engelle
        document.body.style.overflow = 'hidden';
        
        // Fotoğrafları ortala
        setTimeout(() => {
            this.centerImages();
        }, 50);
        
        // Auto close if enabled
        if (this.config.autoClose && this.config.autoCloseDelay > 0) {
            setTimeout(() => this.hide(), this.config.autoCloseDelay);
        }
    }
    
    centerImages() {
        // Tüm fotoğrafları tam ortala
        const images = this.modalElement?.querySelectorAll('.carousel-item img');
        if (images) {
            images.forEach(img => {
                img.style.position = 'absolute';
                img.style.top = '50%';
                img.style.left = '50%';
                img.style.transform = 'translate(-50%, -50%)';
                img.style.margin = '0';
                img.style.maxWidth = '90vw';
                img.style.maxHeight = '90vh';
            });
        }
    }

    hide() {
        if (!this.modalElement) return;
        
        // Custom overlay gizle
        this.modalElement.style.display = 'none';
        this.modalElement.classList.remove('show');
        
        // Body scroll'u geri getir
        document.body.style.overflow = '';
    }

    next() {
        if (this.carousel) {
            this.carousel.next();
        }
    }

    previous() {
        if (this.carousel) {
            this.carousel.prev();
        }
    }
}

// Initialize photo gallery when page loads
let photoGallerySlider = null;
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        photoGallerySlider = new PhotoGallerySlider();
    });
} else {
    photoGallerySlider = new PhotoGallerySlider();
}

// Service Worker for offline functionality (optional - disabled)
// Service Worker kayıt edilmiyor çünkü sw.js dosyası yok
// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', function() {
//         navigator.serviceWorker.register('/static/js/sw.js')
//             .then(function(registration) {
//                 console.log('ServiceWorker registration successful');
//             })
//             .catch(function(err) {
//                 console.log('ServiceWorker registration failed');
//             });
//     });
// }

// Privacy Modal Function
function showPrivacyModal() {
    const modalElement = document.getElementById('privacyModal');
    const modal = new bootstrap.Modal(modalElement);
    
    // Modal kapanış olayını dinle
    modalElement.addEventListener('hidden.bs.modal', () => {
        // Modal kapandığında backdrop'u temizle
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
            backdrop.remove();
        }
        // Body'den modal class'larını kaldır
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }, { once: true });
    
    const confirmButton = modalElement.querySelector('[data-auto-consent="true"]');
    const consentCheckbox = document.getElementById('consent');

    if (confirmButton && consentCheckbox) {
        const handler = () => {
            consentCheckbox.checked = true;
            consentCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            confirmButton.removeEventListener('click', handler);
        };
        confirmButton.addEventListener('click', handler, { once: true });
    }

    modal.show();
}

// E-posta doğrulama sistemi
let currentOgrenciNo = '';
let requestVerificationInputs = [];
let requestVerifyButton = null;
let requestVerificationStatusEl = null;
let requestVerificationEmailEl = null;
let requestVerificationInfoEl = null;

function initializeRequestVerificationUI() {
    requestVerificationInputs = Array.from(document.querySelectorAll('.request-verification-input'));
    requestVerifyButton = document.getElementById('verifyRequestCodeBtn');
    requestVerificationStatusEl = document.getElementById('requestVerificationStatus');
    requestVerificationEmailEl = document.getElementById('requestVerificationEmail');
    requestVerificationInfoEl = document.getElementById('requestVerificationInfo');

    requestVerificationInputs.forEach((input, index) => {
        input.addEventListener('input', (event) => handleRequestVerificationInput(event, index));
        input.addEventListener('keydown', (event) => handleRequestVerificationKeyDown(event, index));
        input.addEventListener('paste', handleRequestVerificationPaste);
    });

    const resendBtn = document.getElementById('resendRequestVerificationBtn');
    if (resendBtn) {
        resendBtn.addEventListener('click', async () => {
            if (!currentOgrenciNo) {
                return;
            }
            const emailField = document.getElementById('verificationEmail');
            const emailValue = emailField ? emailField.value.trim() : '';
            if (!emailValue) {
                return;
            }

            resendBtn.disabled = true;
            resendBtn.classList.add('disabled');
            try {
                await sendVerificationCodeForSearch(currentOgrenciNo, emailValue);
            } finally {
                setTimeout(() => {
                    resendBtn.disabled = false;
                    resendBtn.classList.remove('disabled');
                }, 1500);
            }
        });
    }

    clearRequestVerificationInputs();
    updateRequestVerificationButtonState();
}

document.addEventListener('DOMContentLoaded', initializeRequestVerificationUI);

function clearRequestVerificationInputs() {
    if (!requestVerificationInputs.length) {
        return;
    }
    requestVerificationInputs.forEach(input => {
        input.value = '';
        input.disabled = false;
        input.style.cursor = '';
        input.style.backgroundColor = '';
    });
    if (requestVerifyButton) {
        requestVerifyButton.disabled = true;
        requestVerifyButton.style.cursor = '';
        requestVerifyButton.style.opacity = '';
        requestVerifyButton.innerHTML = '<i class="fas fa-check me-2"></i>Doğrula (Verify)';
    }
}

function updateRequestVerificationButtonState() {
    if (!requestVerifyButton) {
        requestVerifyButton = document.getElementById('verifyRequestCodeBtn');
    }
    const isComplete = requestVerificationInputs.length > 0 && requestVerificationInputs.every(input => (input.value || '').trim().length === 1);
    if (requestVerifyButton) {
        requestVerifyButton.disabled = !isComplete;
        if (!isComplete) {
            requestVerifyButton.innerHTML = '<i class="fas fa-check me-2"></i>Doğrula (Verify)';
        }
    }
}

function getRequestVerificationCodeValue() {
    if (!requestVerificationInputs.length) {
        return '';
    }
    return requestVerificationInputs.map(input => (input.value || '').trim()).join('');
}

function fillRequestVerificationInputsFromString(chars, startIndex = 0) {
    if (!chars) {
        return;
    }
    const digits = chars.replace(/\D/g, '').split('');
    if (!digits.length) {
        return;
    }
    let currentIndex = Math.max(0, startIndex);
    digits.forEach(digit => {
        if (currentIndex >= requestVerificationInputs.length) {
            return;
        }
        requestVerificationInputs[currentIndex].value = digit;
        currentIndex += 1;
    });

    if (currentIndex >= requestVerificationInputs.length) {
        requestVerificationInputs[requestVerificationInputs.length - 1].focus();
        requestVerificationInputs[requestVerificationInputs.length - 1].select();
    } else {
        requestVerificationInputs[currentIndex].focus();
        requestVerificationInputs[currentIndex].select();
    }

    updateRequestVerificationButtonState();
}

function handleRequestVerificationInput(event, index) {
    const input = event.target;
    const value = (input.value || '').replace(/\D/g, '');
    input.value = value.slice(0, 1);

    if (value.length > 1) {
        fillRequestVerificationInputsFromString(value.slice(1), index + 1);
    } else if (value.length === 1 && index < requestVerificationInputs.length - 1) {
        requestVerificationInputs[index + 1].focus();
        requestVerificationInputs[index + 1].select();
    }

    if (requestVerificationStatusEl) {
        requestVerificationStatusEl.textContent = '';
        requestVerificationStatusEl.classList.remove('text-success', 'text-danger');
    }

    updateRequestVerificationButtonState();
}

function handleRequestVerificationKeyDown(event, index) {
    const input = event.target;
    if (event.key === 'Backspace' && !input.value && index > 0) {
        event.preventDefault();
        requestVerificationInputs[index - 1].value = '';
        requestVerificationInputs[index - 1].focus();
        requestVerificationInputs[index - 1].select();
        updateRequestVerificationButtonState();
        return;
    }

    if (event.key === 'ArrowLeft' && index > 0) {
        event.preventDefault();
        requestVerificationInputs[index - 1].focus();
        requestVerificationInputs[index - 1].select();
    } else if (event.key === 'ArrowRight' && index < requestVerificationInputs.length - 1) {
        event.preventDefault();
        requestVerificationInputs[index + 1].focus();
        requestVerificationInputs[index + 1].select();
    }
}

function handleRequestVerificationPaste(event) {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) {
        return;
    }
    const pastedData = clipboardData.getData('text');
    clearRequestVerificationInputs();
    fillRequestVerificationInputsFromString(pastedData, 0);
}

async function showEmailVerificationModal() {
    const inputEl = document.getElementById('searchOgrenciNo');
    const ogrenciNo = inputEl ? inputEl.value.replace(/\D/g, '') : '';

    if (inputEl) {
        inputEl.value = ogrenciNo;
    }
    
    if (!ogrenciNo) {
        window.helpFormApp.showError('Hata (Error)', 'Lütfen öğrenci numaranızı giriniz. (Please enter your student number.)');
        return;
    }
    
    if (ogrenciNo.length < 5) {
        window.helpFormApp.showError('Hata (Error)', 'Öğrenci numarası en az 5 haneli olmalıdır. (Student number must be at least 5 digits.)');
        return;
    }
    
    currentOgrenciNo = ogrenciNo;
    
    // Öğrenci numarasından email adresini oluştur (backend'e istek atmadan, standart format)
    try {
        // Standart format: {ogrenci_no}@std.nisantasi.edu.tr
        const email = window.helpFormApp.generateStudentEmail(ogrenciNo);
        
        if (!email) {
            window.helpFormApp.showError('Hata (Error)', 'Geçersiz öğrenci numarası. (Invalid student number.)');
            return;
        }
        
        // E-posta adresini ayarla ve göster
        const emailField = document.getElementById('verificationEmail');
        if (emailField) {
            emailField.value = email;
        }
        if (requestVerificationEmailEl) {
            requestVerificationEmailEl.textContent = email || '-';
        }
        if (requestVerificationInfoEl) {
            requestVerificationInfoEl.innerHTML = '<i class="fas fa-info-circle me-1"></i>Doğrulama kodu 10 dakika geçerlidir (Verification code is valid for 10 minutes)';
        }
        clearRequestVerificationInputs();
        if (requestVerificationStatusEl) {
            requestVerificationStatusEl.textContent = '';
            requestVerificationStatusEl.classList.remove('text-success', 'text-danger');
        }
        updateRequestVerificationButtonState();
        
        // Modal'ı göster
        const modalElement = document.getElementById('emailVerificationModal');
        const modal = new bootstrap.Modal(modalElement);
        
        // Modal kapanış olayını dinle
        modalElement.addEventListener('hidden.bs.modal', () => {
            // Modal kapandığında backdrop'u temizle
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
            // Body'den modal class'larını kaldır
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            
            clearRequestVerificationInputs();
            if (requestVerificationStatusEl) {
                requestVerificationStatusEl.textContent = '';
                requestVerificationStatusEl.classList.remove('text-success', 'text-danger');
            }
        }, { once: true });
        
        modal.show();
        setTimeout(() => {
            if (requestVerificationInputs.length) {
                requestVerificationInputs[0].focus();
                requestVerificationInputs[0].select();
            }
        }, 200);
        
        // Otomatik olarak doğrulama kodunu gönder
        await sendVerificationCodeForSearch(ogrenciNo, email);
        
    } catch (error) {
        console.error('Öğrenci bilgisi getirme hatası:', error);
        window.helpFormApp.showError('Hata (Error)', 'Öğrenci bilgileri yüklenirken bir hata oluştu. (An error occurred while loading student information.)');
    } finally {
        window.helpFormApp.hideLoading();
    }
}

async function sendVerificationCodeForSearch(ogrenciNo, email) {
    if (!email || !ogrenciNo) {
        return;
    }
    
    try {
        const response = await window.helpFormApp.fetchWithAuth(`${window.helpFormApp.apiBaseUrl}/send-verification-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ogrenci_no: ogrenciNo,
                email: email
            })
        });
        
        const data = await response.json();
        
        if (data.success) {
            // Başarılı - kullanıcıya bilgi ver
            if (requestVerificationInfoEl) {
                requestVerificationInfoEl.innerHTML = `<i class="fas fa-check-circle text-success me-1"></i>Doğrulama kodu <strong>${email}</strong> adresine gönderildi. (Verification code sent to <strong>${email}</strong>)`;
            }
            if (requestVerificationStatusEl) {
                requestVerificationStatusEl.textContent = 'Doğrulama kodu gönderildi.';
                requestVerificationStatusEl.classList.remove('text-danger');
                requestVerificationStatusEl.classList.add('text-success');
            }
        } else {
            window.helpFormApp.showError('Hata (Error)', data.error || 'Doğrulama kodu gönderilemedi. (Verification code could not be sent.)');
        }
        
    } catch (error) {
        console.error('Doğrulama kodu gönderme hatası:', error);
        window.helpFormApp.showError('Hata (Error)', 'Doğrulama kodu gönderilirken bir hata oluştu. (An error occurred while sending the verification code.)');
    }
}

async function verifyCodeAndSearch() {
    const emailField = document.getElementById('verificationEmail');
    const email = emailField ? emailField.value.trim() : '';
    const verificationCode = getRequestVerificationCodeValue();
    
    if (!email || !verificationCode) {
        window.helpFormApp.showError('Hata (Error)', 'Lütfen tüm alanları doldurunuz. (Please fill in all fields.)');
        return;
    }
    
    if (verificationCode.length !== requestVerificationInputs.length) {
        window.helpFormApp.showError('Hata (Error)', 'Doğrulama kodu 6 haneli olmalıdır. (Verification code must be 6 digits.)');
        return;
    }
    
    try {
        window.helpFormApp.showLoading();
        if (requestVerificationStatusEl) {
            requestVerificationStatusEl.textContent = '';
            requestVerificationStatusEl.classList.remove('text-success', 'text-danger');
        }
        
        // Önce kodu doğrula
        const verifyResponse = await window.helpFormApp.fetchWithAuth(`${window.helpFormApp.apiBaseUrl}/verify-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ogrenci_no: currentOgrenciNo,
                email: email,
                verification_code: verificationCode
            })
        });
        
        const verifyData = await verifyResponse.json();
        
        if (!verifyData.success) {
            if (requestVerificationStatusEl) {
                requestVerificationStatusEl.textContent = verifyData.error || 'Doğrulama kodu geçersiz. (Invalid verification code.)';
                requestVerificationStatusEl.classList.remove('text-success');
                requestVerificationStatusEl.classList.add('text-danger');
            }
            window.helpFormApp.showError('Hata (Error)', verifyData.error || 'Doğrulama kodu geçersiz. (Invalid verification code.)');
            return;
        }
        
        // Kod doğrulandı, talep sonuçlarını getir
        const searchResponse = await window.helpFormApp.fetchWithAuth(`${window.helpFormApp.apiBaseUrl}/requests/${currentOgrenciNo}`);
        const searchData = await searchResponse.json();
        
        if (searchData.success) {
            // Doğrulama alanlarını pasif hale getir
            requestVerificationInputs.forEach(input => {
                input.disabled = true;
                input.style.cursor = 'not-allowed';
                input.style.backgroundColor = '#e9ecef';
            });
            if (requestVerifyButton) {
                requestVerifyButton.disabled = true;
                requestVerifyButton.style.cursor = 'not-allowed';
                requestVerifyButton.style.opacity = '0.6';
                requestVerifyButton.innerHTML = '<i class="fas fa-check me-2"></i>Doğrulandı (Verified)';
            }
            if (requestVerificationStatusEl) {
                requestVerificationStatusEl.textContent = 'Doğrulama başarılı. Talep sonuçları yükleniyor...';
                requestVerificationStatusEl.classList.remove('text-danger');
                requestVerificationStatusEl.classList.add('text-success');
            }
            
            // E-posta doğrulama modalını kapat
            const emailModal = bootstrap.Modal.getInstance(document.getElementById('emailVerificationModal'));
            if (emailModal) {
                emailModal.hide();
            }
            
            // Talep sonuçlarını göster
            window.helpFormApp.currentRequestStudentNo = currentOgrenciNo;
            window.helpFormApp.displayRequestResults(searchData.data);
        } else {
            window.helpFormApp.showError('Hata (Error)', searchData.error || 'Talep sonuçları getirilemedi. (Request results could not be retrieved.)');
        }
        
    } catch (error) {
        console.error('Doğrulama ve arama hatası:', error);
        window.helpFormApp.showError('Hata (Error)', 'İşlem sırasında bir hata oluştu. (An error occurred during the process.)');
    } finally {
        window.helpFormApp.hideLoading();
    }
}

// E-posta doğrulama formu submit olayı
document.addEventListener('DOMContentLoaded', function() {
    const emailVerificationForm = document.getElementById('emailVerificationForm');
    if (emailVerificationForm) {
        emailVerificationForm.addEventListener('submit', function(e) {
            e.preventDefault();
            verifyCodeAndSearch();
        });
    }
});

// E-posta validasyonu - window.helpFormApp tanımlanınca ekle
document.addEventListener('DOMContentLoaded', function() {
    if (window.helpFormApp) {
        window.helpFormApp.validateEmail = function(email) {
            const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return pattern.test(email) && email.length <= 100;
        };
    }
});

async function verifyStudentCode() {
    const app = window.helpFormApp;
    if (!app) {
        return;
    }

    const ogrenciNoInput = document.getElementById('ogrenciNo');
    const ogrenciNo = ogrenciNoInput ? ogrenciNoInput.value.replace(/\D/g, '') : '';
    const statusEl = document.getElementById('studentVerificationStatus');
    const verifyBtn = document.getElementById('studentVerifyCodeBtn');

    if (statusEl) {
        statusEl.textContent = '';
    }

    if (!ogrenciNo) {
        app.showError('Hata (Error)', 'Lütfen öğrenci numaranızı giriniz. (Please enter your student number.)');
        return;
    }

    if (!app.currentStudentData) {
        app.showError('Hata (Error)', 'Öğrenci bilgileri bulunamadı. Lütfen öğrenci numaranızı tekrar giriniz.');
        return;
    }

    const verificationCode = app.getVerificationCodeValue();
    const expectedLength = app.verificationInputs ? app.verificationInputs.length : 0;
    if (!verificationCode || verificationCode.length !== expectedLength) {
        if (statusEl) {
            statusEl.textContent = 'Lütfen tüm kutucukları doldurunuz. (Please fill in all code boxes.)';
        }
        app.updateVerificationButtonState();
        return;
    }

    const email = app.currentStudentData.profil_email;

    if (verifyBtn) {
        verifyBtn.disabled = true;
        verifyBtn.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Doğrulanıyor...';
    }

    try {
        app.showLoading();

        const response = await app.fetchWithAuth(`${app.apiBaseUrl}/verify-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ogrenci_no: ogrenciNo,
                email: email,
                verification_code: verificationCode
            })
        });

        const data = await response.json();

        if (data.success) {
            app.isVerified = true;
            // Mail doğrulaması başarılı olduktan sonra tüm öğrenci bilgilerini al
            await app.fetchStudentInfo(ogrenciNo);
            if (app.currentStudentData) {
                app.populateStudentFields(app.currentStudentData);
            }
            app.setResetPasswordAvailability(true);
            const verifiedSection = document.getElementById('verifiedStudentInfo');
            const commonFields = document.getElementById('commonFormFields');
            const studentTicketSection = document.getElementById('studentTicketSection');
            if (verifiedSection) verifiedSection.classList.remove('d-none');
            if (commonFields) commonFields.classList.remove('d-none');
            if (studentTicketSection) studentTicketSection.classList.remove('d-none');

            const emailInfoSection = document.getElementById('emailInfoSection');
            if (emailInfoSection) {
                emailInfoSection.style.display = 'none';
            }

            if (app.sendVerificationButton) {
                app.sendVerificationButton.classList.add('d-none');
                app.sendVerificationButton.disabled = true;
            }

            if (ogrenciNoInput) {
                ogrenciNoInput.disabled = true;
                ogrenciNoInput.classList.add('is-valid');
            }

            const modalElement = document.getElementById('studentVerificationModal');
            if (modalElement) {
                const modalInstance = bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
            app.clearVerificationInputs();
            app.updateVerificationButtonState();
            app.studentVerificationModalOpen = false;

            await app.handleExamSelectionPostVerification();

        } else {
            const message = data.error || 'Doğrulama kodu geçersiz. (Invalid verification code.)';
            if (statusEl) {
                statusEl.textContent = message;
            } else {
                app.showError('Hata (Error)', message);
            }
        }
    } catch (error) {
        console.error('Doğrulama kodu kontrol hatası:', error);
        const message = 'Doğrulama kodu kontrol edilirken bir hata oluştu. (An error occurred while verifying the code.)';
        if (statusEl) {
            statusEl.textContent = message;
        } else {
            app.showError('Hata (Error)', message);
        }
    } finally {
        app.hideLoading();
        if (verifyBtn) {
            verifyBtn.disabled = false;
            verifyBtn.innerHTML = '<i class="fas fa-check me-2"></i>Doğrula (Verify)';
        }
        app.updateVerificationButtonState();
    }
}
